"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from2[key], enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Action: () => Action,
  ActionType: () => ActionType,
  Address: () => Address,
  AdvertisementColumn: () => AdvertisementColumn,
  AgentToolset: () => AgentToolset,
  Airport: () => Airport,
  AndCondition: () => AndCondition,
  AndFilter: () => AndFilter,
  Area: () => Area,
  AreaScale: () => AreaScale,
  Asset: () => Asset,
  AssetSchema: () => AssetSchema,
  BarrierType: () => BarrierType,
  Battery: () => Battery,
  Billboard: () => Billboard,
  Billing: () => Billing,
  BioMassPlant: () => BioMassPlant,
  Bridge: () => Bridge,
  BridgeUsageType: () => BridgeUsageType,
  Building: () => Building,
  BuildingAndHousingData: () => BuildingAndHousingData,
  BusStop: () => BusStop,
  BusinessRule: () => BusinessRule,
  BusinessRuleRuntimeStatus: () => BusinessRuleRuntimeStatus,
  CHP: () => CHP,
  Cardinality: () => Cardinality,
  CareFacility: () => CareFacility,
  CellularCoverage: () => CellularCoverage,
  ChargingStation: () => ChargingStation,
  ChargingType: () => ChargingType,
  Checklist: () => Checklist,
  ChildCareFacility: () => ChildCareFacility,
  Church: () => Church,
  CityObjectLoD2: () => CityObjectLoD2,
  CityObjectType: () => CityObjectType,
  CloudFile: () => CloudFile,
  CloudFolder: () => CloudFolder,
  CloudVolume: () => CloudVolume,
  Comparison: () => Comparison,
  ComparisonCondition: () => ComparisonCondition,
  ComparisonOperator: () => ComparisonOperator,
  ComparisonType: () => ComparisonType,
  Condition: () => Condition,
  ConditionType: () => ConditionType,
  ConjunctionCondition: () => ConjunctionCondition,
  Conversation: () => Conversation,
  CrimeStatistics: () => CrimeStatistics,
  Customer: () => Customer,
  CustomerTheme: () => CustomerTheme,
  Device: () => Device,
  Directionality: () => Directionality,
  Doctor: () => Doctor,
  Document: () => Document,
  DocumentDetails: () => DocumentDetails,
  DocumentType: () => DocumentType,
  DocumentTypeI18N: () => DocumentTypeI18N,
  EconomicsData: () => EconomicsData,
  EmailNotification: () => EmailNotification,
  EmploymentData: () => EmploymentData,
  EnergyFacility: () => EnergyFacility,
  Entitlement: () => Entitlement,
  Entity: () => Entity,
  EntityQuery: () => EntityQuery,
  EntityType: () => EntityType,
  EnvironmentData: () => EnvironmentData,
  Field: () => Field,
  FieldReference: () => FieldReference,
  FieldValue: () => FieldValue,
  Filter: () => Filter,
  FireStation: () => FireStation,
  Floor: () => Floor,
  FloorCategory: () => FloorCategory,
  FreewayMaintenanceOffice: () => FreewayMaintenanceOffice,
  GasAndSteamPowerPlant: () => GasAndSteamPowerPlant,
  Gateway: () => Gateway,
  Hairdresser: () => Hairdresser,
  Hospital: () => Hospital,
  Hotel: () => Hotel,
  HydroelectricPowerPlant: () => HydroelectricPowerPlant,
  Image: () => Image,
  ImageList: () => ImageList,
  IncomeData: () => IncomeData,
  Invoice: () => Invoice,
  InvoiceStatus: () => InvoiceStatus,
  InvoiceType: () => InvoiceType,
  InvoicingPeriod: () => InvoicingPeriod,
  KnowledgeBase: () => KnowledgeBase,
  LandUse: () => LandUse,
  LandUseData: () => LandUseData,
  LandUseI18N: () => LandUseI18N,
  Lease: () => Lease,
  LegalForm: () => LegalForm,
  LegalPerson: () => LegalPerson,
  LinkedEntityQuery: () => LinkedEntityQuery,
  LocalGovernment: () => LocalGovernment,
  LocalGovernmentType: () => LocalGovernmentType,
  LocalGovernmentTypeI18N: () => LocalGovernmentTypeI18N,
  MCPClient: () => MCPClient,
  MIMEType: () => MIMEType,
  MarketplaceOffer: () => MarketplaceOffer,
  Measurement: () => Measurement,
  MeasurementType: () => MeasurementType,
  MeasurementTypeI18N: () => MeasurementTypeI18N,
  MeasurementUnit: () => MeasurementUnit,
  Message: () => Message,
  MessageType: () => MessageType,
  MetadataLoD2: () => MetadataLoD2,
  MeteringAlgorithm: () => MeteringAlgorithm,
  NaturalPerson: () => NaturalPerson,
  OperatingState: () => OperatingState,
  OrCondition: () => OrCondition,
  OrFilter: () => OrFilter,
  Order: () => Order,
  OrderItem: () => OrderItem,
  PVPlant: () => PVPlant,
  Parcel: () => Parcel,
  ParcelStation: () => ParcelStation,
  ParkingLot: () => ParkingLot,
  Partnership: () => Partnership,
  PasswordStatus: () => PasswordStatus,
  PaymentMode: () => PaymentMode,
  Person: () => Person,
  Pharmacy: () => Pharmacy,
  Plan: () => Plan,
  PlotOfLand: () => PlotOfLand,
  PoI: () => PoI,
  PoIType: () => PoIType,
  PoITypeI18N: () => PoITypeI18N,
  PoliceStation: () => PoliceStation,
  PoliticsData: () => PoliticsData,
  PollutionData: () => PollutionData,
  PopulationData: () => PopulationData,
  PostalCode: () => PostalCode,
  ProcessDefinition: () => ProcessDefinition,
  ProcessDefinitionType: () => ProcessDefinitionType,
  Product: () => Product,
  ProductApproval: () => ProductApproval,
  Project: () => Project,
  ProjectEntitlement: () => ProjectEntitlement,
  PublicFinancesData: () => PublicFinancesData,
  PublishingStatus: () => PublishingStatus,
  Query: () => Query,
  Relationship: () => Relationship,
  RelationshipDirection: () => RelationshipDirection,
  ResidentialType: () => ResidentialType,
  Restaurant: () => Restaurant,
  Role: () => Role,
  RoleAssignment: () => RoleAssignment,
  RoleType: () => RoleType,
  RoofType: () => RoofType,
  SMSNotification: () => SMSNotification,
  School: () => School,
  ServiceType: () => ServiceType,
  Site: () => Site,
  SocialBenefitsData: () => SocialBenefitsData,
  SocialSupplyData: () => SocialSupplyData,
  Space: () => Space,
  SpaceCategory: () => SpaceCategory,
  SportType: () => SportType,
  StudentsNationalityGender: () => StudentsNationalityGender,
  StudyType: () => StudyType,
  StudyTypeI18N: () => StudyTypeI18N,
  SubjectOfStudy: () => SubjectOfStudy,
  Subsidiary: () => Subsidiary,
  SubsidiesData: () => SubsidiesData,
  SurfaceType: () => SurfaceType,
  Task: () => Task,
  TaskState: () => TaskState,
  TrafficData: () => TrafficData,
  TrainStation: () => TrainStation,
  TransformLoD2: () => TransformLoD2,
  Unit: () => Unit,
  University: () => University,
  UniversityType: () => UniversityType,
  User: () => User,
  UserState: () => UserState,
  VerticesLoD2: () => VerticesLoD2,
  Way: () => Way,
  WayType: () => WayType,
  WayTypeI18N: () => WayTypeI18N,
  WindTurbine: () => WindTurbine,
  and: () => and,
  calculateBoundingBox: () => calculateBoundingBox,
  from: () => from,
  getConvexPolygonArea: () => getConvexPolygonArea,
  getEntityType: () => getEntityType,
  getGeoArea: () => getGeoArea,
  getRelationship: () => getRelationship,
  group: () => group,
  is: () => is,
  not: () => not,
  objectClasses: () => objectClasses,
  or: () => or,
  outerBoundingBox: () => outerBoundingBox,
  sum: () => sum
});
module.exports = __toCommonJS(src_exports);

// src/model/entity.ts
var Field = class {
  constructor(properties) {
    this.name = properties.name;
    this.type = properties.type;
    this.key = properties.key;
    this.label = properties.label;
  }
  getLabel(locale) {
    if (!this.label || !this.label[locale]) {
      if (this.label && this.label.en) {
        return this.label.en;
      }
      return this.name;
    }
    return this.label[locale];
  }
};
var Cardinality = /* @__PURE__ */ ((Cardinality4) => {
  Cardinality4["OneToOne"] = "OneToOne";
  Cardinality4["OneToMany"] = "OneToMany";
  Cardinality4["ManyToOne"] = "ManyToOne";
  Cardinality4["ManyToMany"] = "ManyToMany";
  return Cardinality4;
})(Cardinality || {});
var Directionality = /* @__PURE__ */ ((Directionality4) => {
  Directionality4["Unidirectional"] = "Unidirectional";
  Directionality4["Bidirectional"] = "Bidirectional";
  return Directionality4;
})(Directionality || {});
var Relationship = class {
  constructor(properties) {
    this.name = properties.name;
    this.type = properties.type;
    this.typeName = properties.typeName;
    this.cardinality = properties.cardinality;
    this.directionality = properties.directionality;
    this.inverseName = properties.inverseName;
    this.label = properties.label;
    this.inverseLabel = properties.inverseLabel;
  }
  getTypeName() {
    return this.typeName || this.type.type.name;
  }
  getLabel(locale) {
    if (!this.label || !this.label[locale]) {
      if (this.label && this.label.en) {
        return this.label.en;
      }
      return this.name;
    }
    return this.label[locale];
  }
  getInverseLabel(locale) {
    if (!this.inverseLabel || !this.inverseLabel[locale]) {
      if (this.inverseLabel && this.inverseLabel.en) {
        return this.inverseLabel.en;
      }
      return this.inverseName;
    }
    return this.inverseLabel[locale];
  }
};
var EntityType = class {
  constructor(properties) {
    this.public = properties.public;
    this.type = properties.type;
    this.name = properties.name;
    this.label = properties.label;
  }
  getLabel(locale) {
    if (!this.label || !this.label[locale]) {
      if (this.label && this.label.en) {
        return this.label.en;
      }
      return this.type.name;
    }
    return this.label[locale];
  }
};
var Image = class {
  // 2:1 aspect ratio
  static getBackgroundImageStyle(imageUrl) {
    return `background-image: url('${imageUrl}'); background-size: cover; background-position: center; aspect-ratio: ${this.TARGET_ASPECT_RATIO};`;
  }
  static getImageElement(imageUrl, onClick) {
    return `<div class="image-container" style="${this.getBackgroundImageStyle(imageUrl)}" ${onClick ? `onclick="${onClick}"` : ""}></div>`;
  }
};
Image.TARGET_ASPECT_RATIO = 2;
var ImageList = class {
  static getImageElements(imageUrls, onClick) {
    return imageUrls.map((url) => Image.getImageElement(url, onClick ? () => onClick(url) : void 0));
  }
};
var Entity = class {
  static validate(entityType) {
    console.log("Fields >>>", entityType.fields);
    console.log("Relationship >>>", entityType.relationships);
  }
  static dumpSchema(entityType) {
    console.log("Entity Type: ", entityType.name);
    console.log("Fields:");
    entityType.fields.forEach((field) => {
      console.log(`	${field.name}: ${field.type.name}${field.type.constructor.key ? "*" : ""}`);
    });
    console.log("Relationships:");
    entityType.relationships.forEach((relationship) => {
      console.log(`	${relationship.name}: ${relationship.type.name}${relationship.type.constructor.cardinality === "OneToMany" /* OneToMany */ ? "[]" : ""}${relationship.type.constructor.directionality === "Bidirectional" /* Bidirectional */ && relationship.type.constructor.inverseName ? relationship.type.constructor.inverseName : ""}`);
    });
    console.log("\n\n");
  }
  constructor(props) {
    this._type = this.getTypeName();
    this._id = props._id;
    this._tenant = props._tenant;
  }
  getTypeClass() {
    return this.constructor;
  }
  getTypeName() {
    return this.constructor.type.name;
  }
};

// src/model/address.ts
var _Address = class _Address extends Entity {
  static splitStreetWithNumber(streetWithNumber) {
    const split = {};
    const chunks = streetWithNumber.split(/(?= \d| [\w\d/]+$)/);
    let street;
    let streetNumber;
    if (chunks.length === 2 && chunks[0] && chunks[1]) {
      street = chunks[0].trim();
      streetNumber = chunks[1].trim();
    } else if (chunks.length === 2 && chunks[0] && chunks[1] && chunks[2]) {
      street = chunks[0].trim();
      streetNumber = chunks[1].trim() + chunks[2].trim();
    }
    if (street && streetNumber) {
      street = street.replace("Str.", "Stra\xDFe");
      street = street.replace("str.", "stra\xDFe");
      street = street.replace("pl.", "platz");
      street = street.replace("Pl.", "Platz");
      return {
        street,
        streetNumber
      };
    }
    return {};
  }
  constructor(props) {
    super(props);
    this.street = props.street;
    this.streetNumber = props.streetNumber;
    this.postalCode = props.postalCode;
    this.city = props.city;
    this.country = props.country;
    this.normalized = _Address.normalize(props);
  }
};
_Address.type = new EntityType({
  type: _Address,
  name: "Address",
  label: {
    en: "Address",
    de: "Adresse"
  }
});
_Address.fields = [
  new Field({
    name: "normalized",
    type: String,
    key: true,
    label: {
      en: "Normal Form",
      de: "Normalform"
    }
  }),
  new Field({
    name: "street",
    type: String,
    key: false,
    label: {
      en: "Street",
      de: "Stra\xDFe"
    }
  }),
  new Field({
    name: "streetNumber",
    type: String,
    key: false,
    label: {
      en: "Street Number",
      de: "Hausnummer"
    }
  }),
  new Field({
    name: "city",
    type: String,
    key: false,
    label: {
      en: "City",
      de: "Ort"
    }
  }),
  new Field({
    name: "postalCode",
    type: String,
    key: false,
    label: {
      en: "Postal Code",
      de: "Postleitzahl"
    }
  }),
  new Field({
    name: "country",
    type: String,
    key: false,
    label: {
      en: "Country",
      de: "Land"
    }
  })
];
_Address.relationships = [];
_Address.normalize = (props) => {
  return `${props.street} ${props.streetNumber} ${props.postalCode} ${props.city} ${props.country || "DE"}`;
};
var Address = _Address;

// src/model/person.ts
var LegalForm = /* @__PURE__ */ ((LegalForm2) => {
  LegalForm2["AG"] = "AG";
  LegalForm2["KG"] = "KG";
  LegalForm2["GmbH"] = "GmbH";
  LegalForm2["GmbHCoKG"] = "GmbH & Co. KG";
  LegalForm2["UG"] = "UG";
  LegalForm2["gUG"] = "gUG";
  LegalForm2["eV"] = "e. V.";
  LegalForm2["eK"] = "e. K.";
  LegalForm2["gGmbH"] = "gGmbH";
  LegalForm2["OHG"] = "OHG";
  LegalForm2["eG"] = "eG";
  LegalForm2["UGCoKG"] = "UG & Co. KG";
  LegalForm2["AGCoOHG"] = "AG & Co. OHG";
  LegalForm2["AGCoKG"] = "AG & Co. KG";
  LegalForm2["LtdCoKG"] = "Ltd. & Co. KG";
  LegalForm2["GmbHCoOHG"] = "GmbH & Co. OHG";
  LegalForm2["Ltd"] = "Ltd.";
  LegalForm2["PartG"] = "PartG";
  LegalForm2["PartGmbB"] = "PartG mbB";
  LegalForm2["BV"] = "B.V.";
  LegalForm2["SE"] = "SE";
  LegalForm2["SECoKG"] = "SE & Co. KG";
  LegalForm2["Inc"] = "Inc.";
  LegalForm2["LLC"] = "LLC";
  LegalForm2["SA"] = "SA";
  LegalForm2["SL"] = "SL";
  LegalForm2["AB"] = "AB";
  LegalForm2["GbR"] = "GbR";
  LegalForm2["GbRCoKG"] = "GbR & Co. KG";
  LegalForm2["other"] = "other";
  return LegalForm2;
})(LegalForm || {});
var CompanyStatus = /* @__PURE__ */ ((CompanyStatus2) => {
  CompanyStatus2["active"] = "active";
  CompanyStatus2["unknown"] = "unknown";
  return CompanyStatus2;
})(CompanyStatus || {});
var Person = class extends Entity {
  constructor(props) {
    super(props);
  }
};
var _NaturalPerson = class _NaturalPerson extends Person {
  constructor(props) {
    super(props);
    this.firstName = props.firstName;
    this.lastName = props.lastName;
    this.dateOfBirth = props.dateOfBirth;
    this.generalManagerOf = props.generalManagerOf ? props.generalManagerOf.map((props2) => new LegalPerson(props2)) : [];
    this.primaryResidence = props.primaryResidence ? new Address(props.primaryResidence) : void 0;
  }
};
_NaturalPerson.type = new EntityType({
  public: false,
  type: _NaturalPerson,
  name: "NaturalPerson",
  label: {
    en: "Natural Person",
    de: "Nat\xFCrliche Person"
  }
});
_NaturalPerson.fields = [
  new Field({
    name: "firstName",
    type: String,
    key: true,
    label: {
      en: "First Name",
      de: "Vorname"
    }
  }),
  new Field({
    name: "lastName",
    type: String,
    key: true,
    label: {
      en: "Last Name",
      de: "Nachname"
    }
  }),
  new Field({
    name: "dateOfBirth",
    type: Date,
    key: true,
    label: {
      en: "Date of Birth",
      de: "Geburtsdatum"
    }
  })
];
_NaturalPerson.relationships = [new Relationship({
  name: "generalManagerOf",
  type: Entity,
  // LegalPerson,
  cardinality: "ManyToMany" /* ManyToMany */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "generalManagers",
  label: {
    en: "General Manager of",
    de: "Gesch\xE4ftsf\xFChrer von"
  },
  inverseLabel: {
    en: "General Managers",
    de: "Gesch\xE4ftsf\xFChrer"
  }
}), new Relationship({
  name: "primaryResidence",
  type: Address,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Primary Residence",
    de: "Hauptsitz"
  }
})];
var NaturalPerson = _NaturalPerson;
var _Subsidiary = class _Subsidiary extends Entity {
  constructor(props) {
    super(props);
    this.id = `${props.address.street} ${props.address.streetNumber} ${props.address.postalCode} ${props.address.city} ${props.address.country}`;
    this.name = props.name;
    this.phone = props.phone;
    this.email = props.email;
    this.website = props.website;
    this.address = new Address(props.address);
  }
};
_Subsidiary.type = new EntityType({
  public: true,
  type: _Subsidiary,
  name: "Subsidiary",
  label: {
    en: "Subsidiary",
    de: "Niederlassung"
  }
});
_Subsidiary.fields = [new Field({
  name: "id",
  type: String,
  key: true,
  label: {
    en: "ID",
    de: "ID"
  }
}), new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone Number",
    de: "Telefon-Nr."
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "E-Mail",
    de: "E-Mail"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Webseite"
  }
})];
_Subsidiary.relationships = [new Relationship({
  name: "address",
  type: Address,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Address",
    de: "Adresse"
  }
})];
var Subsidiary = _Subsidiary;
var _LegalPerson = class _LegalPerson extends Person {
  constructor(props) {
    super(props);
    this.subsidiaries = [];
    this.generalManagers = [];
    this.tradeRegisterCity = props.tradeRegisterCity;
    this.tradeRegisterId = props.tradeRegisterId;
    this.name = props.name;
    this.legalForm = "GmbH" /* GmbH */;
    this.start = props.start;
    this.purpose = props.purpose;
    this.purposeCode = props.purposeCode;
    this.phoneNumber = props.phoneNumber;
    this.faxNumber = props.faxNumber;
    this.email = props.email;
    this.website = props.website;
    this.taxID = props.taxID;
    this.iban = props.iban;
    this.lat = props.lat;
    this.lon = props.lon;
    this.status = props.status;
    this.headquarters = props.headquarters ? new Address(props.headquarters) : void 0;
  }
};
_LegalPerson.type = new EntityType({
  public: true,
  type: _LegalPerson,
  name: "LegalPerson",
  label: {
    en: "Company/Organisation",
    de: "Unternehmen/Organisation"
  }
});
_LegalPerson.fields = [
  new Field({
    name: "tradeRegisterCity",
    type: String,
    key: true,
    label: {
      en: "Trade Register City",
      de: "Registergericht"
    }
  }),
  new Field({
    name: "tradeRegisterId",
    type: String,
    key: true,
    label: {
      en: "Trade Register ID",
      de: "Handelsregister-Nr."
    }
  }),
  new Field({
    name: "name",
    type: String,
    key: true,
    label: {
      en: "Name",
      de: "Name"
    }
  }),
  new Field({
    name: "legalForm",
    type: String,
    key: false,
    label: {
      en: "Legal Form",
      de: "Rechtsform"
    }
  }),
  new Field({
    name: "start",
    type: Date,
    key: false,
    label: {
      en: "Incorporation",
      de: "Gr\xFCndung"
    }
  }),
  new Field({
    name: "purpose",
    type: String,
    key: false,
    label: {
      en: "Purpose",
      de: "Zweck"
    }
  }),
  new Field({
    name: "faxNumber",
    type: String,
    key: false,
    label: {
      en: "Fax Number",
      de: "Fax-Nr."
    }
  }),
  new Field({
    name: "phoneNumber",
    type: String,
    key: false,
    label: {
      en: "Phone Number",
      de: "Telefon-Nr."
    }
  }),
  new Field({
    name: "email",
    type: String,
    key: false,
    label: {
      en: "E-Mail",
      de: "E-Mail"
    }
  }),
  new Field({
    name: "website",
    type: String,
    key: false,
    label: {
      en: "Website",
      de: "Webseite"
    }
  }),
  new Field({
    name: "taxID",
    type: String,
    key: false,
    label: {
      en: "Tax ID",
      de: "Ust-ID"
    }
  }),
  new Field({
    name: "iban",
    type: String,
    key: false,
    label: {
      en: "IBAN",
      de: "IBAN"
    }
  }),
  new Field({
    name: "lat",
    type: Number,
    key: false,
    label: {
      en: "Latitude",
      de: "E-Breitengrad"
    }
  }),
  new Field({
    name: "lon",
    type: String,
    key: false,
    label: {
      en: "Longitude",
      de: "L\xE4ngengrad"
    }
  }),
  new Field({
    name: "status",
    type: CompanyStatus,
    key: false,
    label: {
      en: "Status",
      de: "Status"
    }
  }),
  new Field({
    name: "taxId",
    type: String,
    key: false,
    label: {
      en: "Tax-ID",
      de: "USt.-Id."
    }
  })
];
_LegalPerson.relationships = [new Relationship({
  name: "headquarters",
  type: Address,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Headquarters",
    de: "Hauptsitz"
  }
}), new Relationship({
  name: "subsidiaries",
  type: Subsidiary,
  cardinality: "OneToMany" /* OneToMany */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "company",
  label: {
    en: "Subsidiaries",
    de: "Niederlassungen"
  },
  inverseLabel: {
    en: "Company",
    de: "Unternehmen"
  }
}), new Relationship({
  name: "generalManagers",
  type: NaturalPerson,
  cardinality: "ManyToMany" /* ManyToMany */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "generalManagerOf",
  label: {
    en: "General Managers",
    de: "Gesch\xE4ftsf\xFChrer"
  },
  inverseLabel: {
    en: "General Manager of",
    de: "Gesch\xE4ftsf\xFChrer von"
  }
})];
var LegalPerson = _LegalPerson;
var _Partnership = class _Partnership extends Entity {
  constructor(props) {
    super(props);
    this.customer = props.customer;
    this.supplier = props.supplier;
    this.emailPrimaryContact = props.emailPrimaryContact;
  }
};
_Partnership.type = new EntityType({
  public: true,
  type: _Partnership,
  name: "Partnership",
  label: {
    en: "Partnership",
    de: "Partnerschaft"
  }
});
_Partnership.fields = [new Field({
  name: "customer",
  type: String,
  key: true,
  label: {
    en: "Customer",
    de: "Kunde"
  }
}), new Field({
  name: "supplier",
  type: String,
  key: true,
  label: {
    en: "Supplier",
    de: "Lieferant"
  }
}), new Field({
  name: "emailPrimaryContact",
  type: String,
  key: false,
  label: {
    en: "E-Mail Primary Contact",
    de: "E-Mail Ansprechpartner"
  }
})];
_Partnership.relationships = [];
var Partnership = _Partnership;

// src/model/telemetry.ts
var MeasurementType = /* @__PURE__ */ ((MeasurementType2) => {
  MeasurementType2["outsideTemperature"] = "outsideTemperature";
  MeasurementType2["temperature"] = "temperature";
  MeasurementType2["ambientTemperature"] = "ambientTemperature";
  MeasurementType2["internalTemperature"] = "internalTemperature";
  MeasurementType2["precipitation"] = "precipitation";
  MeasurementType2["relativeHumidity"] = "relativeHumidity";
  MeasurementType2["peopleCount"] = "peopleCount";
  MeasurementType2["energyConsumption"] = "energyConsumption";
  MeasurementType2["windSpeed"] = "windSpeed";
  MeasurementType2["windDirection"] = "windDirection";
  MeasurementType2["operatingState"] = "operatingState";
  MeasurementType2["accelerationX"] = "accelerationX";
  MeasurementType2["accelerationY"] = "accelerationY";
  MeasurementType2["accelerationZ"] = "accelerationZ";
  MeasurementType2["deviceMove"] = "deviceMove";
  MeasurementType2["deviceHorizontalMove"] = "deviceHorizontalMove";
  MeasurementType2["pressure"] = "pressure";
  MeasurementType2["pressureLow"] = "pressureLow";
  MeasurementType2["pressureDrop"] = "pressureDrop";
  MeasurementType2["batteryLevel"] = "batteryLevel";
  MeasurementType2["rssi"] = "rssi";
  return MeasurementType2;
})(MeasurementType || {});
var MeasurementUnit = {
  en: {
    outsideTemperature: "\xB0F",
    temperature: "\xB0F",
    ambientTemperature: "\xB0F",
    internalTemperature: "\xB0F",
    precipitation: "mm",
    relativeHumidity: "%",
    peopleCount: "",
    energyConsumption: "W",
    windSpeed: "m/s\xB2",
    windDirection: "\xB0",
    operatingState: "",
    accelerationX: "m/s\xB2",
    accelerationY: "m/s\xB2",
    accelerationZ: "m/s\xB2",
    deviceMove: "",
    deviceHorizontalMove: "",
    pressure: "bar",
    pressureLow: "",
    pressureDrop: "",
    batteryLevel: "%",
    rssi: "RSSI"
  },
  de: {
    outsideTemperature: "\xB0C",
    temperature: "\xB0C",
    ambientTemperature: "\xB0C",
    internalTemperature: "\xB0C",
    precipitation: "mm",
    relativeHumidity: "%",
    peopleCount: "",
    energyConsumption: "W",
    windSpeed: "m/s",
    windDirection: "\xB0",
    operatingState: "",
    accelerationX: "m/s\xB2",
    accelerationY: "m/s\xB2",
    accelerationZ: "m/s\xB2",
    deviceMove: "",
    deviceHorizontalMove: "",
    pressure: "bar",
    pressureLow: "",
    pressureDrop: "",
    batteryLevel: "%",
    rssi: "RSSI"
  }
};
var MeasurementTypeI18N = {
  en: {
    outsideTemperature: "Outside Temperature",
    temperature: "Temperature",
    ambientTemperature: "Ambient Temperature",
    internalTemperature: "Internal Temperature",
    precipitation: "Precipitation",
    relativeHumidity: "Relative Humidity",
    peopleCount: "People Count",
    energyConsumption: "Energy Consumption",
    windSpeed: "Wind Speed",
    windDirection: "Wind Direction",
    operatingState: "Operating State",
    accelerationX: "Acceleration X",
    accelerationY: "Acceleration Y",
    accelerationZ: "Acceleration Z",
    deviceMove: "Device moved",
    deviceHorizontalMove: "Device moved horizontally",
    pressure: "Pressure",
    pressureLow: "Low pressure",
    pressureDrop: "Rapid pressure drop",
    batteryLevel: "Battery Level",
    rssi: "RSSI"
  },
  de: {
    outsideTemperature: "Aussentemperatur",
    temperature: "Temperatur",
    ambientTemperature: "Umgebungstemperatur",
    internalTemperature: "Interne Temperatur",
    precipitation: "Precipitation",
    relativeHumidity: "Relative Luftfeuchtigkeit",
    peopleCount: "Personenzahl",
    energyConsumption: "Energieverbrauch",
    windSpeed: "Windgeschwindigkeit",
    windDirection: "Windrichtung",
    operatingState: "Betriebszustand",
    accelerationX: "Beschleunigung X",
    accelerationY: "Beschleunigung Y",
    accelerationZ: "Beschleunigung Z",
    deviceMove: "Ger\xE4t bewegt",
    deviceHorizontalMove: "Ger\xE4t horizontal bewegt",
    pressure: "Druck",
    pressureLow: "Niedriger druck",
    pressureDrop: "Rapider Druckabfall",
    batteryLevel: "Batteriestand",
    rssi: "RSSI"
  }
};
var _Measurement = class _Measurement extends Entity {
  constructor(props) {
    super(props);
    this.timestamp = new Date(props.timestamp);
    this.x = props.x;
    this.y = props.y;
    this.latitude = props.latitude;
    this.longitude = props.longitude;
    this.country = props.country;
    this.city = props.city;
    this.postalCode = props.postalCode;
    this.street = props.street;
    this.streetNumber = props.streetNumber;
    this.floor = props.floor;
    this.space = props.space;
    this.asset = props.asset;
    this.metric = props.metric;
    this.value = props.value;
  }
};
_Measurement.type = new EntityType({
  public: false,
  type: _Measurement,
  name: "Measurement",
  label: {
    en: "Measurement",
    de: "Messwert"
  }
});
_Measurement.fields = [new Field({
  name: "timestamp",
  type: Date,
  key: true
}), new Field({
  name: "country",
  type: String,
  key: true
}), new Field({
  name: "city",
  type: String,
  key: true
}), new Field({
  name: "postalCode",
  type: String,
  key: true
}), new Field({
  name: "street",
  type: String,
  key: true
}), new Field({
  name: "streetNumber",
  type: String,
  key: true
}), new Field({
  name: "floor",
  type: String,
  key: true
}), new Field({
  name: "space",
  type: String,
  key: true
}), new Field({
  name: "x",
  type: Number,
  key: true
}), new Field({
  name: "y",
  type: Number,
  key: true
}), new Field({
  name: "latitude",
  type: Number,
  key: true
}), new Field({
  name: "longitude",
  type: Number,
  key: true
}), new Field({
  name: "asset",
  type: String,
  key: true
}), new Field({
  name: "metric",
  type: String,
  key: true
}), new Field({
  name: "value",
  type: Object,
  key: true
})];
_Measurement.relationships = [];
var Measurement = _Measurement;
var _Gateway = class _Gateway extends Entity {
  constructor(props) {
    super(props);
    this.url = props.url;
    this.customer = props.customer;
  }
};
_Gateway.type = new EntityType({
  public: false,
  type: _Gateway,
  name: "Gateway",
  label: {
    en: "Gateway",
    de: "Gateway"
  }
});
_Gateway.fields = [new Field({
  name: "url",
  type: String,
  key: true
}), new Field({
  name: "customer",
  type: String,
  key: true
})];
_Gateway.relationships = [];
var Gateway = _Gateway;
var Device = class {
  constructor(configuration, submitBuffered = (device, state) => {
  }, submitImmediate = (device, state) => {
  }) {
    this.manufacturer = configuration.manufacturer;
    this.type = configuration.type;
    this._id = configuration._id;
    this.lastConfigurationChange = /* @__PURE__ */ new Date();
    this.lastStateChange = /* @__PURE__ */ new Date();
    this.submitBuffered = submitBuffered;
    this.submitImmediate = submitImmediate;
  }
};

// src/model/map.ts
var AreaScale = /* @__PURE__ */ ((AreaScale2) => {
  AreaScale2["Area10km"] = "10km";
  AreaScale2["Area1km"] = "1km";
  AreaScale2["Area100m"] = "100m";
  return AreaScale2;
})(AreaScale || {});
var _Area = class _Area extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.scale = props.scale;
    this.x = props.x;
    this.y = props.y;
    this.lat = props.lat;
    this.lon = props.lon;
    this.boundingBox = props.boundingBox;
    this.minLat = props.minLat;
    this.maxLat = props.maxLat;
    this.minLon = props.minLon;
    this.maxLon = props.maxLon;
    this.population = props.population;
    this.averageRentSqm = props.averageRentSqm;
    this.heatingCount = props.heatingCount;
    this.districtHeatingCount = props.districtHeatingCount;
    this.storeyHeatingCount = props.storeyHeatingCount;
    this.blockHeatingCount = props.blockHeatingCount;
    this.centralHeatingCount = props.centralHeatingCount;
    this.ovenHeatingCount = props.ovenHeatingCount;
    this.noHeatingCount = props.noHeatingCount;
    this.energySourceCount = props.energySourceCount;
    this.gasEnergySourceCount = props.gasEnergySourceCount;
    this.oilEnergySourceCount = props.oilEnergySourceCount;
    this.woodEnergySourceCount = props.woodEnergySourceCount;
    this.bioMassGasEnergySourceCount = props.bioMassGasEnergySourceCount;
    this.solarGeoHeatPumpEnergySourceCount = props.solarGeoHeatPumpEnergySourceCount;
    this.electricalEnergySourceCount = props.electricalEnergySourceCount;
    this.coalEnergySourceCount = props.coalEnergySourceCount;
    this.districtEnergySourceCount = props.districtEnergySourceCount;
    this.noSourceCount = props.noSourceCount;
  }
};
_Area.type = new EntityType({
  type: _Area,
  name: "Area",
  label: {
    en: "Area",
    de: "Fl\xE4che"
  }
});
_Area.fields = [
  new Field({
    name: "id",
    type: String,
    key: true
  }),
  new Field({
    name: "scale",
    type: String,
    key: false
  }),
  new Field({
    name: "x",
    type: Number,
    key: false
  }),
  new Field({
    name: "y",
    type: Number,
    key: false
  }),
  new Field({
    name: "lat",
    type: Number,
    key: false
  }),
  new Field({
    name: "lon",
    type: Number,
    key: false
  }),
  new Field({
    name: "boundingBox",
    type: JSON,
    key: false
  }),
  new Field({
    name: "minLon",
    type: Number,
    key: true
  }),
  new Field({
    name: "maxLon",
    type: Number,
    key: true
  }),
  new Field({
    name: "minLat",
    type: Number,
    key: true
  }),
  new Field({
    name: "maxLat",
    type: Number,
    key: true
  }),
  new Field({
    name: "population",
    type: Number,
    key: false
  }),
  new Field({
    name: "averageRentSqm",
    type: Number,
    key: false
  }),
  new Field({
    name: "heatingCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "districtHeatingCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "storeyHeatingCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "blockHeatingCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "centralHeatingCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "ovenHeatingCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "noHeatingCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "energySourceCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "gasEnergySourceCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "oilEnergySourceCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "woodEnergySourceCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "bioMassGasEnergySourceCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "solarGeoHeatPumpEnergySourceCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "electricalEnergySourceCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "coalEnergySourceCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "districtEnergySourceCount",
    type: Number,
    key: false
  }),
  new Field({
    name: "noSourceCount",
    type: Number,
    key: false
  })
];
_Area.relationships = [];
var Area = _Area;
var LocalGovernmentType = /* @__PURE__ */ ((LocalGovernmentType2) => {
  LocalGovernmentType2["Country"] = "Country";
  LocalGovernmentType2["State"] = "State";
  LocalGovernmentType2["City"] = "City";
  LocalGovernmentType2["County"] = "County";
  LocalGovernmentType2["Municipality"] = "Municipality";
  LocalGovernmentType2["GovernmentDistrict"] = "GovernmentDistrict";
  LocalGovernmentType2["AdministrativeDistrict"] = "AdministrativeDistrict";
  return LocalGovernmentType2;
})(LocalGovernmentType || {});
var LocalGovernmentTypeI18N = {
  en: {
    Country: "Country",
    State: "State",
    City: "City",
    County: "County",
    Municipality: "Municipality",
    GovernmentDistrict: "Government District",
    AdministrativeDistrict: "Administrative District"
  },
  de: {
    Country: "Land",
    State: "Bundesland",
    City: "Stadt",
    County: "Landkreis",
    Municipality: "Gemeinde",
    GovernmentDistrict: "Regierungsbezirk",
    AdministrativeDistrict: "Verwaltungsbezirk"
  }
};
var _LocalGovernment = class _LocalGovernment extends Entity {
  constructor(props) {
    super(props);
    this.id = props.municipalityKey || props.id;
    this.municipalityKey = props.municipalityKey;
    this.type = props.type;
    this.name = props.name;
    this.boundingBox = props.boundingBox;
    this.lat = props.lat;
    this.lon = props.lon;
    this.minLat = props.minLat;
    this.maxLat = props.maxLat;
    this.minLon = props.minLon;
    this.maxLon = props.maxLon;
    this.shape = props.shape;
    this.shapeType = props.shapeType;
    this.postalCode = props.postalCode;
  }
};
_LocalGovernment.type = new EntityType({
  type: _LocalGovernment,
  name: "LocalGovernment",
  label: {
    en: "Local Government",
    de: "Verwaltungseinheit"
  }
});
_LocalGovernment.fields = [new Field({
  name: "id",
  type: String,
  key: true
}), new Field({
  name: "municipalityKey",
  type: String,
  key: true
}), new Field({
  name: "type",
  type: String,
  key: false
}), new Field({
  name: "name",
  type: String,
  key: false
}), new Field({
  name: "created",
  type: Date,
  key: false
}), new Field({
  name: "boundingBox",
  type: JSON,
  key: false
}), new Field({
  name: "lat",
  type: Number,
  key: false
}), new Field({
  name: "lon",
  type: Number,
  key: false
}), new Field({
  name: "minLon",
  type: Number,
  key: true
}), new Field({
  name: "maxLon",
  type: Number,
  key: true
}), new Field({
  name: "minLat",
  type: Number,
  key: true
}), new Field({
  name: "maxLat",
  type: Number,
  key: true
}), new Field({
  name: "shape",
  type: JSON,
  key: false
}), new Field({
  name: "shapeType",
  type: String,
  key: false
}), new Field({
  name: "postalCode",
  type: String,
  key: false
})];
_LocalGovernment.relationships = [];
_LocalGovernment.germany = new _LocalGovernment({
  name: "Deutschland",
  type: "Country" /* Country */,
  municipalityKey: "DE",
  minLat: 47.2701114,
  // Southernmost point (Oberstdorf)
  maxLat: 55.0583835,
  // Northernmost point (List auf Sylt)
  minLon: 5.8663153,
  // Westernmost point (Selfkant)
  maxLon: 15.0419319
  // Easternmost point (Deschka)
});
var LocalGovernment = _LocalGovernment;
var _PostalCode = class _PostalCode extends Entity {
  constructor(props) {
    super(props);
    this.postalCode = props.postalCode;
    this.ags = props.ags;
    this.osmID = props.osmID;
    this.city = props.city;
    this.localGovernment = props.localGovernment;
    this.state = props.state;
    this.boundingBox = props.boundingBox;
    this.minLat = props.minLat;
    this.maxLat = props.maxLat;
    this.minLon = props.minLon;
    this.maxLon = props.maxLon;
    this.shape = props.shape;
    this.shapeType = props.shapeType;
    this.population = props.population;
  }
};
_PostalCode.type = new EntityType({
  type: _PostalCode,
  name: "PostalCode",
  label: {
    en: "Postal Code Area",
    de: "Postleitzahlbereich"
  }
});
_PostalCode.fields = [
  new Field({
    name: "postalCode",
    type: String,
    key: true
  }),
  new Field({
    name: "ags",
    type: String,
    key: false
  }),
  new Field({
    name: "osmID",
    type: String,
    key: false
  }),
  new Field({
    name: "city",
    type: String,
    key: false
  }),
  new Field({
    name: "localGovernment",
    type: String,
    key: false
  }),
  new Field({
    name: "state",
    type: String,
    key: false
  }),
  new Field({
    name: "boundingBox",
    type: JSON,
    key: false
  }),
  new Field({
    name: "minLon",
    type: Number,
    key: true
  }),
  new Field({
    name: "maxLon",
    type: Number,
    key: true
  }),
  new Field({
    name: "minLat",
    type: Number,
    key: true
  }),
  new Field({
    name: "maxLat",
    type: Number,
    key: true
  }),
  new Field({
    name: "shape",
    type: JSON,
    key: false
  }),
  new Field({
    name: "shapeType",
    type: String,
    key: false
  }),
  new Field({
    name: "population",
    type: Number,
    key: false
  })
];
_PostalCode.relationships = [];
var PostalCode = _PostalCode;
var _CellularCoverage = class _CellularCoverage extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.name = props.name;
    this.administrativeLevel = props.administrativeLevel;
    this.state = props.state;
    this.district = props.district;
    this.spatialCategory = props.spatialCategory;
    this.twoGAll = props.twoGAll;
    this.fourGAll = props.fourGAll;
    this.fiveGDssAll = props.fiveGDssAll;
    this.fiveGNsaSaAll = props.fiveGNsaSaAll;
    this.twoGTelefonica = props.twoGTelefonica;
    this.fourGTelefonica = props.fourGTelefonica;
    this.fiveGDssTelefonica = props.fiveGDssTelefonica;
    this.fiveGNsaSaTelefonica = props.fiveGNsaSaTelefonica;
    this.twoGTelekom = props.twoGTelekom;
    this.fourGTelekom = props.fourGTelekom;
    this.fiveGDssTelekom = props.fiveGDssTelekom;
    this.fiveGNsaSaTelekom = props.fiveGNsaSaTelekom;
    this.twoGVodafone = props.twoGVodafone;
    this.fourGVodafone = props.fourGVodafone;
    this.fiveGDssVodafone = props.fiveGDssVodafone;
    this.fiveGNsaSaVodafone = props.fiveGNsaSaVodafone;
  }
};
_CellularCoverage.type = new EntityType({
  type: _CellularCoverage,
  name: "CellularCoverage",
  label: {
    en: "Cellular Coverage",
    de: "Abdeckung Mobilfunknetze"
  }
});
_CellularCoverage.fields = [new Field({
  name: "municipalityKey",
  type: String,
  key: true,
  label: {
    en: "Municipality Key",
    de: "Gemeindeschl\xFCssel"
  }
}), new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "administrativeLevel",
  type: String,
  key: false,
  label: {
    en: "Administrative Level",
    de: "Verwaltungsebene"
  }
}), new Field({
  name: "state",
  type: String,
  key: false,
  label: {
    en: "State",
    de: "Bundesland"
  }
}), new Field({
  name: "district",
  type: String,
  key: false,
  label: {
    en: "District",
    de: "Kreis"
  }
}), new Field({
  name: "spatialCategory",
  type: String,
  key: false,
  label: {
    en: "Spatial Category",
    de: "Raumkategorie"
  }
}), new Field({
  name: "twoGAll",
  type: Number,
  key: false,
  label: {
    en: "2G Coverage All",
    de: "2G Abdeckung Alle"
  }
}), new Field({
  name: "fourGAll",
  type: Number,
  key: false,
  label: {
    en: "4G Coverage All",
    de: "4G Abdeckung Alle"
  }
}), new Field({
  name: "fiveGDssAll",
  type: Number,
  key: false,
  label: {
    en: "5G DSS Coverage All",
    de: "5G DSS Abdeckung Alle"
  }
}), new Field({
  name: "fiveGNsaSaAll",
  type: Number,
  key: false,
  label: {
    en: "5G NSA/SA Coverage All",
    de: "5G NSA/SA Abdeckung Alle"
  }
}), new Field({
  name: "twoGTelefonica",
  type: Number,
  key: false,
  label: {
    en: "2G Coverage Telefonica",
    de: "2G Abdeckung Telefonica"
  }
}), new Field({
  name: "fourGTelefonica",
  type: Number,
  key: false,
  label: {
    en: "4G Coverage Telefonica",
    de: "4G Abdeckung Telefonica"
  }
}), new Field({
  name: "fiveGDssTelefonica",
  type: Number,
  key: false,
  label: {
    en: "5G DSS Coverage Telefonica",
    de: "5G DSS Abdeckung Telefonica"
  }
}), new Field({
  name: "fiveGNsaSaTelefonica",
  type: Number,
  key: false,
  label: {
    en: "5G NSA/SA Coverage Telefonica",
    de: "5G NSA/SA Abdeckung Telefonica"
  }
}), new Field({
  name: "twoGTelekom",
  type: Number,
  key: false,
  label: {
    en: "2G Coverage Telekom",
    de: "2G Abdeckung Telekom"
  }
}), new Field({
  name: "fourGTelekom",
  type: Number,
  key: false,
  label: {
    en: "4G Coverage Telekom",
    de: "4G Abdeckung Telekom"
  }
}), new Field({
  name: "fiveGDssTelekom",
  type: Number,
  key: false,
  label: {
    en: "5G DSS Coverage Telekom",
    de: "5G DSS Abdeckung Telekom"
  }
}), new Field({
  name: "fiveGNsaSaTelekom",
  type: Number,
  key: false,
  label: {
    en: "5G NSA/SA Coverage Telekom",
    de: "5G NSA/SA Abdeckung Telekom"
  }
}), new Field({
  name: "twoGVodafone",
  type: Number,
  key: false,
  label: {
    en: "2G Coverage Vodafone",
    de: "2G Abdeckung Vodafone"
  }
}), new Field({
  name: "fourGVodafone",
  type: Number,
  key: false,
  label: {
    en: "4G Coverage Vodafone",
    de: "4G Abdeckung Vodafone"
  }
}), new Field({
  name: "fiveGDssVodafone",
  type: Number,
  key: false,
  label: {
    en: "5G DSS Coverage Vodafone",
    de: "5G DSS Abdeckung Vodafone"
  }
}), new Field({
  name: "fiveGNsaSaVodafone",
  type: Number,
  key: false,
  label: {
    en: "5G NSA/SA Coverage Vodafone",
    de: "5G NSA/SA Abdeckung Vodafone"
  }
})];
_CellularCoverage.relationships = [];
var CellularCoverage = _CellularCoverage;

// src/model/document.ts
var DocumentType = /* @__PURE__ */ ((DocumentType2) => {
  DocumentType2["unknown"] = "unknown";
  DocumentType2["photo"] = "photo";
  DocumentType2["report"] = "report";
  DocumentType2["invoice"] = "invoice";
  DocumentType2["receipt"] = "receipt";
  DocumentType2["contract"] = "contract";
  DocumentType2["proposal"] = "proposal";
  DocumentType2["memo"] = "memo";
  DocumentType2["letter"] = "letter";
  DocumentType2["manual"] = "manual";
  DocumentType2["presentation"] = "presentation";
  DocumentType2["spreadsheet"] = "spreadsheet";
  DocumentType2["form"] = "form";
  DocumentType2["whitepaper"] = "whitepaper";
  DocumentType2["article"] = "article";
  DocumentType2["resume"] = "resume";
  DocumentType2["certificate"] = "certificate";
  DocumentType2["policy"] = "policy";
  DocumentType2["agreement"] = "agreement";
  DocumentType2["checklist"] = "checklist";
  DocumentType2["budget"] = "budget";
  DocumentType2["businessPlan"] = "businessPlan";
  DocumentType2["caseStudy"] = "caseStudy";
  DocumentType2["datasheet"] = "datasheet";
  DocumentType2["guideline"] = "guideline";
  DocumentType2["pressRelease"] = "pressRelease";
  DocumentType2["researchPaper"] = "researchPaper";
  DocumentType2["strategyPlan"] = "strategyPlan";
  DocumentType2["trainingMaterial"] = "trainingMaterial";
  DocumentType2["auditReport"] = "auditReport";
  DocumentType2["meetingMinutes"] = "meetingMinutes";
  DocumentType2["presentationSlide"] = "presentationSlide";
  DocumentType2["userGuide"] = "userGuide";
  DocumentType2["faq"] = "faq";
  DocumentType2["brochure"] = "brochure";
  DocumentType2["advertisement"] = "advertisement";
  DocumentType2["announcement"] = "announcement";
  DocumentType2["email"] = "email";
  DocumentType2["newsletter"] = "newsletter";
  DocumentType2["statement"] = "statement";
  DocumentType2["legalNotice"] = "legalNotice";
  DocumentType2["termsAndConditions"] = "termsAndConditions";
  DocumentType2["privacyPolicy"] = "privacyPolicy";
  DocumentType2["codeOfConduct"] = "codeOfConduct";
  DocumentType2["warranty"] = "warranty";
  DocumentType2["referenceLetter"] = "referenceLetter";
  DocumentType2["jobDescription"] = "jobDescription";
  DocumentType2["workOrder"] = "workOrder";
  DocumentType2["quote"] = "quote";
  DocumentType2["caseReport"] = "caseReport";
  DocumentType2["survey"] = "survey";
  DocumentType2["testPlan"] = "testPlan";
  DocumentType2["incidentReport"] = "incidentReport";
  return DocumentType2;
})(DocumentType || {});
var DocumentTypeI18N = {
  en: {
    unknown: "Unknown",
    photo: "Photo",
    logo: "Logo",
    report: "Report",
    invoice: "Invoice",
    receipt: "Receipt",
    contract: "Contract",
    proposal: "Proposal",
    memo: "Memo",
    letter: "Letter",
    manual: "Manual",
    presentation: "Presentation",
    spreadsheet: "Spreadsheet",
    form: "Form",
    whitepaper: "Whitepaper",
    article: "Article",
    resume: "Resume",
    certificate: "Certificate",
    policy: "Policy",
    agreement: "Agreement",
    checklist: "Checklist",
    budget: "Budget",
    businessPlan: "BusinessPlan",
    caseStudy: "CaseStudy",
    datasheet: "Datasheet",
    guideline: "Guideline",
    pressRelease: "PressRelease",
    researchPaper: "ResearchPaper",
    strategyPlan: "StrategyPlan",
    trainingMaterial: "TrainingMaterial",
    auditReport: "AuditReport",
    meetingMinutes: "MeetingMinutes",
    presentationSlide: "PresentationSlide",
    userGuide: "UserGuide",
    faq: "Faq",
    brochure: "Brochure",
    advertisement: "Advertisement",
    announcement: "Announcement",
    email: "Email",
    newsletter: "Newsletter",
    statement: "Statement",
    legalNotice: "LegalNotice",
    termsAndConditions: "TermsAndConditions",
    privacyPolicy: "PrivacyPolicy",
    codeOfConduct: "CodeOfConduct",
    warranty: "Warranty",
    referenceLetter: "ReferenceLetter",
    jobDescription: "JobDescription",
    workOrder: "WorkOrder",
    quote: "Quote",
    caseReport: "CaseReport",
    survey: "Survey",
    testPlan: "TestPlan",
    incidentReport: "IncidentReport"
  },
  de: {
    unknown: "Unbekannt",
    report: "Bericht",
    photo: "Foto",
    logo: "Logo",
    invoice: "Rechnung",
    receipt: "Beleg",
    contract: "Vertrag",
    proposal: "Vorschlag",
    memo: "Notiz",
    letter: "Brief",
    manual: "Handbuch",
    presentation: "Pr\xE4sentation",
    spreadsheet: "Tabellenkalkulation",
    form: "Formular",
    whitepaper: "Whitepaper",
    article: "Artikel",
    resume: "Lebenslauf",
    certificate: "Zertifikat",
    policy: "Richtlinie",
    agreement: "Vereinbarung",
    checklist: "Checkliste",
    budget: "Budget",
    businessPlan: "Gesch\xE4ftsplan",
    caseStudy: "Fallstudie",
    datasheet: "Datenblatt",
    guideline: "Richtlinie",
    pressRelease: "Pressemitteilung",
    researchPaper: "Forschungsarbeit",
    strategyPlan: "Strategieplan",
    trainingMaterial: "Schulungsmaterial",
    auditReport: "Pr\xFCfbericht",
    meetingMinutes: "Sitzungsprotokoll",
    presentationSlide: "Pr\xE4sentationsfolie",
    userGuide: "Benutzerhandbuch",
    faq: "FAQ",
    brochure: "Brosch\xFCre",
    advertisement: "Werbung",
    announcement: "Ank\xFCndigung",
    email: "E-Mail",
    newsletter: "Newsletter",
    statement: "Erkl\xE4rung",
    legalNotice: "Rechtlicher Hinweis",
    termsAndConditions: "Allgemeine Gesch\xE4ftsbedingungen",
    privacyPolicy: "Datenschutzrichtlinie",
    codeOfConduct: "Verhaltenskodex",
    warranty: "Garantie",
    referenceLetter: "Empfehlungsschreiben",
    jobDescription: "Stellenbeschreibung",
    workOrder: "Arbeitsauftrag",
    quote: "Angebot",
    caseReport: "Fallbericht",
    survey: "Umfrage",
    testPlan: "Testplan",
    incidentReport: "Vorfallsbericht"
  }
};
var MIMEType = /* @__PURE__ */ ((MIMEType2) => {
  MIMEType2["unknown"] = "unknown";
  MIMEType2["textPlain"] = "text/plain";
  MIMEType2["textCSV"] = "text/csv";
  MIMEType2["imagePNG"] = "image/png";
  MIMEType2["imageJPEG"] = "image/jpeg";
  MIMEType2["imageSVG"] = "image/svg+xml";
  MIMEType2["applicationPDF"] = "application/pdf";
  MIMEType2["applicationMicrosoftExcel"] = "application/vnd.ms-excel";
  MIMEType2["applicationMicrosoftExcelOpenXML"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  MIMEType2["applicationMicrosoftPowerPoint"] = "application/vnd.ms-powerpoint";
  MIMEType2["applicationMicrosoftPowerPointOpenXML"] = "vnd.openxmlformats-officedocument.presentationml.presentation";
  MIMEType2["applicationMicrosoftWord"] = "application/msword";
  MIMEType2["applicationMicrosoftWordOpenXML"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  return MIMEType2;
})(MIMEType || {});
var _Document = class _Document extends Entity {
  constructor(props) {
    super(props);
    this.url = props.url;
    this.synopsis = props.synopsis;
  }
};
_Document.type = new EntityType({
  type: _Document,
  name: "Document",
  label: {
    en: "Document",
    de: "Dokument"
  }
});
_Document.fields = [
  new Field({
    name: "url",
    type: String,
    key: true,
    label: {
      en: "URL",
      de: "URL"
    }
  }),
  new Field({
    name: "synopsis",
    type: String,
    key: false,
    label: {
      en: "Synopsis",
      de: "Kurzfassung"
    }
  })
];
_Document.relationships = [];
var Document = _Document;
var _DocumentDetails = class _DocumentDetails extends Entity {
  constructor(props) {
    super(props);
    this.created = props.created ? new Date(props.created) : /* @__PURE__ */ new Date();
    this.lastModified = props.lastModified ? new Date(props.lastModified) : this.created;
    this.url = props.url;
    this.title = props.title;
    this.synopsis = props.synopsis;
    this.size = props.size || 0;
    this.documentType = props.documentType || "unknown" /* unknown */;
    this.mimeType = props.mimeType || "unknown" /* unknown */;
    this.tags = props.tags || [];
  }
};
_DocumentDetails.type = new EntityType({
  type: _DocumentDetails,
  name: "DocumentDetails",
  label: {
    en: "Document details",
    de: "Dokumentendetails"
  }
});
_DocumentDetails.fields = [new Field({
  name: "created",
  type: Date,
  key: false,
  label: {
    en: "Created",
    de: "Angelegt"
  }
}), new Field({
  name: "lastModified",
  type: Date,
  key: false,
  label: {
    en: "Last modified",
    de: "Zuletzt ge\xE4ndert"
  }
}), new Field({
  name: "url",
  type: String,
  key: true,
  label: {
    en: "URL",
    de: "URL"
  }
}), new Field({
  name: "synopsis",
  type: String,
  key: false,
  label: {
    en: "Synopsis",
    de: "Kurzfassung"
  }
}), new Field({
  name: "size",
  type: Number,
  key: false,
  label: {
    en: "Size",
    de: "Gr\xF6\xDFe"
  }
}), new Field({
  name: "documentType",
  type: DocumentType,
  key: false,
  label: {
    en: "Document type",
    de: "Dokumententyp"
  }
}), new Field({
  name: "mimeType",
  type: MIMEType,
  key: false,
  label: {
    en: "MIME type",
    de: "MIME-Typ"
  }
})];
_DocumentDetails.relationships = [];
var DocumentDetails = _DocumentDetails;

// src/model/building.ts
var _Site = class _Site extends Entity {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.street = props.street;
    this.streetNumber = props.streetNumber;
    this.postalCode = props.postalCode;
    this.city = props.city;
    this.country = props.country;
    this.buildings = props.buildings || [];
    this.floors = props.floors || [];
  }
};
_Site.type = new EntityType({
  type: _Site,
  name: "Site",
  label: {
    en: "Site",
    de: "Liegenschaft"
  }
});
_Site.fields = [new Field({
  name: "name",
  type: String,
  key: false
}), new Field({
  name: "street",
  type: String,
  key: false
}), new Field({
  name: "streetNumber",
  type: String,
  key: false
}), new Field({
  name: "postalCode",
  type: String,
  key: false
}), new Field({
  name: "city",
  type: String,
  key: false
}), new Field({
  name: "country",
  type: String,
  key: false
}), new Field({
  name: "buildings",
  type: JSON,
  key: false
}), new Field({
  name: "floor",
  type: JSON,
  key: false
})];
_Site.relationships = [];
var Site = _Site;
var _Building = class _Building extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id || `${props.address.street} ${props.address.streetNumber}, ${props.address.postalCode} ${props.address.city}, ${props.address.country}`;
    this.id_osm = props.id_osm;
    this.name = props.name;
    this.levels = props.levels;
    this.shape = props.shape || [];
    this.buildingType = props.buildingType;
    this.address = props.address ? new Address(props.address) : void 0;
    this.floors = props.floors ? props.floors.map((props2) => new Floor(props2)) : [];
    if (props.minLat && props.maxLat && props.minLon && props.maxLon) {
      this.minLat = props.minLat;
      this.maxLat = props.maxLat;
      this.minLon = props.minLon;
      this.maxLon = props.maxLon;
    } else {
      this.minLat = Number.MAX_SAFE_INTEGER;
      this.maxLat = Number.MIN_SAFE_INTEGER;
      this.minLon = Number.MAX_SAFE_INTEGER;
      this.maxLon = Number.MIN_SAFE_INTEGER;
      this.shape.forEach((point) => {
        this.minLat = Math.min(point.lat, this.minLat);
        this.maxLat = Math.max(point.lat, this.maxLat);
        this.minLon = Math.min(point.lon, this.minLon);
        this.maxLon = Math.max(point.lon, this.maxLon);
      });
    }
  }
};
_Building.type = new EntityType({
  public: true,
  type: _Building,
  name: "Building",
  label: {
    en: "Building",
    de: "Geb\xE4ude"
  }
});
_Building.fields = [new Field({
  name: "id",
  type: String,
  key: true
}), new Field({
  name: "id_osm",
  type: String,
  key: true
}), new Field({
  name: "name",
  type: String,
  key: false
}), new Field({
  name: "buildingType",
  type: String,
  key: false
}), new Field({
  name: "levels",
  type: Number,
  key: false
}), new Field({
  name: "shape",
  type: JSON,
  key: false
}), new Field({
  name: "minLat",
  type: Number,
  key: false
}), new Field({
  name: "maxLat",
  type: Number,
  key: false
}), new Field({
  name: "minLon",
  type: Number,
  key: false
}), new Field({
  name: "maxLon",
  type: Number,
  key: false
})];
_Building.relationships = [new Relationship({
  name: "address",
  type: Address,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Address",
    de: "Adresse"
  }
}), new Relationship({
  name: "floors",
  type: Entity,
  // Floor
  cardinality: "OneToMany" /* OneToMany */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "building",
  label: {
    en: "Floors",
    de: "Etagen"
  }
})];
var Building = _Building;
var FloorCategory = /* @__PURE__ */ ((FloorCategory2) => {
  FloorCategory2[FloorCategory2["Retail"] = 0] = "Retail";
  FloorCategory2[FloorCategory2["Residential"] = 1] = "Residential";
  FloorCategory2[FloorCategory2["Parking"] = 2] = "Parking";
  FloorCategory2[FloorCategory2["Commercial"] = 3] = "Commercial";
  FloorCategory2[FloorCategory2["Office"] = 4] = "Office";
  FloorCategory2[FloorCategory2["Mixed"] = 5] = "Mixed";
  return FloorCategory2;
})(FloorCategory || {});
var _Floor = class _Floor extends Entity {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.level = isNaN(props.level) ? 0 : Number(props.level);
    this.category = props.category;
    this.grossFloorArea = props.grossFloorArea;
    this.floorplanImageURI = props.floorplanImageURI;
    this.floorplanImageWidth = props.floorplanImageWidth;
    this.floorplanImageHeight = props.floorplanImageHeight;
    this.floorplanImageScale = props.floorplanImageScale;
    this.building = props.building ? new Building(props.building) : void 0;
    this.spaces = props.spaces ? props.spaces.map((props2) => new Space(props2)) : [];
  }
};
_Floor.type = new EntityType({
  public: false,
  type: _Floor,
  name: "Floor",
  label: {
    en: "Floor",
    de: "Etage"
  }
});
_Floor.fields = [new Field({
  name: "name",
  type: String,
  key: false
}), new Field({
  name: "level",
  type: Number,
  key: false
}), new Field({
  name: "category",
  type: FloorCategory,
  key: false
}), new Field({
  name: "grossFloorArea",
  type: Number,
  key: false
}), new Field({
  name: "floorplanImageURI",
  type: String,
  key: false
}), new Field({
  name: "floorplanImageWidth",
  type: Number,
  key: false
}), new Field({
  name: "floorplanImageHeight",
  type: Number,
  key: false
}), new Field({
  name: "floorplanImageScale",
  type: Number,
  key: false
})];
_Floor.relationships = [new Relationship({
  name: "building",
  type: Building,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "floors",
  label: {
    en: "Building",
    de: "Geb\xE4ude"
  }
}), new Relationship({
  name: "spaces",
  type: Entity,
  // Space
  cardinality: "OneToMany" /* OneToMany */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "floor",
  label: {
    en: "Spaces",
    de: "R\xE4ume"
  }
})];
var Floor = _Floor;
var SpaceCategory = /* @__PURE__ */ ((SpaceCategory2) => {
  SpaceCategory2[SpaceCategory2["Activity Based Working"] = 0] = "Activity Based Working";
  SpaceCategory2[SpaceCategory2["Airport lounge"] = 1] = "Airport lounge";
  SpaceCategory2[SpaceCategory2["Armory"] = 2] = "Armory";
  SpaceCategory2[SpaceCategory2["Attic"] = 3] = "Attic";
  SpaceCategory2[SpaceCategory2["Back room"] = 4] = "Back room";
  SpaceCategory2[SpaceCategory2["Ballroom"] = 5] = "Ballroom";
  SpaceCategory2[SpaceCategory2["Barn"] = 6] = "Barn";
  SpaceCategory2[SpaceCategory2["Bathroom"] = 7] = "Bathroom";
  SpaceCategory2[SpaceCategory2["Bedroom"] = 8] = "Bedroom";
  SpaceCategory2[SpaceCategory2["Boudoir"] = 9] = "Boudoir";
  SpaceCategory2[SpaceCategory2["Bower"] = 10] = "Bower";
  SpaceCategory2[SpaceCategory2["Box office"] = 11] = "Box office";
  SpaceCategory2[SpaceCategory2["Booth"] = 12] = "Booth";
  SpaceCategory2[SpaceCategory2["Burial chamber"] = 13] = "Burial chamber";
  SpaceCategory2[SpaceCategory2["Castle Chapel"] = 14] = "Castle Chapel";
  SpaceCategory2[SpaceCategory2["Canteen kitchen"] = 15] = "Canteen kitchen";
  SpaceCategory2[SpaceCategory2["Carrel"] = 16] = "Carrel";
  SpaceCategory2[SpaceCategory2["Changing room"] = 17] = "Changing room";
  SpaceCategory2[SpaceCategory2["Chapel"] = 18] = "Chapel";
  SpaceCategory2[SpaceCategory2["Chapter house"] = 19] = "Chapter house";
  SpaceCategory2[SpaceCategory2["Check room"] = 20] = "Check room";
  SpaceCategory2[SpaceCategory2["Children's room"] = 21] = "Children's room";
  SpaceCategory2[SpaceCategory2["Clean room"] = 22] = "Clean room";
  SpaceCategory2[SpaceCategory2["Closet"] = 23] = "Closet";
  SpaceCategory2[SpaceCategory2["Cloister cell"] = 24] = "Cloister cell";
  SpaceCategory2[SpaceCategory2["Communal laundry room"] = 25] = "Communal laundry room";
  SpaceCategory2[SpaceCategory2["Conference room"] = 26] = "Conference room";
  SpaceCategory2[SpaceCategory2["Corridor"] = 27] = "Corridor";
  SpaceCategory2[SpaceCategory2["Courtroom"] = 28] = "Courtroom";
  SpaceCategory2[SpaceCategory2["Cramming room"] = 29] = "Cramming room";
  SpaceCategory2[SpaceCategory2["Crypt"] = 30] = "Crypt";
  SpaceCategory2[SpaceCategory2["Darkroom"] = 31] = "Darkroom";
  SpaceCategory2[SpaceCategory2["Delivery room"] = 32] = "Delivery room";
  SpaceCategory2[SpaceCategory2["Dining room"] = 33] = "Dining room";
  SpaceCategory2[SpaceCategory2["Dirt sluice"] = 34] = "Dirt sluice";
  SpaceCategory2[SpaceCategory2["Dormitory"] = 35] = "Dormitory";
  SpaceCategory2[SpaceCategory2["Domestic study"] = 36] = "Domestic study";
  SpaceCategory2[SpaceCategory2["Drug consumption room"] = 37] = "Drug consumption room";
  SpaceCategory2[SpaceCategory2["Electrical operating room"] = 38] = "Electrical operating room";
  SpaceCategory2[SpaceCategory2["Escape room"] = 39] = "Escape room";
  SpaceCategory2[SpaceCategory2["Eat-in kitchen"] = 40] = "Eat-in kitchen";
  SpaceCategory2[SpaceCategory2["First aid room"] = 41] = "First aid room";
  SpaceCategory2[SpaceCategory2["Fitness room"] = 42] = "Fitness room";
  SpaceCategory2[SpaceCategory2["Foyer"] = 43] = "Foyer";
  SpaceCategory2[SpaceCategory2["Guest room"] = 44] = "Guest room";
  SpaceCategory2[SpaceCategory2["Hall"] = 45] = "Hall";
  SpaceCategory2[SpaceCategory2["Hallway"] = 46] = "Hallway";
  SpaceCategory2[SpaceCategory2["House connection room"] = 47] = "House connection room";
  SpaceCategory2[SpaceCategory2["Infirmary"] = 48] = "Infirmary";
  SpaceCategory2[SpaceCategory2["Interrogation room"] = 49] = "Interrogation room";
  SpaceCategory2[SpaceCategory2["Kitchen"] = 50] = "Kitchen";
  SpaceCategory2[SpaceCategory2["Ladies room"] = 51] = "Ladies room";
  SpaceCategory2[SpaceCategory2["Language lab"] = 52] = "Language lab";
  SpaceCategory2[SpaceCategory2["Laundry room"] = 53] = "Laundry room";
  SpaceCategory2[SpaceCategory2["Lecture room"] = 54] = "Lecture room";
  SpaceCategory2[SpaceCategory2["Living room"] = 55] = "Living room";
  SpaceCategory2[SpaceCategory2["Lobby"] = 56] = "Lobby";
  SpaceCategory2[SpaceCategory2["Loge"] = 57] = "Loge";
  SpaceCategory2[SpaceCategory2["Long-term visitors' room"] = 58] = "Long-term visitors' room";
  SpaceCategory2[SpaceCategory2["Lodging room"] = 59] = "Lodging room";
  SpaceCategory2[SpaceCategory2["Lounge"] = 60] = "Lounge";
  SpaceCategory2[SpaceCategory2["Master control room"] = 61] = "Master control room";
  SpaceCategory2[SpaceCategory2["Memorial room"] = 62] = "Memorial room";
  SpaceCategory2[SpaceCategory2["Men's room"] = 63] = "Men's room";
  SpaceCategory2[SpaceCategory2["Midwife's delivery room"] = 64] = "Midwife's delivery room";
  SpaceCategory2[SpaceCategory2["Music Room"] = 65] = "Music Room";
  SpaceCategory2[SpaceCategory2["Office"] = 66] = "Office";
  SpaceCategory2[SpaceCategory2["Open-plan office"] = 67] = "Open-plan office";
  SpaceCategory2[SpaceCategory2["Ossuary"] = 68] = "Ossuary";
  SpaceCategory2[SpaceCategory2["Panic room"] = 69] = "Panic room";
  SpaceCategory2[SpaceCategory2["Pantry"] = 70] = "Pantry";
  SpaceCategory2[SpaceCategory2["Parlor"] = 71] = "Parlor";
  SpaceCategory2[SpaceCategory2["Plenary room"] = 72] = "Plenary room";
  SpaceCategory2[SpaceCategory2["Powder room"] = 73] = "Powder room";
  SpaceCategory2[SpaceCategory2["Prison cell"] = 74] = "Prison cell";
  SpaceCategory2[SpaceCategory2["Protection room"] = 75] = "Protection room";
  SpaceCategory2[SpaceCategory2["Radio room"] = 76] = "Radio room";
  SpaceCategory2[SpaceCategory2["Rage room"] = 77] = "Rage room";
  SpaceCategory2[SpaceCategory2["Refectory"] = 78] = "Refectory";
  SpaceCategory2[SpaceCategory2["Rehearsal room"] = 79] = "Rehearsal room";
  SpaceCategory2[SpaceCategory2["Ripping floor"] = 80] = "Ripping floor";
  SpaceCategory2[SpaceCategory2["Safety cell"] = 81] = "Safety cell";
  SpaceCategory2[SpaceCategory2["Scriptorium"] = 82] = "Scriptorium";
  SpaceCategory2[SpaceCategory2["Shock room"] = 83] = "Shock room";
  SpaceCategory2[SpaceCategory2["Sky Lobby"] = 84] = "Sky Lobby";
  SpaceCategory2[SpaceCategory2["Smoking cabin"] = 85] = "Smoking cabin";
  SpaceCategory2[SpaceCategory2["Smoking chamber"] = 86] = "Smoking chamber";
  SpaceCategory2[SpaceCategory2["Smoking room"] = 87] = "Smoking room";
  SpaceCategory2[SpaceCategory2["Soft cell"] = 88] = "Soft cell";
  SpaceCategory2[SpaceCategory2["Staff room"] = 89] = "Staff room";
  SpaceCategory2[SpaceCategory2["Staircase"] = 90] = "Staircase";
  SpaceCategory2[SpaceCategory2["Television room"] = 91] = "Television room";
  SpaceCategory2[SpaceCategory2["Tower room"] = 92] = "Tower room";
  SpaceCategory2[SpaceCategory2["TV room"] = 93] = "TV room";
  SpaceCategory2[SpaceCategory2["Utility room"] = 94] = "Utility room";
  SpaceCategory2[SpaceCategory2["Vestibule"] = 95] = "Vestibule";
  SpaceCategory2[SpaceCategory2["Waiting room"] = 96] = "Waiting room";
  SpaceCategory2[SpaceCategory2["Warming room"] = 97] = "Warming room";
  SpaceCategory2[SpaceCategory2["Wedding room"] = 98] = "Wedding room";
  return SpaceCategory2;
})(SpaceCategory || {});
var _Space = class _Space extends Entity {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.longName = props.longName;
    this.color = props.color;
    this.category = props.category;
    this.shape = props.shape || [];
    this.floor = props.floor ? new Floor(props.floor) : void 0;
  }
};
_Space.type = new EntityType({
  public: false,
  type: _Space,
  name: "Space",
  label: {
    en: "Space",
    de: "Raum"
  }
});
_Space.fields = [new Field({
  name: "name",
  type: String,
  key: false
}), new Field({
  name: "longName",
  type: String,
  key: false
}), new Field({
  name: "color",
  type: String,
  key: false
}), new Field({
  name: "category",
  type: SpaceCategory,
  key: false
}), new Field({
  name: "shape",
  type: JSON,
  key: false
})];
_Space.relationships = [new Relationship({
  name: "floor",
  type: Floor,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "spaces",
  label: {
    en: "Floor",
    de: "Etage"
  }
})];
var Space = _Space;
var _Unit = class _Unit extends Entity {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.grossFloorArea = props.grossFloorArea;
    this.building = props.building;
  }
};
_Unit.type = new EntityType({
  public: true,
  type: _Unit,
  name: "Unit",
  label: {
    en: "Unit",
    de: "Einheit"
  }
});
_Unit.fields = [new Field({
  name: "name",
  type: String,
  key: false
}), new Field({
  name: "grossFloorArea",
  type: Number,
  key: false
})];
_Unit.relationships = [new Relationship({
  name: "building",
  type: Building,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "units",
  label: {
    en: "Building",
    de: "Geb\xE4ude"
  }
})];
var Unit = _Unit;
var _Lease = class _Lease extends Entity {
  constructor(props) {
    super(props);
    this.startDate = new Date(props.startDate);
    this.duration = Number(props.duration).valueOf();
    this.contract = new Document({
      url: props.contract.url,
      synopsis: props.contract.synopsis
    }), this.unit = new Unit({
      name: props.unit.name,
      grossFloorArea: props.unit.grossFloorArea,
      building: new Building({
        address: new Address({
          street: props.unit.building.address.street,
          streetNumber: props.unit.building.address.streetNumber,
          postalCode: props.unit.building.address.postalCode,
          city: props.unit.building.address.city,
          country: props.unit.building.address.country
        })
      })
    });
    this.landlord = new NaturalPerson(props.landlord);
    this.tenant = new NaturalPerson(props.tenant);
  }
};
_Lease.type = new EntityType({
  public: false,
  type: _Lease,
  name: "Lease",
  label: {
    en: "Lease",
    de: "Mietverh\xE4ltnis"
  }
});
_Lease.fields = [new Field({
  name: "startDate",
  type: Date,
  key: false
}), new Field({
  name: "duration",
  type: Number,
  key: false
})];
_Lease.relationships = [new Relationship({
  name: "contract",
  type: Document,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Contract",
    de: "Vertrag"
  }
}), new Relationship({
  name: "unit",
  type: Unit,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "leases",
  label: {
    en: "Unit",
    de: "Einheit"
  },
  inverseLabel: {
    en: "Leases",
    de: "Vermietungen"
  }
}), new Relationship({
  name: "tenant",
  type: NaturalPerson,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Tenant",
    de: "Mieter"
  }
}), new Relationship({
  name: "landlord",
  type: NaturalPerson,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Landlord",
    de: "Vermieter"
  }
})];
var Lease = _Lease;
var CityObjectType = /* @__PURE__ */ ((CityObjectType2) => {
  CityObjectType2["building"] = "building";
  return CityObjectType2;
})(CityObjectType || {});
var RoofType = /* @__PURE__ */ ((RoofType2) => {
  RoofType2["bla"] = "1000";
  return RoofType2;
})(RoofType || {});
var _CityObjectLoD2 = class _CityObjectLoD2 extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.type = props.type;
    this.tileOffsetX = props.tileOffsetX;
    this.tileOffsetY = props.tileOffsetY;
    this.minLat = props.minLat;
    this.minLon = props.minLon;
    this.maxLat = props.maxLat;
    this.maxLon = props.maxLon;
    this.creationDate = new Date(props.creationDate);
    this.localGovernmentKey = props.localGovernmentKey;
    this.dataSourceRoofHeight = props.dataSourceRoofHeight;
    this.geometryType2DReference = props.geometryType2DReference;
    this.datasourceLocation = props.datasourceLocation;
    this.datasourceFloorHeight = props.datasourceFloorHeight;
    this.floorPlanUpdated = new Date(props.floorPlanUpdated);
    this.measuredHeight = props.measuredHeight;
    this.functionType = props.functionType;
    this.roofType = props.roofType;
    this.geometry = props.geometry;
  }
};
_CityObjectLoD2.type = new EntityType({
  public: false,
  type: _CityObjectLoD2,
  name: "CityObjectLoD2",
  label: {
    en: "City Object LoD2",
    de: "Stadt-Objekt LoD2"
  }
});
_CityObjectLoD2.fields = [new Field({
  name: "id",
  type: String,
  key: true
}), new Field({
  name: "type",
  type: CityObjectType,
  key: false
}), new Field({
  name: "tileOffsetX",
  type: Number,
  key: false
}), new Field({
  name: "tileOffsetY",
  type: Number,
  key: false
}), new Field({
  name: "minLat",
  type: Number,
  key: false
}), new Field({
  name: "minLon",
  type: Number,
  key: false
}), new Field({
  name: "maxLat",
  type: Number,
  key: false
}), new Field({
  name: "maxLon",
  type: Number,
  key: false
}), new Field({
  name: "creationDate",
  type: Date,
  key: false
}), new Field({
  name: "localGovernmentKey",
  type: String,
  key: false
}), new Field({
  name: "dataSourceRoofHeight",
  type: String,
  key: false
}), new Field({
  name: "geometryType2DReference",
  type: String,
  key: false
}), new Field({
  name: "datasourceLocation",
  type: String,
  key: false
}), new Field({
  name: "datasourceFloorHeight",
  type: String,
  key: false
}), new Field({
  name: "floorPlanUpdated",
  type: Date,
  key: false
}), new Field({
  name: "measuredHeight",
  type: Number,
  key: false
}), new Field({
  name: "functionType",
  type: String,
  key: false
}), new Field({
  name: "roofType",
  type: RoofType,
  key: false
}), new Field({
  name: "geometry",
  type: JSON,
  key: false
})];
_CityObjectLoD2.relationships = [];
var CityObjectLoD2 = _CityObjectLoD2;
var _TransformLoD2 = class _TransformLoD2 extends Entity {
  constructor(props) {
    super(props);
    this.tileOffsetX = props.tileOffsetX;
    this.tileOffsetY = props.tileOffsetY;
    this.scale = props.scale;
    this.translate = props.translate;
  }
};
_TransformLoD2.type = new EntityType({
  public: false,
  type: _TransformLoD2,
  name: "TransformLoD2",
  label: {
    en: "TransformLoD2",
    de: "Transformation LoD2"
  }
});
_TransformLoD2.fields = [new Field({
  name: "tileOffsetX",
  type: Number,
  key: true
}), new Field({
  name: "tileOffsetY",
  type: Number,
  key: true
}), new Field({
  name: "scale",
  type: JSON,
  key: false
}), new Field({
  name: "translate",
  type: JSON,
  key: false
})];
_TransformLoD2.relationships = [];
var TransformLoD2 = _TransformLoD2;
var _VerticesLoD2 = class _VerticesLoD2 extends Entity {
  constructor(props) {
    super(props);
    this.tileOffsetX = props.tileOffsetX;
    this.tileOffsetY = props.tileOffsetY;
    this.vertices = props.vertices;
  }
};
_VerticesLoD2.type = new EntityType({
  public: false,
  type: _VerticesLoD2,
  name: "VerticesLoD2",
  label: {
    en: "VerticesLoD2",
    de: "Ecken LoD2"
  }
});
_VerticesLoD2.fields = [new Field({
  name: "tileOffsetX",
  type: Number,
  key: true
}), new Field({
  name: "tileOffsetY",
  type: Number,
  key: true
}), new Field({
  name: "vertices",
  type: JSON,
  key: false
})];
_VerticesLoD2.relationships = [];
var VerticesLoD2 = _VerticesLoD2;
var _MetadataLoD2 = class _MetadataLoD2 extends Entity {
  constructor(props) {
    super(props);
    this.tileOffsetX = props.tileOffsetX;
    this.tileOffsetY = props.tileOffsetY;
    this.geographicalExtent = props.geographicalExtent;
  }
};
_MetadataLoD2.type = new EntityType({
  public: false,
  type: _MetadataLoD2,
  name: "MetadataLoD2",
  label: {
    en: "Metadata LoD2",
    de: "Metadaten LoD2"
  }
});
_MetadataLoD2.fields = [new Field({
  name: "tileOffsetX",
  type: Number,
  key: true
}), new Field({
  name: "tileOffsetY",
  type: Number,
  key: true
}), new Field({
  name: "geographicalExtent",
  type: JSON,
  key: false
})];
_MetadataLoD2.relationships = [];
var MetadataLoD2 = _MetadataLoD2;

// src/model/asset.ts
var AssetSchema = /* @__PURE__ */ ((AssetSchema2) => {
  AssetSchema2["din276"] = "din276";
  return AssetSchema2;
})(AssetSchema || {});
var OperatingState = /* @__PURE__ */ ((OperatingState2) => {
  OperatingState2[OperatingState2["normal"] = 0] = "normal";
  OperatingState2[OperatingState2["warning"] = 1] = "warning";
  OperatingState2[OperatingState2["critical"] = 2] = "critical";
  OperatingState2[OperatingState2["maintenance"] = 3] = "maintenance";
  OperatingState2[OperatingState2["decommisioned"] = 4] = "decommisioned";
  OperatingState2[OperatingState2["unknown"] = -1] = "unknown";
  return OperatingState2;
})(OperatingState || {});
var _Asset = class _Asset extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.name = props.name;
    this.schema = props.schema;
    this.schemaCategory = props.schemaCategory;
    this.icon = props.icon;
    this.properties = props.properties;
    this.registeredBy = props.registeredBy;
    this.registered = props.registered ? new Date(props.registered) : void 0;
    this.lastModifiedBy = props.lastModifiedBy || props.registeredBy;
    this.lastModified = props.lastModified ? new Date(props.lastModified) : this.registered;
    this.installed = props.installed ? new Date(props.installed) : void 0;
    this.lastMaintained = props.lastMaintained ? new Date(props.lastMaintained) : void 0;
    this.nextMaintenance = props.nextMaintenance ? new Date(props.nextMaintenance) : void 0;
    this.lastChecked = props.lastChecked ? new Date(props.lastChecked) : void 0;
    this.nextCheck = props.nextCheck ? new Date(props.nextCheck) : void 0;
    this.maintenanceInterval = props.maintenanceInterval;
    this.details = props.details;
    this.latitude = props.latitude;
    this.longitude = props.longitude;
    this.street = props.street;
    this.streetNumber = props.streetNumber;
    this.postalCode = props.postalCode;
    this.city = props.city;
    this.country = props.country;
    this.photos = props.photos ? props.photos : [];
    this.image = props.image;
    this.mountingImage = props.mountingImage;
    this.typePlateImage = props.typePlateImage;
    this.productName = props.productName;
    this.product = props.product;
    this.manufacturerName = props.manufacturerName;
    this.iotGateway = props.iotGateway;
    this.iotDeviceType = props.iotDeviceType;
    this.iotConfiguration = props.iotConfiguration;
    this.floor = props.floor;
    this.x = props.x;
    this.y = props.y;
  }
};
_Asset.type = new EntityType({
  type: _Asset,
  name: "Asset",
  label: {
    en: "Asset",
    de: "Ger\xE4t"
  }
});
_Asset.fields = [new Field({
  name: "id",
  type: String,
  key: true,
  label: {
    en: "ID",
    de: "ID"
  }
}), new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "schema",
  type: AssetSchema,
  key: false,
  label: {
    en: "Schema",
    de: "Schema"
  }
}), new Field({
  name: "schemaCategory",
  type: String,
  key: false,
  label: {
    en: "Category",
    de: "Kategorie"
  }
}), new Field({
  name: "icon",
  type: String,
  key: false,
  label: {
    en: "Icon",
    de: "Icon"
  }
}), new Field({
  name: "registeredBy",
  type: String,
  key: false,
  label: {
    en: "Registered by",
    de: "Registriert von"
  }
}), new Field({
  name: "registered",
  type: Date,
  key: false,
  label: {
    en: "Registered",
    de: "Registriert"
  }
}), new Field({
  name: "lastModifiedBy",
  type: String,
  key: false,
  label: {
    en: "Last modified by",
    de: "Zuletzt ge\xE4ndert von"
  }
}), new Field({
  name: "lastModified",
  type: Date,
  key: false,
  label: {
    en: "Last modified",
    de: "Zuletzt ge\xE4ndert"
  }
}), new Field({
  name: "installed",
  type: Date,
  key: false,
  label: {
    en: "Installed",
    de: "Installiert"
  }
}), new Field({
  name: "lastMaintained",
  type: Date,
  key: false,
  label: {
    en: "Last Maintenance",
    de: "Letzte Wartung"
  }
}), new Field({
  name: "nextMaintenance",
  type: Date,
  key: false,
  label: {
    en: "Next Maintenance",
    de: "N\xE4chste Wartung"
  }
}), new Field({
  name: "lastChecked",
  type: Date,
  key: false,
  label: {
    en: "Last Check",
    de: "Letzte Pr\xFCfung"
  }
}), new Field({
  name: "nextCheck",
  type: Date,
  key: false,
  label: {
    en: "Next Check",
    de: "N\xE4chste Pr\xFCfung"
  }
}), new Field({
  name: "maintenanceInterval",
  type: Number,
  key: false,
  label: {
    en: "Maintenance Interval",
    de: "Letzte Wartung"
  }
}), new Field({
  name: "details",
  type: String,
  key: false,
  label: {
    en: "Details",
    de: "Details"
  }
}), new Field({
  name: "properties",
  type: JSON,
  key: false,
  label: {
    en: "Properties",
    de: "Eigenschaften"
  }
}), new Field({
  name: "latitude",
  type: Number,
  key: false,
  label: {
    en: "Latitude",
    de: "Breitendgrad"
  }
}), new Field({
  name: "longitude",
  type: Number,
  key: false,
  label: {
    en: "Longitude",
    de: "L\xE4ngengrad"
  }
}), new Field({
  name: "street",
  type: String,
  key: false,
  label: {
    en: "Street",
    de: "Stra\xDFe"
  }
}), new Field({
  name: "streetNumber",
  type: String,
  key: false,
  label: {
    en: "Street Number",
    de: "Hausnummer"
  }
}), new Field({
  name: "postalCode",
  type: String,
  key: false,
  label: {
    en: "Postal Code",
    de: "Postleitzahl"
  }
}), new Field({
  name: "city",
  type: String,
  key: false,
  label: {
    en: "City",
    de: "Ort"
  }
}), new Field({
  name: "country",
  type: String,
  key: false,
  label: {
    en: "Country",
    de: "Land"
  }
}), new Field({
  name: "photos",
  type: ImageList,
  key: false,
  label: {
    en: "Photos",
    de: "Fotos"
  }
}), new Field({
  name: "image",
  type: Image,
  key: false,
  label: {
    en: "Photo",
    de: "Foto"
  }
}), new Field({
  name: "mountingImage",
  type: Image,
  key: false,
  label: {
    en: "Mounting Photo",
    de: "Montagefoto"
  }
}), new Field({
  name: "typePlateImage",
  type: Image,
  key: false,
  label: {
    en: "Type Plate",
    de: "Typenschild"
  }
}), new Field({
  name: "productName",
  type: String,
  key: false,
  label: {
    en: "Product Name",
    de: "Produktname"
  }
}), new Field({
  name: "product",
  type: String,
  key: false,
  label: {
    en: "Product ID",
    de: "Produkt-ID"
  }
}), new Field({
  name: "manufacturerName",
  type: String,
  key: false,
  label: {
    en: "Manufacturer Name",
    de: "Herstellername"
  }
}), new Field({
  name: "iotGateway",
  type: String,
  key: false,
  label: {
    en: "IoT-Gateway",
    de: "IoT-Gateway"
  }
}), new Field({
  name: "iotDeviceType",
  type: String,
  key: false,
  label: {
    en: "IoT Device Type",
    de: "IoT-Ger\xE4tetyp"
  }
}), new Field({
  name: "iotConfiguration",
  type: JSON,
  key: false,
  label: {
    en: "IoT Configuration",
    de: "IoT-Konfiguration"
  }
}), new Field({
  name: "floor",
  type: String,
  key: false,
  label: {
    en: "Floor",
    de: "Etage"
  }
}), new Field({
  name: "x",
  type: Number,
  key: false,
  label: {
    en: "x",
    de: "x"
  }
}), new Field({
  name: "y",
  type: Number,
  key: false,
  label: {
    en: "y",
    de: "y"
  }
})];
_Asset.relationships = [new Relationship({
  name: "address",
  type: Address,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Address",
    de: "Adresse"
  }
}), new Relationship({
  name: "holder",
  type: LegalPerson,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Holder",
    de: "Eigent\xFCmer"
  }
})];
var Asset = _Asset;

// src/model/businessRule.ts
var ConditionType = /* @__PURE__ */ ((ConditionType2) => {
  ConditionType2["Comparison"] = "Comparison";
  ConditionType2["AndCondition"] = "AndCondition";
  ConditionType2["OrCondition"] = "OrCondition";
  return ConditionType2;
})(ConditionType || {});
var Condition = class {
  static unmarshal(properties) {
    switch (properties.conditionType) {
      case "AndCondition" /* AndCondition */:
        return new AndCondition(properties);
      case "OrCondition" /* OrCondition */:
        return new OrCondition(properties);
      case "Comparison" /* Comparison */:
      default:
        return new ComparisonCondition(properties);
    }
  }
  constructor(conditionType) {
    this.conditionType = conditionType;
  }
};
var ComparisonOperator = /* @__PURE__ */ ((ComparisonOperator2) => {
  ComparisonOperator2["equal"] = "equal";
  ComparisonOperator2["less"] = "less";
  ComparisonOperator2["lessEqual"] = "lessEqual";
  ComparisonOperator2["greater"] = "greater";
  ComparisonOperator2["greaterEqual"] = "greaterEqual";
  return ComparisonOperator2;
})(ComparisonOperator || {});
var ComparisonType = /* @__PURE__ */ ((ComparisonType2) => {
  ComparisonType2["field"] = "field";
  ComparisonType2["value"] = "value";
  return ComparisonType2;
})(ComparisonType || {});
var ComparisonCondition = class extends Condition {
  constructor(properties = { operator: "greater" /* greater */, comparisonType: "value" /* value */ }) {
    super("Comparison" /* Comparison */);
    this.field = properties.field;
    this.operator = properties.operator;
    this.comparisonType = properties.comparisonType;
    this.comparisonField = properties.comparisonField;
    this.comparisonValue = properties.comparisonValue;
  }
  check(measurement) {
    if (measurement.metric !== this.field || measurement.value === void 0) {
      return false;
    }
    const value = this.comparisonValue;
    if (this.operator === "equal" /* equal */) {
      if (typeof value === "string") {
        return measurement.value === Number(value);
      } else {
        return measurement.value === Number(value);
      }
    } else if (this.operator === "less" /* less */) {
      if (typeof value === "string") {
        return measurement.value.toString().localeCompare(value) < 0;
      } else {
        return Number(measurement.value) < Number(value);
      }
    } else if (this.operator === "lessEqual" /* lessEqual */) {
      if (typeof value === "string") {
        return measurement.value.toString().localeCompare(value) <= 0;
      } else {
        return Number(measurement.value) <= Number(value);
      }
    } else if (this.operator === "greater" /* greater */) {
      if (typeof value === "string") {
        return measurement.value.toString().localeCompare(value) > 0;
      } else {
        return Number(measurement.value) > Number(value);
      }
    } else if (this.operator === "greaterEqual" /* greaterEqual */) {
      if (typeof value === "string") {
        return measurement.value.toString().localeCompare(value) >= 1;
      } else {
        return Number(measurement.value) >= Number(value);
      }
    }
    return false;
  }
  isCompletelyDefined() {
    return !!this.field && this.field.trim().length > 0 && this.comparisonValue !== void 0;
  }
};
var ConjunctionCondition = class extends Condition {
  constructor(type, properties = { conditions: [] }) {
    super(type);
    this.conditions = properties.conditions;
  }
  isCompletelyDefined() {
    return this.conditions && this.conditions.length > 0;
  }
};
var AndCondition = class extends ConjunctionCondition {
  constructor(properties = { conditions: [] }) {
    super("AndCondition" /* AndCondition */, properties);
  }
  check(measurement) {
    for (const condition of this.conditions) {
      if (!condition.check(measurement)) {
        return false;
      }
    }
    return true;
  }
};
var OrCondition = class extends ConjunctionCondition {
  constructor(properties = { conditions: [] }) {
    super("OrCondition" /* OrCondition */, properties);
  }
  check(measurement) {
    for (const condition of this.conditions) {
      if (condition.check(measurement)) {
        return true;
      }
    }
    return false;
  }
};
var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["EmailNotification"] = "EmailNotification";
  ActionType2["SMSNotification"] = "SMSNotification";
  return ActionType2;
})(ActionType || {});
var Action = class {
  static unmarshal(properties) {
    switch (properties.actionType) {
      case "SMSNotification" /* SMSNotification */:
        return new SMSNotification(properties);
      case "EmailNotification" /* EmailNotification */:
      default:
        return new EmailNotification(properties);
    }
  }
  constructor(actionType) {
    this.actionType = actionType;
  }
};
var EmailNotification = class extends Action {
  constructor(properties) {
    super("EmailNotification" /* EmailNotification */);
    this.to = properties.to;
    this.cc = properties.cc;
    this.bcc = properties.bcc;
    this.subject = properties.subject;
    this.content = properties.content;
  }
  isCompletelyDefined() {
    return !!this.to && this.to.trim().length > 0 && !!this.subject && this.subject.trim().length > 0 && !!this.content && this.content.trim().length > 0;
  }
};
var SMSNotification = class extends Action {
  constructor(properties) {
    super("SMSNotification" /* SMSNotification */);
    this.phoneNumber = properties.phoneNumber;
    this.content = properties.content;
  }
  isCompletelyDefined() {
    return !!this.phoneNumber && this.phoneNumber.trim().length > 0 && !!this.content && this.content.trim().length > 0;
  }
};
var BusinessRuleRuntimeStatus = /* @__PURE__ */ ((BusinessRuleRuntimeStatus2) => {
  BusinessRuleRuntimeStatus2["unknown"] = "unknown";
  BusinessRuleRuntimeStatus2["running"] = "running";
  BusinessRuleRuntimeStatus2["stopped"] = "stopped";
  BusinessRuleRuntimeStatus2["interrupted"] = "interrupted";
  return BusinessRuleRuntimeStatus2;
})(BusinessRuleRuntimeStatus || {});
var _BusinessRule = class _BusinessRule extends Entity {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.description = props.description;
    this.conditions = props.conditions ? props.conditions.map((condition) => Condition.unmarshal(condition)) : [];
    this.actions = props.actions ? props.actions.map((action) => Action.unmarshal(action)) : [];
    this.products = props.products || [];
    this.projects = props.projects || [];
    this.status = props.status || "unknown" /* unknown */;
    this.activation = props.activation;
    this.lastCheck = props.lastCheck;
    this.lastExecution = props.lastExecution;
  }
  check(measurement) {
    for (const condition of this.conditions) {
      if (condition.check(measurement)) {
        return true;
      }
    }
    return false;
  }
};
_BusinessRule.type = new EntityType({
  public: false,
  type: _BusinessRule,
  name: "BusinessRule",
  label: {
    en: "Business Rule",
    de: "Gesch\xE4ftsregel"
  }
});
_BusinessRule.fields = [new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "description",
  type: String,
  key: false,
  label: {
    en: "Description",
    de: "Beschreibung"
  }
}), new Field({
  name: "conditions",
  type: JSON,
  key: false,
  label: {
    en: "Conditions",
    de: "Bedingungen"
  }
}), new Field({
  name: "actions",
  type: JSON,
  key: false,
  label: {
    en: "Actions",
    de: "Aktionen"
  }
}), new Field({
  name: "products",
  type: JSON,
  key: false,
  label: {
    en: "Products",
    de: "Produkte"
  }
}), new Field({
  name: "projects",
  type: JSON,
  key: false,
  label: {
    en: "Projects",
    de: "Projekte"
  }
}), new Field({
  name: "businessRule",
  type: String,
  key: true,
  label: {
    en: "Business Rule",
    de: "Gesch\xE4ftsregel"
  }
}), new Field({
  name: "status",
  type: BusinessRuleRuntimeStatus,
  key: false,
  label: {
    en: "Status",
    de: "Status"
  }
}), new Field({
  name: "activation",
  type: Date,
  key: false,
  label: {
    en: "Activation",
    de: "Aktivierung"
  }
}), new Field({
  name: "lastCheck",
  type: Date,
  key: false,
  label: {
    en: "Last Check",
    de: "Letzte Pr\xFCfung"
  }
}), new Field({
  name: "lastExecution",
  type: Date,
  key: false,
  label: {
    en: "Last Execution",
    de: "Letzte Ausf\xFChrung"
  }
})];
_BusinessRule.relationships = [];
var BusinessRule = _BusinessRule;

// src/model/product.ts
var _Product = class _Product extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.name = props.name;
    this.description = props.description;
    this.schema = props.schema;
    this.schemaCategory = props.schemaCategory;
    this.telemetry = props.telemetry;
    this.warningConditions = props.warningConditions ? props.warningConditions.map((condition) => Condition.unmarshal(condition)) : [];
    this.criticalConditions = props.criticalConditions ? props.criticalConditions.map((condition) => Condition.unmarshal(condition)) : [];
    this.manual = props.manual ? new Document({
      url: props.manual.url,
      synopsis: props.manual.synopsis
    }) : void 0;
    this.manufacturer = props.manufacturer ? new LegalPerson(props.manufacturer) : void 0;
    this.approvals = props.approvals ? props.approvals.map((approval) => new ProductApproval(approval)) : [];
  }
};
_Product.type = new EntityType({
  public: true,
  type: _Product,
  name: "Product",
  label: {
    en: "Product",
    de: "Produkt"
  }
});
_Product.fields = [new Field({
  name: "id",
  type: String,
  key: true,
  label: {
    en: "ID",
    de: "ID"
  }
}), new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "description",
  type: String,
  key: false,
  label: {
    en: "Description",
    de: "Beschreibung"
  }
}), new Field({
  name: "schema",
  type: String,
  key: false,
  label: {
    en: "Schema",
    de: "Schema"
  }
}), new Field({
  name: "schemaCategory",
  type: String,
  key: false,
  label: {
    en: "Category",
    de: "Kategorie"
  }
}), new Field({
  name: "telemetry",
  type: JSON,
  key: false,
  label: {
    en: "Telemetry",
    de: "Telemetrie"
  }
}), new Field({
  name: "warningConditions",
  type: JSON,
  key: false,
  label: {
    en: "Warning Conditions",
    de: "Bedingungen Warnung"
  }
}), new Field({
  name: "criticalConditions",
  type: JSON,
  key: false,
  label: {
    en: "Critical Conditions",
    de: "Kritische Bedingungen"
  }
})];
_Product.relationships = [new Relationship({
  name: "manual",
  type: Document,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Manual",
    de: "Handbuch"
  }
}), new Relationship({
  name: "manufacturer",
  type: LegalPerson,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "products",
  label: {
    en: "Manufacturer",
    de: "Hersteller"
  },
  inverseLabel: {
    en: "Products",
    de: "Produkte"
  }
}), new Relationship({
  name: "approvals",
  type: Entity,
  // ProductApproval
  cardinality: "OneToMany" /* OneToMany */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "product",
  label: {
    en: "Approvals",
    de: "Zulassungen"
  },
  inverseLabel: {
    en: "Product",
    de: "Produkt"
  }
})];
var Product = _Product;
var _ProductApproval = class _ProductApproval extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.issuer = props.issuer;
    this.issuedOn = props.issuedOn ? new Date(props.issuedOn) : void 0;
    this.notification = props.notification ? new Document({
      url: props.notification.url,
      synopsis: props.notification.synopsis
    }) : void 0;
    this.product = props.product ? new Product(props.product) : void 0;
  }
};
_ProductApproval.type = new EntityType({
  public: true,
  type: _ProductApproval,
  name: "ProductApproval",
  label: {
    en: "Product Approval",
    de: "Produktzulassung"
  }
});
_ProductApproval.fields = [new Field({
  name: "id",
  type: String,
  key: true,
  label: {
    en: "ID",
    de: "ID"
  }
}), new Field({
  name: "issuer",
  type: String,
  key: false,
  label: {
    en: "Issuer",
    de: "Erteilt von"
  }
}), new Field({
  name: "issuedOn",
  type: Date,
  key: false,
  label: {
    en: "Issued on",
    de: "Erteilt am"
  }
}), new Field({
  name: "validTo",
  type: Date,
  key: false,
  label: {
    en: "Valid to",
    de: "G\xFCltig bis"
  }
})];
_ProductApproval.relationships = [new Relationship({
  name: "product",
  type: Product,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "approvals",
  label: {
    en: "Product",
    de: "Produkt"
  },
  inverseLabel: {
    en: "Approvals",
    de: "Zulassungen"
  }
}), new Relationship({
  name: "notification",
  type: Document,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Notification",
    de: "Bescheid"
  }
})];
var ProductApproval = _ProductApproval;

// src/model/user.ts
var PasswordStatus = /* @__PURE__ */ ((PasswordStatus2) => {
  PasswordStatus2["change"] = "change";
  PasswordStatus2["permanent"] = "permanent";
  return PasswordStatus2;
})(PasswordStatus || {});
var UserState = /* @__PURE__ */ ((UserState2) => {
  UserState2["inRegistration"] = "inRegistration";
  UserState2["active"] = "active";
  UserState2["inactive"] = "inactive";
  return UserState2;
})(UserState || {});
var _User = class _User extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.customer = props.customer;
    this.state = props.state || "inRegistration" /* inRegistration */;
    this.email = props.email;
    this.created = props.created;
    this.passwordHash = props.passwordHash;
    this.passwordStatus = props.passwordStatus;
    this.otp = props.otp;
    this.mobileNumber = props.mobileNumber;
    this.firstName = props.firstName;
    this.lastName = props.lastName;
    this.roles = props.roles || [];
    this.photo = props.photo;
    this.roleAssignments = props.roleAssignments || [];
  }
};
_User.type = new EntityType({
  public: false,
  type: _User,
  name: "User",
  label: {
    en: "User",
    de: "Nutzer"
  }
});
_User.fields = [new Field({
  name: "id",
  type: String,
  key: true
}), new Field({
  name: "customer",
  type: String,
  key: false
}), new Field({
  name: "state",
  type: UserState,
  key: false
}), new Field({
  name: "email",
  type: String,
  key: true
}), new Field({
  name: "created",
  type: Date,
  key: false
}), new Field({
  name: "passwordHash",
  type: String,
  key: false
}), new Field({
  name: "passwordStatus",
  type: PasswordStatus,
  key: false
}), new Field({
  name: "otp",
  type: String,
  key: false
}), new Field({
  name: "mobileNumber",
  type: String,
  key: false
}), new Field({
  name: "firstName",
  type: String,
  key: false
}), new Field({
  name: "lastName",
  type: String,
  key: false
}), new Field({
  name: "roles",
  type: JSON,
  key: false
}), new Field({
  name: "photo",
  type: Image,
  key: false
})];
_User.relationships = [new Relationship({
  name: "roleAssignments",
  type: Entity,
  // RoleAssignment
  typeName: "RoleAssignment",
  cardinality: "OneToMany" /* OneToMany */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "user",
  label: {
    en: "Role Assignments",
    de: "Rollenzuordnung"
  }
})];
var User = _User;
var _Customer = class _Customer extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.created = props.created;
    this.name = props.name;
    this.domain = props.domain;
    this.address = props.address;
    this.legalPerson = props.legalPerson;
  }
};
_Customer.type = new EntityType({
  type: _Customer,
  name: "Customer",
  label: {
    en: "Customer",
    de: "Kunde"
  }
});
_Customer.fields = [new Field({
  name: "id",
  type: String,
  key: true
}), new Field({
  name: "created",
  type: Date,
  key: false
}), new Field({
  name: "name",
  type: String,
  key: false
}), new Field({
  name: "domain",
  type: String,
  key: false
}), new Field({
  name: "logoURL",
  type: String,
  key: false
}), new Field({
  name: "address",
  type: JSON,
  key: false
}), new Field({
  name: "legalPerson",
  type: String,
  key: false
})];
_Customer.relationships = [];
var Customer = _Customer;
var _CustomerTheme = class _CustomerTheme extends Entity {
  constructor(props) {
    super(props);
    this.customer = props.customer;
    this.logoURL = props.logoURL;
    this.primaryDarker = props.primaryDarker;
    this.primaryDark = props.primaryDark;
    this.primary = props.primary;
    this.primaryLight = props.primaryLight;
    this.primaryLighter = props.primaryLighter;
    this.secondary = props.secondary;
    this.accent = props.accent;
  }
};
_CustomerTheme.type = new EntityType({
  type: _CustomerTheme,
  name: "CustomerTheme",
  label: {
    en: "Customer Theme",
    de: "Kunden-Theme"
  }
});
_CustomerTheme.fields = [new Field({
  name: "customer",
  type: String,
  key: true
}), new Field({
  name: "logoURL",
  type: String,
  key: false
}), new Field({
  name: "primaryDarker",
  type: String,
  key: false
}), new Field({
  name: "primaryDark",
  type: String,
  key: false
}), new Field({
  name: "primary",
  type: String,
  key: false
}), new Field({
  name: "primaryLight",
  type: String,
  key: false
}), new Field({
  name: "primaryLighter",
  type: String,
  key: false
}), new Field({
  name: "secondary",
  type: String,
  key: false
}), new Field({
  name: "accent",
  type: String,
  key: false
})];
_CustomerTheme.relationships = [];
var CustomerTheme = _CustomerTheme;

// src/model/order.ts
var import_dayjs = __toESM(require("dayjs"));
var import_quarterOfYear = __toESM(require("dayjs/plugin/quarterOfYear"));
import_dayjs.default.extend(import_quarterOfYear.default);
var ServiceType = /* @__PURE__ */ ((ServiceType2) => {
  ServiceType2["deviceCommissioning"] = "deviceCommissioning";
  ServiceType2["deviceMaintenance"] = "deviceMaintenance";
  ServiceType2["portalAndAppUsage"] = "portalAndAppUsage";
  ServiceType2["privateDataIngestion"] = "privateDataIngestion";
  ServiceType2["marketplaceOfferUsage"] = "marketplaceOfferUsage";
  return ServiceType2;
})(ServiceType || {});
var MeteringAlgorithm = /* @__PURE__ */ ((MeteringAlgorithm2) => {
  MeteringAlgorithm2["perNamedUser"] = "perNamedUser";
  MeteringAlgorithm2["perActiveUserInMonth"] = "perActiveUserInMonth";
  MeteringAlgorithm2["perAsset"] = "perAsset";
  MeteringAlgorithm2["perDocument"] = "perDocument";
  MeteringAlgorithm2["perTelemetryRecord"] = "perTelemetryRecord";
  MeteringAlgorithm2["perAssetInstallation"] = "perAssetInstallation";
  return MeteringAlgorithm2;
})(MeteringAlgorithm || {});
var Billing = class {
  constructor(name, fee, offset, algorithm) {
    this.name = name;
    this.fee = fee;
    this.offset = offset;
    this.algorithm = algorithm;
  }
};
var PaymentMode = /* @__PURE__ */ ((PaymentMode2) => {
  PaymentMode2["none"] = "none";
  PaymentMode2["endOfTerm"] = "endOfTerm";
  PaymentMode2["upFront"] = "upFront";
  return PaymentMode2;
})(PaymentMode || {});
var InvoicingPeriod = /* @__PURE__ */ ((InvoicingPeriod2) => {
  InvoicingPeriod2["monthly"] = "monthly";
  InvoicingPeriod2["quarterly"] = "quarterly";
  return InvoicingPeriod2;
})(InvoicingPeriod || {});
var Plan = class {
  constructor(properties) {
    this.name = properties.name;
    this.description = properties.description;
    this.billings = properties.billings;
    this.baseFee = properties.baseFee;
    this.term = properties.term;
    this.creationDate = properties.creationDate || /* @__PURE__ */ new Date();
    this.validFromDate = properties.validFromDate || (0, import_dayjs.default)().toDate();
    this.validToDate = properties.validToDate || (0, import_dayjs.default)().add(1, "year").toDate();
  }
};
var _Order = class _Order extends Entity {
  constructor(properties) {
    super(properties);
    this.customer = properties.customer;
    this.orderDate = new Date(properties.orderDate);
    this.expirationDate = new Date(properties.expirationDate);
    this.paymentMode = properties.paymentMode || "upFront" /* upFront */;
    this.billingPeriod = properties.billingPeriod || "monthly" /* monthly */;
    this.orderItems = (properties.orderItems || []).map((orderItem) => new OrderItem(orderItem));
  }
  startOfBillingPeriod(date) {
    switch (this.billingPeriod) {
      case "quarterly" /* quarterly */:
        return (0, import_dayjs.default)(date || /* @__PURE__ */ new Date()).startOf("Q").toDate();
      case "monthly" /* monthly */:
      default:
        return (0, import_dayjs.default)(date || /* @__PURE__ */ new Date()).startOf("M").toDate();
    }
  }
  endOfBillingPeriod(date) {
    switch (this.billingPeriod) {
      case "quarterly" /* quarterly */:
        return (0, import_dayjs.default)(date || /* @__PURE__ */ new Date()).endOf("Q").toDate();
      case "monthly" /* monthly */:
      default:
        return (0, import_dayjs.default)(date || /* @__PURE__ */ new Date()).endOf("M").toDate();
    }
  }
  addBillingPeriod(date) {
    switch (this.billingPeriod) {
      case "quarterly" /* quarterly */:
        return (0, import_dayjs.default)(date || /* @__PURE__ */ new Date()).add(1, "Q").toDate();
      case "monthly" /* monthly */:
      default:
        return (0, import_dayjs.default)(date || /* @__PURE__ */ new Date()).add(1, "M").toDate();
    }
  }
  subtractBillingPeriod(date) {
    switch (this.billingPeriod) {
      case "quarterly" /* quarterly */:
        return (0, import_dayjs.default)(date || /* @__PURE__ */ new Date()).subtract(1, "Q").toDate();
      case "monthly" /* monthly */:
      default:
        return (0, import_dayjs.default)(date || /* @__PURE__ */ new Date()).subtract(1, "M").toDate();
    }
  }
};
_Order.type = new EntityType({
  public: false,
  type: _Order,
  name: "Order",
  label: {
    en: "Order",
    de: "Bestellung"
  }
});
_Order.fields = [new Field({
  name: "customer",
  type: String,
  key: false
}), new Field({
  name: "orderDate",
  type: Date,
  key: false
}), new Field({
  name: "expirationDate",
  type: Date,
  key: false
}), new Field({
  name: "paymentMode",
  type: String,
  key: false
}), new Field({
  name: "billingPeriod",
  type: String,
  key: false
})];
_Order.relationships = [];
var Order = _Order;
var OrderItem = class {
  constructor(properties) {
    this.service = properties.service;
    this.serviceReference = properties.serviceReference;
    this.plan = properties.plan;
  }
};
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2["open"] = "open";
  InvoiceStatus2["paid"] = "paid";
  InvoiceStatus2["dispute"] = "dispute";
  return InvoiceStatus2;
})(InvoiceStatus || {});
var _Invoice = class _Invoice extends Entity {
  constructor(properties) {
    super(properties);
    let prefix = properties.buyer ? properties.buyer.name.toUpperCase() : "TRI";
    if (prefix.length === 1) {
      prefix += "XX";
    } else if (prefix.length === 2) {
      prefix += "X";
    } else {
      prefix = prefix.substring(0, 3);
    }
    this.id = `${prefix}-${(0, import_dayjs.default)().format("YYYY-MMDD-hhmmss")}`;
    this.status = properties.status || "open" /* open */;
    this.order = properties.order;
    this.customer = properties.customer;
    this.seller = properties.seller;
    this.buyer = properties.buyer;
    this.creationDate = /* @__PURE__ */ new Date();
    this.periodFromDate = new Date(properties.periodFromDate);
    this.periodToDate = new Date(properties.periodToDate);
    this.paidDate = properties.paidDate ? new Date(properties.paidDate) : void 0;
    this.itemGroups = properties.itemGroups || [];
    this.billingAddress = properties.billingAddress;
  }
  addItemGroup(name) {
    const itemGroup = new ItemGroup(name);
    this.itemGroups.push(itemGroup);
    return itemGroup;
  }
  subtotal() {
    let amount = 0;
    this.itemGroups.forEach((itemGroup) => {
      itemGroup.items.forEach((item) => {
        amount += item.totalAmount;
      });
    });
    return amount;
  }
  grandTotal(vat) {
    return this.subtotal() * (1 + vat);
  }
};
_Invoice.type = new EntityType({
  public: false,
  type: _Invoice,
  name: "Invoice",
  label: {
    en: "Invoice",
    de: "Rechnung"
  }
});
_Invoice.fields = [new Field({
  name: "id",
  type: String,
  key: true
}), new Field({
  name: "status",
  type: InvoiceStatus,
  key: false
}), new Field({
  name: "order",
  type: String,
  key: false
}), new Field({
  name: "customer",
  type: String,
  key: false
}), new Field({
  name: "seller",
  type: JSON,
  key: false
}), new Field({
  name: "buyer",
  type: JSON,
  key: false
}), new Field({
  name: "creationDate",
  type: String,
  key: false
}), new Field({
  name: "periodFromDate",
  type: String,
  key: false
}), new Field({
  name: "periodToDate",
  type: Date,
  key: false
}), new Field({
  name: "paidDate",
  type: Date,
  key: false
}), new Field({
  name: "itemGroups",
  type: JSON,
  key: false
}), new Field({
  name: "billingAddress",
  type: JSON,
  key: false
})];
_Invoice.relationships = [];
var Invoice = _Invoice;
var ItemGroup = class {
  constructor(name) {
    this.name = name;
    this.items = [];
  }
  addItem(description, amount, singlePrice, totalPrice) {
    this.items.push(new InvoiceItem(description, amount, singlePrice, totalPrice));
  }
};
var InvoiceItem = class {
  constructor(description, amount, singlePrice, totalPrice) {
    this.description = description;
    this.volume = amount;
    this.amount = singlePrice;
    this.totalAmount = totalPrice;
  }
};

// src/model/poi.ts
var PoIType = /* @__PURE__ */ ((PoIType2) => {
  PoIType2["school"] = "school";
  PoIType2["university"] = "university";
  PoIType2["chargingStation"] = "chargingStation";
  PoIType2["advertisementColumn"] = "advertisementColumn";
  PoIType2["billboard"] = "billboard";
  PoIType2["fireStation"] = "fireStation";
  PoIType2["policeStation"] = "policeStation";
  PoIType2["childCareFacility"] = "childCareFacility";
  PoIType2["pharmacy"] = "pharmacy";
  PoIType2["hotel"] = "hotel";
  PoIType2["restaurant"] = "restaurant";
  PoIType2["hospital"] = "hospital";
  PoIType2["airport"] = "airport";
  PoIType2["trainStation"] = "trainStation";
  PoIType2["freewayMaintenanceOffice"] = "freewayMaintenanceOffice";
  PoIType2["parkingLot"] = "parkingLot";
  PoIType2["busStop"] = "busStop";
  PoIType2["church"] = "church";
  PoIType2["hairdresser"] = "hairdresser";
  PoIType2["doctor"] = "doctor";
  PoIType2["parcelStation"] = "parcelStation";
  PoIType2["careFacility"] = "careFacility";
  return PoIType2;
})(PoIType || {});
var PoITypeI18N = {
  en: {
    school: "School",
    university: "University",
    chargingStation: "Charging Point",
    advertisementColumn: "Advertisemen tColumn",
    billboard: "Billboard",
    fireStation: "FireStation",
    policeStation: "PoliceStation",
    childCareFacility: "Child Care Facility",
    pharmacy: "Pharmacy",
    hotel: "Hotel",
    restaurant: "Restaurant",
    hospital: "Hospital",
    airport: "Airport",
    trainStation: "Train Station",
    freewayMaintenanceOffice: "Freeway Maintenance Office",
    parkingLot: "Parking Lot",
    busStop: "Bus Stop",
    church: "Church/Worship Place",
    hairdresser: "Hairdresser",
    doctor: "Doctor",
    parcelStation: "Parcel Station",
    careFacility: "Care Facility"
  },
  de: {
    school: "Schule",
    university: "Universit\xE4t",
    chargingStation: "Ladestation",
    advertisementColumn: "Lita\xDFs\xE4ule",
    billboard: "Anzeigetafel",
    fireStation: "Feuerwache",
    policeStation: "Polizei",
    childCareFacility: "Kindergarten",
    pharmacy: "Apotheke",
    hotel: "Hotel",
    restaurant: "Restaurant",
    hospital: "Krankenhaus",
    airport: "Flughafen",
    trainStation: "Bahnhof",
    freewayMaintenanceOffice: "Autobahnmeisterei",
    parkingLot: "Parkplatz",
    busStop: "Bushaltestelle",
    church: "Kirche/Gebetsst\xE4tte",
    hairdresser: "Friseur",
    doctor: "Arzt",
    parcelStation: "Paketstation",
    careFacility: "Pflegeheim"
  }
};
var _PoI = class _PoI extends Entity {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.poiType = props.poiType;
    this.street = props.street;
    this.streetNumber = props.streetNumber;
    this.postalCode = props.postalCode;
    this.city = props.city;
    this.country = props.country || "DE";
    this.lat = props.lat;
    this.lon = props.lon;
  }
};
_PoI.type = new EntityType({
  type: _PoI,
  name: "PoI",
  label: {
    en: "Point of Interest",
    de: "Point of Interest"
  }
});
_PoI.fields = [new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "poiType",
  type: PoIType,
  key: true,
  label: {
    en: "PoI Type",
    de: "PoI-Typ"
  }
}), new Field({
  name: "lat",
  type: Number,
  key: true,
  label: {
    en: "Latitude",
    de: "Breitengrad"
  }
}), new Field({
  name: "lon",
  type: String,
  key: true,
  label: {
    en: "Longitude",
    de: "L\xE4ngengrad"
  }
}), new Field({
  name: "street",
  type: String,
  key: false,
  label: {
    en: "Street",
    de: "Stra\xDFe"
  }
}), new Field({
  name: "streetNumber",
  type: String,
  key: false,
  label: {
    en: "Street Number",
    de: "Hausnummer"
  }
}), new Field({
  name: "postalCode",
  type: String,
  key: false,
  label: {
    en: "Postal Code",
    de: "Postleitzahl"
  }
}), new Field({
  name: "city",
  type: String,
  key: false,
  label: {
    en: "City",
    de: "Ort"
  }
}), new Field({
  name: "country",
  type: String,
  key: false,
  label: {
    en: "Country",
    de: "Land"
  }
})];
_PoI.relationships = [new Relationship({
  name: "address",
  type: Address,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Address",
    de: "Adresse"
  }
})];
var PoI = _PoI;
var UniversityType = /* @__PURE__ */ ((UniversityType2) => {
  UniversityType2["university"] = "university";
  UniversityType2["universityOfAppliedScience"] = "universityOfAppliedScience";
  UniversityType2["artCollege"] = "artCollege";
  UniversityType2["schoolOfAdministration"] = "schoolOfAdministration";
  UniversityType2["other"] = "other";
  return UniversityType2;
})(UniversityType || {});
var _University = class _University extends PoI {
  constructor(props) {
    super(props);
    this.shortName = props.shortName;
    this.universityType = props.universityType;
    this.numberOfStudents = props.numberOfStudents;
    this.sponsorship = props.sponsorship;
    this.foundationYear = props.foundationYear;
    this.rightToAwardDoctorates = props.rightToAwardDoctorates;
    this.rightToHabilitation = props.rightToHabilitation;
    this.postbox = props.postbox;
    this.streetMail = props.streetMail;
    this.streetNumberMail = props.streetNumberMail;
    this.postalCodeMail = props.postalCodeMail;
    this.cityMail = props.cityMail;
    this.phoneNumber = props.phoneNumber;
    this.faxNumber = props.faxNumber;
    this.email = props.email;
    this.website = props.website;
  }
};
_University.type = new EntityType({
  type: _University,
  name: "University",
  label: {
    en: "University",
    de: "Universit\xE4t"
  }
});
_University.fields = [
  ...PoI.fields,
  new Field({
    name: "shortName",
    type: String,
    key: false,
    label: {
      en: "Short Name",
      de: "Kurzname"
    }
  }),
  new Field({
    name: "universityType",
    type: UniversityType,
    key: false,
    label: {
      en: "University Type",
      de: "Hochschultyp"
    }
  }),
  new Field({
    name: "numberOfStudents",
    type: Number,
    key: false,
    label: {
      en: "Number of Students",
      de: "Anzahl Studenten"
    }
  }),
  new Field({
    name: "sponsorship",
    type: String,
    key: false,
    label: {
      en: "Sponsorship",
      de: "Tr\xE4gerschaft"
    }
  }),
  new Field({
    name: "foundationYear",
    type: String,
    key: false,
    label: {
      en: "Foundation Year",
      de: "Gr\xFCndungsjahr"
    }
  }),
  new Field({
    name: "rightToAwardDoctorates",
    type: Boolean,
    key: false,
    label: {
      en: "Right to award Doctorates",
      de: "Promotionsrecht"
    }
  }),
  new Field({
    name: "rightToHabilitation",
    type: Boolean,
    key: false,
    label: {
      en: "Right to Habilitation",
      de: "Habilitationsrecht"
    }
  }),
  new Field({
    name: "postbox",
    type: String,
    key: false,
    label: {
      en: "Post Box",
      de: "Postfach"
    }
  }),
  new Field({
    name: "streetMail",
    type: String,
    key: false,
    label: {
      en: "Street (Mail)",
      de: "Stra\xDFe (Postanschrift)"
    }
  }),
  new Field({
    name: "streetNumberMail",
    type: String,
    key: false,
    label: {
      en: "Street Number (Mail)",
      de: "Hausnummer (Postanschrift)"
    }
  }),
  new Field({
    name: "postalCodeMail",
    type: String,
    key: false,
    label: {
      en: "Postal Code (Mail)",
      de: "Postleitzahl (Postanschrift)"
    }
  }),
  new Field({
    name: "cityMail",
    type: String,
    key: false,
    label: {
      en: "City (Mail)",
      de: "Ort (Postanschrift)"
    }
  }),
  new Field({
    name: "phoneNumber",
    type: String,
    key: false,
    label: {
      en: "Phone Number",
      de: "Telefonnummer"
    }
  }),
  new Field({
    name: "faxNumber",
    type: String,
    key: false,
    label: {
      en: "Fax Number",
      de: "Faxnummer"
    }
  }),
  new Field({
    name: "email",
    type: String,
    key: false,
    label: {
      en: "E-Mail",
      de: "E-Mail"
    }
  }),
  new Field({
    name: "website",
    type: String,
    key: false,
    label: {
      en: "Website",
      de: "Website"
    }
  })
];
_University.relationships = [...PoI.relationships];
var University = _University;
var _School = class _School extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.osmType = props.osmType;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.iscedLevel = props.iscedLevel;
    this.schoolType = props.schoolType;
    this.capacity = props.capacity;
    this.students = props.students;
    this.teachers = props.teachers;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
  }
};
_School.type = new EntityType({
  type: _School,
  name: "School",
  label: {
    en: "School",
    de: "Schule"
  }
});
_School.fields = [
  ...PoI.fields,
  new Field({
    name: "osmId",
    type: String,
    key: false,
    label: {
      en: "OSM ID",
      de: "OSM ID"
    }
  }),
  new Field({
    name: "osmType",
    type: String,
    key: false,
    label: {
      en: "OSM Type",
      de: "OSM-Typ"
    }
  }),
  new Field({
    name: "operator",
    type: String,
    key: false,
    label: {
      en: "Operator",
      de: "Betreiber"
    }
  }),
  new Field({
    name: "website",
    type: String,
    key: false,
    label: {
      en: "Website",
      de: "Website"
    }
  }),
  new Field({
    name: "phone",
    type: String,
    key: false,
    label: {
      en: "Phone",
      de: "Telefon"
    }
  }),
  new Field({
    name: "email",
    type: String,
    key: false,
    label: {
      en: "Email",
      de: "E-Mail"
    }
  }),
  new Field({
    name: "iscedLevel",
    type: String,
    key: false,
    label: {
      en: "ISCED Level",
      de: "ISCED Level"
    }
  }),
  new Field({
    name: "schoolType",
    type: String,
    key: false,
    label: {
      en: "School Type",
      de: "Schultyp"
    }
  }),
  new Field({
    name: "capacity",
    type: String,
    key: false,
    label: {
      en: "Capacity",
      de: "Kapazit\xE4t"
    }
  }),
  new Field({
    name: "students",
    type: String,
    key: false,
    label: {
      en: "Students",
      de: "Sch\xFCler"
    }
  }),
  new Field({
    name: "teachers",
    type: String,
    key: false,
    label: {
      en: "Teachers",
      de: "Lehrer"
    }
  }),
  new Field({
    name: "openingHours",
    type: String,
    key: false,
    label: {
      en: "Opening Hours",
      de: "\xD6ffnungszeiten"
    }
  }),
  new Field({
    name: "wheelchair",
    type: String,
    key: false,
    label: {
      en: "Wheelchair Access",
      de: "Rollstuhlgerecht"
    }
  })
];
_School.relationships = [];
var School = _School;
var ChargingType = /* @__PURE__ */ ((ChargingType2) => {
  ChargingType2["normalCharging"] = "normalCharging";
  ChargingType2["speedCharging"] = "speedCharging";
  return ChargingType2;
})(ChargingType || {});
var _ChargingStation = class _ChargingStation extends PoI {
  constructor(props) {
    super(props);
    this.operator = props.operator;
    this.commissioningDate = props.commissioningDate;
    this.ratedPower = props.ratedPower;
    this.chargingType = props.chargingType;
    this.numberOfChargingPoints = props.numberOfChargingPoints;
    this.plugTypes = props.plugTypes;
  }
};
_ChargingStation.type = new EntityType({
  type: _ChargingStation,
  name: "ChargingStation",
  label: {
    en: "Charging Station",
    de: "Lades\xE4ule"
  }
});
_ChargingStation.fields = [...PoI.fields, new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "commissioningDate",
  type: Date,
  key: false,
  label: {
    en: "Commissioning Date",
    de: "Inbetriebnahmedatum"
  }
}), new Field({
  name: "ratedPower",
  type: Number,
  key: false,
  label: {
    en: "Rated Power (kW)",
    de: "Nennleistung (kW)"
  }
}), new Field({
  name: "chargingType",
  type: ChargingType,
  key: false,
  label: {
    en: "Charging Type",
    de: "Art der Ladeeinrichtung"
  }
}), new Field({
  name: "numberOfChargingPoints",
  type: Number,
  key: false,
  label: {
    en: "Number of Charging Points",
    de: "Anzahl Ladepunkte"
  }
}), new Field({
  name: "plugTypes",
  type: JSON,
  key: false,
  label: {
    en: "Plug Types",
    de: "Steckertypen"
  }
})];
_ChargingStation.relationships = [...PoI.relationships];
var ChargingStation = _ChargingStation;
var _AdvertisementColumn = class _AdvertisementColumn extends PoI {
  constructor(props) {
    super(props);
    this.operator = props.operator;
    this.description = props.description;
    this.lit = props.lit;
  }
};
_AdvertisementColumn.type = new EntityType({
  type: _AdvertisementColumn,
  name: "AdvertisementColumn",
  label: {
    en: "Advertisement Column",
    de: "Litfa\xDFs\xE4ule"
  }
});
_AdvertisementColumn.fields = [...PoI.fields, new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
})];
// Website? Beleuchtung (luminous, lit) animation
_AdvertisementColumn.relationships = [...PoI.relationships];
var AdvertisementColumn = _AdvertisementColumn;
var _Billboard = class _Billboard extends PoI {
  constructor(props) {
    super(props);
    this.operator = props.operator;
    this.model = props.model;
    this.description = props.description;
    this.lit = props.lit;
    this.direction = props.direction;
  }
};
_Billboard.type = new EntityType({
  type: _Billboard,
  name: "Billboard",
  label: {
    en: "Billboard",
    de: "Billboard"
  }
});
_Billboard.fields = [...PoI.fields, new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "model",
  type: String,
  key: false,
  label: {
    en: "Model",
    de: "Modell"
  }
}), new Field({
  name: "description",
  type: String,
  key: false,
  label: {
    en: "Description",
    de: "Beschreibung"
  }
}), new Field({
  name: "direction",
  type: Number,
  key: false,
  label: {
    en: "Direction",
    de: "Ausrichtung"
  }
}), new Field({
  name: "lit",
  type: Boolean,
  key: false,
  label: {
    en: "Lit",
    de: "Beleuchtet"
  }
})];
_Billboard.relationships = [...PoI.relationships];
var Billboard = _Billboard;
var _FireStation = class _FireStation extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.name = props.name;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.fireStationType = props.fireStationType;
    this.staffCount = props.staffCount;
    this.staffVolunteers = props.staffVolunteers;
    this.staffFulltime = props.staffFulltime;
    this.openingHours = props.openingHours;
    this.emergency = props.emergency;
    this.wheelchair = props.wheelchair;
  }
};
_FireStation.type = new EntityType({
  type: _FireStation,
  name: "FireStation",
  label: {
    en: "Fire Station",
    de: "Feuerwache"
  }
});
_FireStation.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "fireStationType",
  type: String,
  key: false,
  label: {
    en: "Fire Station Type",
    de: "Feuerwachetyp"
  }
}), new Field({
  name: "staffCount",
  type: String,
  key: false,
  label: {
    en: "Staff Count",
    de: "Personalst\xE4rke"
  }
}), new Field({
  name: "staffVolunteers",
  type: String,
  key: false,
  label: {
    en: "Volunteer Staff",
    de: "Freiwilliges Personal"
  }
}), new Field({
  name: "staffFulltime",
  type: String,
  key: false,
  label: {
    en: "Full-time Staff",
    de: "Vollzeitpersonal"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "emergency",
  type: String,
  key: false,
  label: {
    en: "Emergency",
    de: "Notfall"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_FireStation.relationships = [...PoI.relationships];
var FireStation = _FireStation;
var _PoliceStation = class _PoliceStation extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.country = props.country;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
  }
};
_PoliceStation.type = new EntityType({
  type: _PoliceStation,
  name: "PoliceStation",
  label: {
    en: "Police Station",
    de: "Polizeistation"
  }
});
_PoliceStation.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_PoliceStation.relationships = [...PoI.relationships];
var PoliceStation = _PoliceStation;
var _ChildCareFacility = class _ChildCareFacility extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.capacity = props.capacity;
    this.ageFrom = props.ageFrom;
    this.ageTo = props.ageTo;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
  }
};
_ChildCareFacility.type = new EntityType({
  type: _ChildCareFacility,
  name: "ChildCareFacility",
  label: {
    en: "Child Care Facility",
    de: "Kindergarten"
  }
});
_ChildCareFacility.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "capacity",
  type: String,
  key: false,
  label: {
    en: "Capacity",
    de: "Kapazit\xE4t"
  }
}), new Field({
  name: "ageFrom",
  type: String,
  key: false,
  label: {
    en: "Age From",
    de: "Alter von"
  }
}), new Field({
  name: "ageTo",
  type: String,
  key: false,
  label: {
    en: "Age To",
    de: "Alter bis"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_ChildCareFacility.relationships = [...PoI.relationships];
var ChildCareFacility = _ChildCareFacility;
var _Pharmacy = class _Pharmacy extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
  }
};
_Pharmacy.type = new EntityType({
  type: _Pharmacy,
  name: "Pharmacy",
  label: {
    en: "Pharmacy",
    de: "Apotheke"
  }
});
_Pharmacy.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
}), new Field({
  name: "lastUpdated",
  type: String,
  key: false,
  label: {
    en: "Last Updated",
    de: "Zuletzt aktualisiert"
  }
})];
_Pharmacy.relationships = [...PoI.relationships];
var Pharmacy = _Pharmacy;
var _Hotel = class _Hotel extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.tourism = props.tourism;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.stars = props.stars;
    this.rooms = props.rooms;
    this.beds = props.beds;
    this.openingHours = props.openingHours;
    this.checkIn = props.checkIn;
    this.checkOut = props.checkOut;
    this.wheelchair = props.wheelchair;
  }
};
_Hotel.type = new EntityType({
  type: _Hotel,
  name: "Hotel",
  label: {
    en: "Hotel",
    de: "Hotel"
  }
});
_Hotel.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "tourism",
  type: String,
  key: false,
  label: {
    en: "Tourism",
    de: "Tourismus"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "stars",
  type: String,
  key: false,
  label: {
    en: "Stars",
    de: "Sterne"
  }
}), new Field({
  name: "rooms",
  type: String,
  key: false,
  label: {
    en: "Rooms",
    de: "Zimmer"
  }
}), new Field({
  name: "beds",
  type: String,
  key: false,
  label: {
    en: "Beds",
    de: "Betten"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "checkIn",
  type: String,
  key: false,
  label: {
    en: "Check-in Time",
    de: "Check-in Zeit"
  }
}), new Field({
  name: "checkOut",
  type: String,
  key: false,
  label: {
    en: "Check-out Time",
    de: "Check-out Zeit"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_Hotel.relationships = [...PoI.relationships];
var Hotel = _Hotel;
var _Restaurant = class _Restaurant extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.cuisine = props.cuisine;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.openingHours = props.openingHours;
    this.delivery = props.delivery;
    this.takeaway = props.takeaway;
    this.dietary = props.dietary;
    this.wheelchair = props.wheelchair;
  }
};
_Restaurant.type = new EntityType({
  type: _Restaurant,
  name: "Restaurant",
  label: {
    en: "Restaurant",
    de: "Restaurant"
  }
});
_Restaurant.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "cuisine",
  type: String,
  key: false,
  label: {
    en: "Cuisine",
    de: "K\xFCche"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "delivery",
  type: String,
  key: false,
  label: {
    en: "Delivery",
    de: "Lieferung"
  }
}), new Field({
  name: "takeaway",
  type: String,
  key: false,
  label: {
    en: "Takeaway",
    de: "Mitnehmen"
  }
}), new Field({
  name: "dietary",
  type: String,
  key: false,
  label: {
    en: "Dietary Options",
    de: "Ern\xE4hrungsoptionen"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_Restaurant.relationships = [...PoI.relationships];
var Restaurant = _Restaurant;
var _Hospital = class _Hospital extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.poiType = props.poiType;
    this.name = props.name;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.openingHours = props.openingHours;
    this.emergency = props.emergency;
    this.beds = props.beds;
    this.wheelchair = props.wheelchair;
  }
};
_Hospital.type = new EntityType({
  type: _Hospital,
  name: "Hospital",
  label: {
    en: "Hospital",
    de: "Krankenhaus"
  }
});
_Hospital.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "emergency",
  type: String,
  key: false,
  label: {
    en: "Emergency",
    de: "Notfall"
  }
}), new Field({
  name: "beds",
  type: String,
  key: false,
  label: {
    en: "Beds",
    de: "Betten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_Hospital.relationships = [...PoI.relationships];
var Hospital = _Hospital;
var _Airport = class _Airport extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.poiType = props.poiType;
    this.name = props.name;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.ref = props.ref;
    this.iata = props.iata;
    this.icao = props.icao;
    this.ele = props.ele;
    this.runways = props.runways;
    this.wheelchair = props.wheelchair;
  }
};
_Airport.type = new EntityType({
  type: _Airport,
  name: "Airport",
  label: {
    en: "Airport",
    de: "Flughafen"
  }
});
_Airport.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "ref",
  type: String,
  key: false,
  label: {
    en: "Reference",
    de: "Referenz"
  }
}), new Field({
  name: "iata",
  type: String,
  key: false,
  label: {
    en: "IATA Code",
    de: "IATA-Code"
  }
}), new Field({
  name: "icao",
  type: String,
  key: false,
  label: {
    en: "ICAO Code",
    de: "ICAO-Code"
  }
}), new Field({
  name: "ele",
  type: String,
  key: false,
  label: {
    en: "Elevation",
    de: "H\xF6he"
  }
}), new Field({
  name: "runways",
  type: String,
  key: false,
  label: {
    en: "Runways",
    de: "Landebahnen"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_Airport.relationships = [...PoI.relationships];
var Airport = _Airport;
var _PollutionData = class _PollutionData extends PoI {
  constructor(props) {
    super(props);
    this.category = props.category;
    this.type = props.type;
    this.sector = props.sector;
    this.sourceType = props.sourceType;
    this.dataCollectionMethod = props.dataCollectionMethod;
    this.sourceText = props.sourceText;
    this.sourceUrl = props.sourceUrl;
    this.datasetId = props.datasetId;
    this.datasetName = props.datasetName;
    this.pfasValues = props.pfasValues;
    this.unit = props.unit;
    this.pfasSum = props.pfasSum;
    this.details = props.details;
    this.matrix = props.matrix;
    this.date = props.date ? new Date(props.date) : void 0;
    this.year = props.year;
  }
};
_PollutionData.type = new EntityType({
  type: _PollutionData,
  name: "PollutionData",
  label: {
    en: "Pollution Data",
    de: "Schadstoffdaten"
  }
});
_PollutionData.fields = [...PoI.fields, new Field({
  name: "category",
  type: String,
  key: false,
  label: {
    en: "Category",
    de: "Kategorie"
  }
}), new Field({
  name: "type",
  type: String,
  key: false,
  label: {
    en: "Type",
    de: "Typ"
  }
}), new Field({
  name: "sector",
  type: String,
  key: false,
  label: {
    en: "Sector",
    de: "Sektor"
  }
}), new Field({
  name: "sourceType",
  type: String,
  key: false,
  label: {
    en: "Source Type",
    de: "Quellentyp"
  }
}), new Field({
  name: "dataCollectionMethod",
  type: String,
  key: false,
  label: {
    en: "Data Collection Method",
    de: "Datenerhebungsmethode"
  }
}), new Field({
  name: "sourceText",
  type: String,
  key: false,
  label: {
    en: "Source Text",
    de: "Quellentext"
  }
}), new Field({
  name: "sourceUrl",
  type: String,
  key: false,
  label: {
    en: "Source URL",
    de: "Quellen-URL"
  }
}), new Field({
  name: "datasetId",
  type: String,
  key: false,
  label: {
    en: "Dataset ID",
    de: "Datensatz-ID"
  }
}), new Field({
  name: "datasetName",
  type: String,
  key: false,
  label: {
    en: "Dataset Name",
    de: "Datensatzname"
  }
}), new Field({
  name: "pfasValues",
  type: JSON,
  key: false,
  label: {
    en: "PFAS Values",
    de: "PFAS-Werte"
  }
}), new Field({
  name: "unit",
  type: String,
  key: false,
  label: {
    en: "Unit",
    de: "Einheit"
  }
}), new Field({
  name: "pfasSum",
  type: String,
  key: false,
  label: {
    en: "PFAS Sum",
    de: "PFAS-Summe"
  }
}), new Field({
  name: "details",
  type: JSON,
  key: false,
  label: {
    en: "Details",
    de: "Details"
  }
}), new Field({
  name: "matrix",
  type: String,
  key: false,
  label: {
    en: "Matrix",
    de: "Matrix"
  }
}), new Field({
  name: "date",
  type: Date,
  key: false,
  label: {
    en: "Date",
    de: "Datum"
  }
}), new Field({
  name: "year",
  type: String,
  key: false,
  label: {
    en: "Year",
    de: "Jahr"
  }
})];
_PollutionData.relationships = [...PoI.relationships];
var PollutionData = _PollutionData;
var _TrainStation = class _TrainStation extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
    this.lastUpdated = props.lastUpdated;
  }
};
_TrainStation.type = new EntityType({
  type: _TrainStation,
  name: "TrainStation",
  label: {
    en: "Train Station",
    de: "Bahnhof"
  }
});
_TrainStation.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
}), new Field({
  name: "lastUpdated",
  type: String,
  key: false,
  label: {
    en: "Last Updated",
    de: "Zuletzt aktualisiert"
  }
})];
_TrainStation.relationships = [...PoI.relationships];
var TrainStation = _TrainStation;
var _FreewayMaintenanceOffice = class _FreewayMaintenanceOffice extends PoI {
  constructor(props) {
    super(props);
    this.type = props.type;
    this.state = props.state;
    this.location = props.location;
    this.phone = props.phone;
    this.person = props.person;
    this.branch = props.branch;
    this.subsidiary = props.subsidiary;
  }
};
_FreewayMaintenanceOffice.type = new EntityType({
  type: _FreewayMaintenanceOffice,
  name: "FreewayMaintenanceOffice",
  label: {
    en: "Freeway Maintenance Office",
    de: "Autobahnmeisterei"
  }
});
_FreewayMaintenanceOffice.fields = [...PoI.fields, new Field({
  name: "type",
  type: String,
  key: false,
  label: {
    en: "Type",
    de: "Typ"
  }
}), new Field({
  name: "state",
  type: String,
  key: false,
  label: {
    en: "State",
    de: "Bundesland"
  }
}), new Field({
  name: "location",
  type: String,
  key: false,
  label: {
    en: "Location",
    de: "Standort"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "person",
  type: String,
  key: false,
  label: {
    en: "Contact",
    de: "Ansprechpartner"
  }
}), new Field({
  name: "branch",
  type: String,
  key: false,
  label: {
    en: "Branch",
    de: "Branche"
  }
}), new Field({
  name: "subsidiary",
  type: String,
  key: false,
  label: {
    en: "Subsidiary",
    de: "Tochtergesellschaft"
  }
})];
_FreewayMaintenanceOffice.relationships = [...PoI.relationships];
var FreewayMaintenanceOffice = _FreewayMaintenanceOffice;
var _ParkingLot = class _ParkingLot extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.parking = props.parking;
    this.capacity = props.capacity;
    this.fee = props.fee;
    this.access = props.access;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
  }
};
_ParkingLot.type = new EntityType({
  type: _ParkingLot,
  name: "ParkingLot",
  label: {
    en: "Parking Lot",
    de: "Parkplatz"
  }
});
_ParkingLot.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "parking",
  type: String,
  key: false,
  label: {
    en: "Parking Type",
    de: "Parkplatztyp"
  }
}), new Field({
  name: "capacity",
  type: String,
  key: false,
  label: {
    en: "Capacity",
    de: "Kapazit\xE4t"
  }
}), new Field({
  name: "fee",
  type: String,
  key: false,
  label: {
    en: "Fee",
    de: "Geb\xFChr"
  }
}), new Field({
  name: "access",
  type: String,
  key: false,
  label: {
    en: "Access",
    de: "Zugang"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_ParkingLot.relationships = [...PoI.relationships];
var ParkingLot = _ParkingLot;
var _BusStop = class _BusStop extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.publicTransport = props.publicTransport;
    this.bus = props.bus;
    this.shelter = props.shelter;
    this.bench = props.bench;
    this.operator = props.operator;
    this.network = props.network;
    this.wheelchair = props.wheelchair;
  }
};
_BusStop.type = new EntityType({
  type: _BusStop,
  name: "BusStop",
  label: {
    en: "Bus Stop",
    de: "Bushaltestelle"
  }
});
_BusStop.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "publicTransport",
  type: String,
  key: false,
  label: {
    en: "Public Transport",
    de: "\xD6ffentlicher Verkehr"
  }
}), new Field({
  name: "bus",
  type: String,
  key: false,
  label: {
    en: "Bus",
    de: "Bus"
  }
}), new Field({
  name: "shelter",
  type: String,
  key: false,
  label: {
    en: "Shelter",
    de: "Warteh\xE4uschen"
  }
}), new Field({
  name: "bench",
  type: String,
  key: false,
  label: {
    en: "Bench",
    de: "Bank"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "network",
  type: String,
  key: false,
  label: {
    en: "Network",
    de: "Netzwerk"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_BusStop.relationships = [...PoI.relationships];
var BusStop = _BusStop;
var _Church = class _Church extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.building = props.building;
    this.denomination = props.denomination;
    this.religion = props.religion;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
    this.heritage = props.heritage;
    this.architect = props.architect;
    this.architecturalStyle = props.architecturalStyle;
    this.yearBuilt = props.yearBuilt;
  }
};
_Church.type = new EntityType({
  type: _Church,
  name: "Church",
  label: {
    en: "Church/Worship Place",
    de: "Kirche/Gebetsst\xE4tte"
  }
});
_Church.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "building",
  type: String,
  key: false,
  label: {
    en: "Building",
    de: "Geb\xE4ude"
  }
}), new Field({
  name: "denomination",
  type: String,
  key: false,
  label: {
    en: "Denomination",
    de: "Konfession"
  }
}), new Field({
  name: "religion",
  type: String,
  key: false,
  label: {
    en: "Religion",
    de: "Religion"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
}), new Field({
  name: "heritage",
  type: String,
  key: false,
  label: {
    en: "Heritage",
    de: "Denkmal"
  }
}), new Field({
  name: "architect",
  type: String,
  key: false,
  label: {
    en: "Architect",
    de: "Architekt"
  }
}), new Field({
  name: "architecturalStyle",
  type: String,
  key: false,
  label: {
    en: "Architectural Style",
    de: "Baustil"
  }
}), new Field({
  name: "yearBuilt",
  type: String,
  key: false,
  label: {
    en: "Year Built",
    de: "Baujahr"
  }
})];
_Church.relationships = [...PoI.relationships];
var Church = _Church;
var _Hairdresser = class _Hairdresser extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.poiType = props.poiType;
    this.name = props.name;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
    this.lastUpdated = props.lastUpdated;
  }
};
_Hairdresser.type = new EntityType({
  type: _Hairdresser,
  name: "Hairdresser",
  label: {
    en: "Hairdresser",
    de: "Friseur"
  }
});
_Hairdresser.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
}), new Field({
  name: "lastUpdated",
  type: String,
  key: false,
  label: {
    en: "Last Updated",
    de: "Zuletzt aktualisiert"
  }
})];
_Hairdresser.relationships = [...PoI.relationships];
var Hairdresser = _Hairdresser;
var _Doctor = class _Doctor extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
  }
};
_Doctor.type = new EntityType({
  type: _Doctor,
  name: "Doctor",
  label: {
    en: "Doctor",
    de: "Arzt"
  }
});
_Doctor.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
})];
_Doctor.relationships = [...PoI.relationships];
var Doctor = _Doctor;
var _ParcelStation = class _ParcelStation extends PoI {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.operator = props.operator;
    this.website = props.website;
    this.phone = props.phone;
    this.email = props.email;
    this.openingHours = props.openingHours;
    this.wheelchair = props.wheelchair;
    this.parcelMailIn = props.parcelMailIn;
    this.parcelPickup = props.parcelPickup;
    this.parcelLocker = props.parcelLocker;
  }
};
_ParcelStation.type = new EntityType({
  type: _ParcelStation,
  name: "ParcelStation",
  label: {
    en: "Parcel Station",
    de: "Paketstation"
  }
});
_ParcelStation.fields = [...PoI.fields, new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "openingHours",
  type: String,
  key: false,
  label: {
    en: "Opening Hours",
    de: "\xD6ffnungszeiten"
  }
}), new Field({
  name: "wheelchair",
  type: String,
  key: false,
  label: {
    en: "Wheelchair Access",
    de: "Rollstuhlgerecht"
  }
}), new Field({
  name: "parcelMailIn",
  type: String,
  key: false,
  label: {
    en: "Parcel Mail In",
    de: "Paketannahme"
  }
}), new Field({
  name: "parcelPickup",
  type: String,
  key: false,
  label: {
    en: "Parcel Pickup",
    de: "Paketabholung"
  }
}), new Field({
  name: "parcelLocker",
  type: String,
  key: false,
  label: {
    en: "Parcel Locker",
    de: "Paketfach"
  }
})];
_ParcelStation.relationships = [...PoI.relationships];
var ParcelStation = _ParcelStation;
var _CareFacility = class _CareFacility extends PoI {
  constructor(props) {
    super(props);
    this.pmId = props.pmId;
    this.carrierId = props.carrierId;
    this.ikNumber = props.ikNumber;
    this.sector = props.sector;
    this.status = props.status;
    this.operator = props.operator;
    this.ikInt = props.ikInt;
    this.subsidiary1 = props.subsidiary1;
    this.subsidiary2 = props.subsidiary2;
    this.type = props.type;
    this.state = props.state;
    this.municipalityCode = props.municipalityCode;
    this.phone = props.phone;
    this.fax = props.fax;
    this.email = props.email;
    this.website = props.website;
    this.domain = props.domain;
    this.mdkDate = props.mdkDate ? new Date(props.mdkDate) : void 0;
    this.nursingAndMedicalCare = props.nursingAndMedicalCare;
    this.dealingWithDementiaResidents = props.dealingWithDementiaResidents;
    this.socialCareAndDailyActivities = props.socialCareAndDailyActivities;
    this.housingNutritionHousekeepingAndHygiene = props.housingNutritionHousekeepingAndHygiene;
    this.residentSurvey = props.residentSurvey;
    this.mdkGrade = props.mdkGrade;
    this.sourceUrl = props.sourceUrl;
    this.numberOfPatientsCared = props.numberOfPatientsCared;
    this.capacityFullTimeNursing = props.capacityFullTimeNursing;
    this.capacityShortTermCare = props.capacityShortTermCare;
    this.capacityNightCare = props.capacityNightCare;
    this.singleRooms = props.singleRooms;
    this.doubleRooms = props.doubleRooms;
    this.constructionYear = props.constructionYear;
    this.modernizationYear = props.modernizationYear;
    this.trainingLevy = props.trainingLevy;
    this.incomeFromOwnCapital = props.incomeFromOwnCapital;
    this.maintenanceAndManagement = props.maintenanceAndManagement;
    this.investment = props.investment;
    this.singleRoomRatio = props.singleRoomRatio;
    this.occupancyRate = props.occupancyRate;
    this.careLevel1 = props.careLevel1;
    this.careLevel2 = props.careLevel2;
    this.careLevel3 = props.careLevel3;
    this.careLevel4 = props.careLevel4;
    this.careLevel5 = props.careLevel5;
    this.specialization = props.specialization;
  }
};
_CareFacility.type = new EntityType({
  type: _CareFacility,
  name: "CareFacility",
  label: {
    en: "Care Facility",
    de: "Pflegeheim"
  }
});
_CareFacility.fields = [...PoI.fields, new Field({
  name: "pmId",
  type: String,
  key: false,
  label: {
    en: "PM ID",
    de: "PM ID"
  }
}), new Field({
  name: "carrierId",
  type: String,
  key: false,
  label: {
    en: "Carrier ID",
    de: "Tr\xE4ger ID"
  }
}), new Field({
  name: "ikNumber",
  type: String,
  key: false,
  label: {
    en: "IK Number",
    de: "IK-Nummer"
  }
}), new Field({
  name: "sector",
  type: String,
  key: false,
  label: {
    en: "Sector",
    de: "Sektor"
  }
}), new Field({
  name: "status",
  type: String,
  key: false,
  label: {
    en: "Status",
    de: "Status"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "ikInt",
  type: String,
  key: false,
  label: {
    en: "IK International",
    de: "IK International"
  }
}), new Field({
  name: "subsidiary1",
  type: String,
  key: false,
  label: {
    en: "Subsidiary 1",
    de: "Tochtergesellschaft 1"
  }
}), new Field({
  name: "subsidiary2",
  type: String,
  key: false,
  label: {
    en: "Subsidiary 2",
    de: "Tochtergesellschaft 2"
  }
}), new Field({
  name: "type",
  type: String,
  key: false,
  label: {
    en: "Type",
    de: "Typ"
  }
}), new Field({
  name: "state",
  type: String,
  key: false,
  label: {
    en: "State",
    de: "Bundesland"
  }
}), new Field({
  name: "municipalityCode",
  type: String,
  key: false,
  label: {
    en: "Municipality Code",
    de: "Gemeindeschl\xFCssel"
  }
}), new Field({
  name: "phone",
  type: String,
  key: false,
  label: {
    en: "Phone",
    de: "Telefon"
  }
}), new Field({
  name: "fax",
  type: String,
  key: false,
  label: {
    en: "Fax",
    de: "Fax"
  }
}), new Field({
  name: "email",
  type: String,
  key: false,
  label: {
    en: "Email",
    de: "E-Mail"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "domain",
  type: String,
  key: false,
  label: {
    en: "Domain",
    de: "Domain"
  }
}), new Field({
  name: "mdkDate",
  type: Date,
  key: false,
  label: {
    en: "MDK Date",
    de: "MDK Datum"
  }
}), new Field({
  name: "nursingAndMedicalCare",
  type: String,
  key: false,
  label: {
    en: "Nursing and Medical Care",
    de: "Pflege und medizinische Versorgung"
  }
}), new Field({
  name: "dealingWithDementiaResidents",
  type: String,
  key: false,
  label: {
    en: "Dealing with Dementia Residents",
    de: "Umgang mit demenzkranken Bewohnern"
  }
}), new Field({
  name: "socialCareAndDailyActivities",
  type: String,
  key: false,
  label: {
    en: "Social Care and Daily Activities",
    de: "Soziale Betreuung und Alltagsgestaltung"
  }
}), new Field({
  name: "housingNutritionHousekeepingAndHygiene",
  type: String,
  key: false,
  label: {
    en: "Housing, Nutrition, Housekeeping and Hygiene",
    de: "Wohnen, Ern\xE4hrung, Hauswirtschaft und Hygiene"
  }
}), new Field({
  name: "residentSurvey",
  type: String,
  key: false,
  label: {
    en: "Resident Survey",
    de: "Bewohnerbefragung"
  }
}), new Field({
  name: "mdkGrade",
  type: String,
  key: false,
  label: {
    en: "MDK Grade",
    de: "MDK Note"
  }
}), new Field({
  name: "sourceUrl",
  type: String,
  key: false,
  label: {
    en: "Source URL",
    de: "Quellen-URL"
  }
}), new Field({
  name: "numberOfPatientsCared",
  type: Number,
  key: false,
  label: {
    en: "Number of Patients Cared",
    de: "Anzahl der betreuten Patienten"
  }
}), new Field({
  name: "capacityFullTimeNursing",
  type: Number,
  key: false,
  label: {
    en: "Capacity Full-time Nursing",
    de: "Kapazit\xE4t Vollzeitpflege"
  }
}), new Field({
  name: "capacityShortTermCare",
  type: Number,
  key: false,
  label: {
    en: "Capacity Short-term Care",
    de: "Kapazit\xE4t Kurzzeitpflege"
  }
}), new Field({
  name: "capacityNightCare",
  type: Number,
  key: false,
  label: {
    en: "Capacity Night Care",
    de: "Kapazit\xE4t Nachtpflege"
  }
}), new Field({
  name: "singleRooms",
  type: Number,
  key: false,
  label: {
    en: "Single Rooms",
    de: "Einzelzimmer"
  }
}), new Field({
  name: "doubleRooms",
  type: Number,
  key: false,
  label: {
    en: "Double Rooms",
    de: "Doppelzimmer"
  }
}), new Field({
  name: "constructionYear",
  type: Number,
  key: false,
  label: {
    en: "Construction Year",
    de: "Baujahr"
  }
}), new Field({
  name: "modernizationYear",
  type: Number,
  key: false,
  label: {
    en: "Modernization Year",
    de: "Modernisierungsjahr"
  }
}), new Field({
  name: "trainingLevy",
  type: Number,
  key: false,
  label: {
    en: "Training Levy",
    de: "Ausbildungsabgabe"
  }
}), new Field({
  name: "incomeFromOwnCapital",
  type: Number,
  key: false,
  label: {
    en: "Income from Own Capital",
    de: "Ertrag aus Eigenkapital"
  }
}), new Field({
  name: "maintenanceAndManagement",
  type: Number,
  key: false,
  label: {
    en: "Maintenance and Management",
    de: "Instandhaltung und Verwaltung"
  }
}), new Field({
  name: "investment",
  type: Number,
  key: false,
  label: {
    en: "Investment",
    de: "Investition"
  }
}), new Field({
  name: "singleRoomRatio",
  type: Number,
  key: false,
  label: {
    en: "Single Room Ratio",
    de: "Einzelzimmerquote"
  }
}), new Field({
  name: "occupancyRate",
  type: Number,
  key: false,
  label: {
    en: "Occupancy Rate",
    de: "Belegungsquote"
  }
}), new Field({
  name: "careLevel1",
  type: Number,
  key: false,
  label: {
    en: "Care Level 1",
    de: "Pflegestufe 1"
  }
}), new Field({
  name: "careLevel2",
  type: Number,
  key: false,
  label: {
    en: "Care Level 2",
    de: "Pflegestufe 2"
  }
}), new Field({
  name: "careLevel3",
  type: Number,
  key: false,
  label: {
    en: "Care Level 3",
    de: "Pflegestufe 3"
  }
}), new Field({
  name: "careLevel4",
  type: Number,
  key: false,
  label: {
    en: "Care Level 4",
    de: "Pflegestufe 4"
  }
}), new Field({
  name: "careLevel5",
  type: Number,
  key: false,
  label: {
    en: "Care Level 5",
    de: "Pflegestufe 5"
  }
}), new Field({
  name: "specialization",
  type: String,
  key: false,
  label: {
    en: "Specialization",
    de: "Spezialisierung"
  }
})];
_CareFacility.relationships = [...PoI.relationships];
var CareFacility = _CareFacility;

// src/model/way.ts
var WayType = /* @__PURE__ */ ((WayType2) => {
  WayType2["bikePath"] = "bikePath";
  WayType2["bridge"] = "bridge";
  return WayType2;
})(WayType || {});
var WayTypeI18N = {
  en: {
    bikePath: "Bicycle Path",
    bridge: "Bridge"
  },
  de: {
    bikePath: "Fahrradweg",
    bridge: "Br\xFCcke"
  }
};
var _Way = class _Way extends Entity {
  constructor(props) {
    super(props);
    this.wayType = props.wayType;
    this.shape = props.shape || [];
    this.minLat = props.minLat;
    this.maxLat = props.maxLat;
    this.minLon = props.minLon;
    this.maxLon = props.maxLon;
  }
};
_Way.type = new EntityType({
  type: _Way,
  name: "Way",
  label: {
    en: "Way",
    de: "Wege"
  }
});
_Way.fields = [new Field({
  name: "wayType",
  type: WayType,
  key: false,
  label: {
    en: "Way Type",
    de: "Wegtyp"
  }
}), new Field({
  name: "shape",
  type: JSON,
  key: false,
  label: {
    en: "Shape",
    de: "Shape"
  }
}), new Field({
  name: "minLat",
  type: Number,
  key: false,
  label: {
    en: "Minimum Latitude",
    de: "Minimum Breitengrad"
  }
}), new Field({
  name: "maxLat",
  type: Number,
  key: false,
  label: {
    en: "Maximum Latitude",
    de: "Maximum Breitengrad"
  }
}), new Field({
  name: "minLon",
  type: Number,
  key: false,
  label: {
    en: "Minimum Longitude",
    de: "Minimum L\xE4ngengrad"
  }
}), new Field({
  name: "maxLon",
  type: Number,
  key: false,
  label: {
    en: "Maximum Longitude",
    de: "Maximum L\xE4ngengrad"
  }
})];
_Way.relationships = [];
var Way = _Way;
var BridgeUsageType = /* @__PURE__ */ ((BridgeUsageType2) => {
  BridgeUsageType2["pedestrian"] = "pedestrian";
  BridgeUsageType2["bicycle"] = "bicycle";
  BridgeUsageType2["motorVehicle"] = "motorVehicle";
  BridgeUsageType2["railway"] = "railway";
  BridgeUsageType2["other"] = "other";
  return BridgeUsageType2;
})(BridgeUsageType || {});
var _Bridge = class _Bridge extends Entity {
  constructor(props) {
    super(props);
    this.osmId = props.osmId;
    this.name = props.name;
    this.nameDe = props.nameDe;
    this.bridge = props.bridge;
    this.bridgeType = props.bridgeType;
    this.bridgeStructure = props.bridgeStructure;
    this.bridgeMaterial = props.bridgeMaterial;
    this.bridgeHeight = props.bridgeHeight;
    this.bridgeWidth = props.bridgeWidth;
    this.bridgeLength = props.bridgeLength;
    this.bridgeSpan = props.bridgeSpan;
    this.bridgeYearBuilt = props.bridgeYearBuilt;
    this.bridgeYearRenovated = props.bridgeYearRenovated;
    this.bridgeCondition = props.bridgeCondition;
    this.bridgeLoadLimit = props.bridgeLoadLimit;
    this.bridgeTraffic = props.bridgeTraffic;
    this.bridgeRef = props.bridgeRef;
    this.operator = props.operator;
    this.website = props.website;
    this.lastUpdated = props.lastUpdated;
    this.lat = props.lat;
    this.lon = props.lon;
    this.shape = props.shape;
    this.conditionGradeClass = props.conditionGradeClass;
    this.conditionGradeEvaluation = props.conditionGradeEvaluation;
    this.districtCode = props.districtCode;
    this.district = props.district;
    this.stage = props.stage;
    this.lengthClass = props.lengthClass;
    this.constructionYear = props.constructionYear;
    this.materialClass = props.materialClass;
    this.construction = props.construction;
    this.loadCapacityIndex = props.loadCapacityIndex;
    this.partOfBastList = props.partOfBastList;
    this.dataDeliveryDate = props.dataDeliveryDate;
    this.nrStatus = props.nrStatus;
    this.materialSubstructure = props.materialSubstructure;
    this.constructionYearSubstructure = props.constructionYearSubstructure;
    this.stateNumber = props.stateNumber;
    this.stateName = props.stateName;
    this.maintenanceOffice = props.maintenanceOffice;
    this.maintenanceOfficeDetails = props.maintenanceOfficeDetails;
    this.office = props.office;
    this.structureNumber = props.structureNumber;
    this.partialStructureNumber = props.partialStructureNumber;
    this.partialStructureType = props.partialStructureType;
    this.structureName = props.structureName;
    this.location = props.location;
    this.streetName = props.streetName;
    this.streetType = props.streetType;
    this.length = props.length;
    this.width = props.width;
    this.area = props.area;
    this.highestConditionAbove = props.highestConditionAbove;
    this.highestConditionBelow = props.highestConditionBelow;
    this.loadPositionOne = props.loadPositionOne;
    this.loadPositionTwo = props.loadPositionTwo;
    this.ageClass = props.ageClass;
    this.yearLastMainInspection = props.yearLastMainInspection;
    this.partialStructureNetwork = props.partialStructureNetwork;
    this.heavyTrafficBlock = props.heavyTrafficBlock;
    this.xCoordinate = props.xCoordinate;
    this.yCoordinate = props.yCoordinate;
    this.conditionGrade = props.conditionGrade;
    this.substanceIndex2019 = props.substanceIndex2019;
    this.basis = props.basis;
    this.extension = props.extension;
    this.urbanArea = props.urbanArea;
    this.residentsPerKm2 = props.residentsPerKm2;
    this.trafficAreaUsageDensity = props.trafficAreaUsageDensity;
    this.adjustedCondition = props.adjustedCondition;
    this.trafficVehicles = props.trafficVehicles;
    this.trafficHeavyVehicles = props.trafficHeavyVehicles;
    this.usageType = props.usageType;
    this.germanRailwaysData = props.germanRailwaysData;
    this.projects = props.projects;
  }
};
_Bridge.type = new EntityType({
  type: _Bridge,
  name: "Bridge",
  label: {
    en: "Bridge",
    de: "Br\xFCcke"
  }
});
_Bridge.fields = [new Field({
  name: "osmId",
  type: String,
  key: false,
  label: {
    en: "OSM ID",
    de: "OSM ID"
  }
}), new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "nameDe",
  type: String,
  key: false,
  label: {
    en: "Name (German)",
    de: "Name (Deutsch)"
  }
}), new Field({
  name: "bridge",
  type: String,
  key: false,
  label: {
    en: "Bridge",
    de: "Br\xFCcke"
  }
}), new Field({
  name: "bridgeType",
  type: String,
  key: false,
  label: {
    en: "Bridge Type",
    de: "Br\xFCckentyp"
  }
}), new Field({
  name: "bridgeStructure",
  type: String,
  key: false,
  label: {
    en: "Bridge Structure",
    de: "Br\xFCckenstruktur"
  }
}), new Field({
  name: "bridgeMaterial",
  type: String,
  key: false,
  label: {
    en: "Bridge Material",
    de: "Br\xFCckenmaterial"
  }
}), new Field({
  name: "bridgeHeight",
  type: String,
  key: false,
  label: {
    en: "Bridge Height",
    de: "Br\xFCckenh\xF6he"
  }
}), new Field({
  name: "bridgeWidth",
  type: String,
  key: false,
  label: {
    en: "Bridge Width",
    de: "Br\xFCckenbreite"
  }
}), new Field({
  name: "bridgeLength",
  type: String,
  key: false,
  label: {
    en: "Bridge Length",
    de: "Br\xFCckenl\xE4nge"
  }
}), new Field({
  name: "bridgeSpan",
  type: String,
  key: false,
  label: {
    en: "Bridge Span",
    de: "Br\xFCckenspannweite"
  }
}), new Field({
  name: "bridgeYearBuilt",
  type: String,
  key: false,
  label: {
    en: "Bridge Year Built",
    de: "Br\xFCckenbaujahr"
  }
}), new Field({
  name: "bridgeYearRenovated",
  type: String,
  key: false,
  label: {
    en: "Bridge Year Renovated",
    de: "Br\xFCckenrenovierungsjahr"
  }
}), new Field({
  name: "bridgeCondition",
  type: String,
  key: false,
  label: {
    en: "Bridge Condition",
    de: "Br\xFCckenzustand"
  }
}), new Field({
  name: "bridgeLoadLimit",
  type: String,
  key: false,
  label: {
    en: "Bridge Load Limit",
    de: "Br\xFCckenlastgrenze"
  }
}), new Field({
  name: "bridgeTraffic",
  type: String,
  key: false,
  label: {
    en: "Bridge Traffic",
    de: "Br\xFCckenverkehr"
  }
}), new Field({
  name: "bridgeRef",
  type: String,
  key: false,
  label: {
    en: "Bridge Reference",
    de: "Br\xFCckenreferenz"
  }
}), new Field({
  name: "operator",
  type: String,
  key: false,
  label: {
    en: "Operator",
    de: "Betreiber"
  }
}), new Field({
  name: "website",
  type: String,
  key: false,
  label: {
    en: "Website",
    de: "Website"
  }
}), new Field({
  name: "lastUpdated",
  type: String,
  key: false,
  label: {
    en: "Last Updated",
    de: "Zuletzt aktualisiert"
  }
}), new Field({
  name: "lat",
  type: Number,
  key: false,
  label: {
    en: "Latitude",
    de: "Breitengrad"
  }
}), new Field({
  name: "lon",
  type: Number,
  key: false,
  label: {
    en: "Longitude",
    de: "L\xE4ngengrad"
  }
}), new Field({
  name: "shape",
  type: JSON,
  key: false,
  label: {
    en: "Shape",
    de: "Form"
  }
}), new Field({
  name: "conditionGradeClass",
  type: String,
  key: false,
  label: {
    en: "Condition Grade Class",
    de: "Zustandsnotenklasse"
  }
}), new Field({
  name: "conditionGradeEvaluation",
  type: String,
  key: false,
  label: {
    en: "Condition Grade Evaluation",
    de: "Zustandsnotenbewertung"
  }
}), new Field({
  name: "districtCode",
  type: String,
  key: false,
  label: {
    en: "District Code",
    de: "Bezirkscode"
  }
}), new Field({
  name: "district",
  type: String,
  key: false,
  label: {
    en: "District",
    de: "Bezirk"
  }
}), new Field({
  name: "stage",
  type: String,
  key: false,
  label: {
    en: "Stage",
    de: "Stufe"
  }
}), new Field({
  name: "lengthClass",
  type: String,
  key: false,
  label: {
    en: "Length Class",
    de: "L\xE4ngenklasse"
  }
}), new Field({
  name: "constructionYear",
  type: String,
  key: false,
  label: {
    en: "Construction Year",
    de: "Baujahr"
  }
}), new Field({
  name: "materialClass",
  type: String,
  key: false,
  label: {
    en: "Material Class",
    de: "Materialklasse"
  }
}), new Field({
  name: "construction",
  type: String,
  key: false,
  label: {
    en: "Construction",
    de: "Konstruktion"
  }
}), new Field({
  name: "loadCapacityIndex",
  type: String,
  key: false,
  label: {
    en: "Load Capacity Index",
    de: "Lastkapazit\xE4tsindex"
  }
}), new Field({
  name: "partOfBastList",
  type: String,
  key: false,
  label: {
    en: "Part of BASt List",
    de: "Teil der BASt Liste"
  }
}), new Field({
  name: "dataDeliveryDate",
  type: String,
  key: false,
  label: {
    en: "Data Delivery Date",
    de: "Datenlieferdatum"
  }
}), new Field({
  name: "nrStatus",
  type: String,
  key: false,
  label: {
    en: "NR Status",
    de: "NR Status"
  }
}), new Field({
  name: "materialSubstructure",
  type: String,
  key: false,
  label: {
    en: "Material Substructure",
    de: "Material Unterbau"
  }
}), new Field({
  name: "constructionYearSubstructure",
  type: String,
  key: false,
  label: {
    en: "Construction Year Substructure",
    de: "Baujahr Unterbau"
  }
}), new Field({
  name: "stateNumber",
  type: String,
  key: false,
  label: {
    en: "State Number",
    de: "Staatsnummer"
  }
}), new Field({
  name: "stateName",
  type: String,
  key: false,
  label: {
    en: "State Name",
    de: "Staatsname"
  }
}), new Field({
  name: "maintenanceOffice",
  type: String,
  key: false,
  label: {
    en: "Maintenance Office",
    de: "Autobahnmeisterei"
  }
}), new Field({
  name: "maintenanceOfficeDetails",
  type: JSON,
  key: false,
  label: {
    en: "Maintenance Office Details",
    de: "Details Autobahnmeisterei"
  }
}), new Field({
  name: "office",
  type: String,
  key: false,
  label: {
    en: "Office",
    de: "B\xFCro"
  }
}), new Field({
  name: "structureNumber",
  type: String,
  key: false,
  label: {
    en: "Structure Number",
    de: "Strukturnummer"
  }
}), new Field({
  name: "partialStructureNumber",
  type: String,
  key: false,
  label: {
    en: "Partial Structure Number",
    de: "Teilstrukturnummer"
  }
}), new Field({
  name: "partialStructureType",
  type: String,
  key: false,
  label: {
    en: "Partial Structure Type",
    de: "Teilstrukturtyp"
  }
}), new Field({
  name: "structureName",
  type: String,
  key: false,
  label: {
    en: "Structure Name",
    de: "Strukturname"
  }
}), new Field({
  name: "location",
  type: String,
  key: false,
  label: {
    en: "Location",
    de: "Standort"
  }
}), new Field({
  name: "streetName",
  type: String,
  key: false,
  label: {
    en: "Street Name",
    de: "Stra\xDFenname"
  }
}), new Field({
  name: "streetType",
  type: String,
  key: false,
  label: {
    en: "Street Type",
    de: "Stra\xDFentyp"
  }
}), new Field({
  name: "length",
  type: Number,
  key: false,
  label: {
    en: "Length",
    de: "L\xE4nge"
  }
}), new Field({
  name: "width",
  type: Number,
  key: false,
  label: {
    en: "Width",
    de: "Breite"
  }
}), new Field({
  name: "area",
  type: Number,
  key: false,
  label: {
    en: "Area",
    de: "Fl\xE4che"
  }
}), new Field({
  name: "highestConditionAbove",
  type: String,
  key: false,
  label: {
    en: "Highest Condition Above",
    de: "H\xF6chster Zustand oben"
  }
}), new Field({
  name: "highestConditionBelow",
  type: String,
  key: false,
  label: {
    en: "Highest Condition Below",
    de: "H\xF6chster Zustand unten"
  }
}), new Field({
  name: "loadPositionOne",
  type: String,
  key: false,
  label: {
    en: "Load Position One",
    de: "Lastposition Eins"
  }
}), new Field({
  name: "loadPositionTwo",
  type: String,
  key: false,
  label: {
    en: "Load Position Two",
    de: "Lastposition Zwei"
  }
}), new Field({
  name: "ageClass",
  type: String,
  key: false,
  label: {
    en: "Age Class",
    de: "Altersklasse"
  }
}), new Field({
  name: "yearLastMainInspection",
  type: String,
  key: false,
  label: {
    en: "Year Last Main Inspection",
    de: "Jahr der letzten Hauptpr\xFCfung"
  }
}), new Field({
  name: "partialStructureNetwork",
  type: String,
  key: false,
  label: {
    en: "Partial Structure Network",
    de: "Teilstrukturnetzwerk"
  }
}), new Field({
  name: "heavyTrafficBlock",
  type: String,
  key: false,
  label: {
    en: "Heavy Traffic Block",
    de: "Schwerverkehrsblock"
  }
}), new Field({
  name: "xCoordinate",
  type: String,
  key: false,
  label: {
    en: "X Coordinate",
    de: "X-Koordinate"
  }
}), new Field({
  name: "yCoordinate",
  type: String,
  key: false,
  label: {
    en: "Y Coordinate",
    de: "Y-Koordinate"
  }
}), new Field({
  name: "conditionGrade",
  type: String,
  key: false,
  label: {
    en: "Condition Grade",
    de: "Zustandsnote"
  }
}), new Field({
  name: "substanceIndex2019",
  type: String,
  key: false,
  label: {
    en: "Substance Index 2019",
    de: "Substanzindex 2019"
  }
}), new Field({
  name: "basis",
  type: String,
  key: false,
  label: {
    en: "Basis",
    de: "Basis"
  }
}), new Field({
  name: "extension",
  type: String,
  key: false,
  label: {
    en: "Extension",
    de: "Erweiterung"
  }
}), new Field({
  name: "urbanArea",
  type: String,
  key: false,
  label: {
    en: "Urban Area",
    de: "Stadtgebiet"
  }
}), new Field({
  name: "residentsPerKm2",
  type: String,
  key: false,
  label: {
    en: "Residents per km\xB2",
    de: "Einwohner pro km\xB2"
  }
}), new Field({
  name: "trafficAreaUsageDensity",
  type: String,
  key: false,
  label: {
    en: "Traffic Area Usage Density",
    de: "Verkehrsfl\xE4chennutzungsdichte"
  }
}), new Field({
  name: "adjustedCondition",
  type: String,
  key: false,
  label: {
    en: "Adjusted Condition",
    de: "Angepasster Zustand"
  }
}), new Field({
  name: "trafficVehicles",
  type: String,
  key: false,
  label: {
    en: "Traffic Vehicles",
    de: "Verkehrsfahrzeuge"
  }
}), new Field({
  name: "trafficHeavyVehicles",
  type: String,
  key: false,
  label: {
    en: "Traffic Heavy Vehicles",
    de: "Verkehr schwere Fahrzeuge"
  }
}), new Field({
  name: "usageType",
  type: BridgeUsageType,
  key: false,
  label: {
    en: "Usage Type",
    de: "Nutzungsart"
  }
}), new Field({
  name: "germanRailwaysData",
  type: JSON,
  key: false,
  label: {
    en: "German Railways Data",
    de: "Deutsche Bahn-Daten"
  }
}), new Field({
  name: "projects",
  type: JSON,
  key: false,
  label: {
    en: "Projects",
    de: "Projekte"
  }
})];
_Bridge.relationships = [];
var Bridge = _Bridge;

// src/model/project.ts
var InvoiceType = /* @__PURE__ */ ((InvoiceType2) => {
  InvoiceType2["direct"] = "direct";
  InvoiceType2["indirect"] = "indirect";
  return InvoiceType2;
})(InvoiceType || {});
var _Project = class _Project extends Entity {
  constructor(properties) {
    super(properties);
    this.name = properties.name;
    this.description = properties.description;
    this.startDate = new Date(properties.startDate);
    this.endDate = properties.endDate ? new Date(properties.endDate) : void 0;
    this.customer = properties.customer;
    this.objects = properties.objects || [];
    this.partners = properties.partners || [];
    this.documents = properties.documents || [];
    this.entitlements = properties.entitlements || {};
    this.sites = properties.sites || [];
    this.partnerships = properties.partnerships || [];
    this.invoiceType = properties.invoiceType || "direct" /* direct */;
  }
};
_Project.type = new EntityType({
  public: false,
  type: _Project,
  name: "Project",
  label: {
    en: "Project",
    de: "Projekt"
  }
});
_Project.fields = [new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "description",
  type: String,
  key: false,
  label: {
    en: "Description",
    de: "Beschreibung"
  }
}), new Field({
  name: "startDate",
  type: Date,
  key: false,
  label: {
    en: "Start Date",
    de: "Startdatum"
  }
}), new Field({
  name: "endDate",
  type: Date,
  key: false,
  label: {
    en: "End Date",
    de: "Enddatum"
  }
}), new Field({
  name: "customer",
  type: String,
  key: false,
  label: {
    en: "Customer",
    de: "Kunde"
  }
}), new Field({
  name: "objects",
  type: JSON,
  key: false,
  label: {
    en: "Objects",
    de: "Objekte"
  }
}), new Field({
  name: "partners",
  type: JSON,
  key: false,
  label: {
    en: "Partners",
    de: "Partner"
  }
}), new Field({
  name: "documents",
  type: JSON,
  key: false,
  label: {
    en: "Documents",
    de: "Dokumente"
  }
}), new Field({
  name: "entitlements",
  type: JSON,
  key: false,
  label: {
    en: "Entitlements",
    de: "Berechtigungen"
  }
}), new Field({
  name: "sites",
  type: JSON,
  key: false,
  label: {
    en: "Sites",
    de: "Liegenschaften"
  }
}), new Field({
  name: "partnerships",
  type: JSON,
  key: false,
  label: {
    en: "Partnerships",
    de: "Partnerschaften"
  }
}), new Field({
  name: "invoiceType",
  type: InvoiceType,
  key: false
})];
_Project.relationships = [];
var Project = _Project;
var _ProjectEntitlement = class _ProjectEntitlement extends Entity {
  constructor(props) {
    super(props);
    this.project = props.project;
    this.invitedBy = props.invitedBy;
    this.company = props.company;
    this.roles = props.roles;
    this.primaryContactEmail = props.primaryContactEmail;
  }
};
_ProjectEntitlement.type = new EntityType({
  public: false,
  type: _ProjectEntitlement,
  name: "ProjectEntitlement",
  label: {
    en: "Project Entitlement",
    de: "Projektberechtigung"
  }
});
_ProjectEntitlement.fields = [new Field({
  name: "invitedBy",
  type: String,
  key: false,
  label: {
    en: "Invited by",
    de: "Eingeladen von"
  }
}), new Field({
  name: "company",
  type: String,
  key: false,
  label: {
    en: "Company",
    de: "Unternehmen"
  }
}), new Field({
  name: "roles",
  type: JSON,
  key: false,
  label: {
    en: "Roles",
    de: "Rollen"
  }
}), new Field({
  name: "primaryContactEmail",
  type: String,
  key: false,
  label: {
    en: "Primary Contact E-mail",
    de: "E-Mail Prim\xE4rkontakt"
  }
})];
_ProjectEntitlement.relationships = [];
var ProjectEntitlement = _ProjectEntitlement;

// src/model/process.ts
var ProcessDefinitionType = /* @__PURE__ */ ((ProcessDefinitionType2) => {
  ProcessDefinitionType2["unstructuredCase"] = "unstructuredCase";
  ProcessDefinitionType2["checklist"] = "checklist";
  ProcessDefinitionType2["structuredProcess"] = "structuredProcess";
  return ProcessDefinitionType2;
})(ProcessDefinitionType || {});
var _ProcessDefinition = class _ProcessDefinition extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.name = props.name;
    this.origin = props.origin;
    this.type = props.type;
    this.data = props.data || {};
    this.role = props.role;
    this.schemaCategory = props.schemaCategory;
    this.fields = props.fields;
    this.period = props.period;
  }
};
_ProcessDefinition.type = new EntityType({
  public: false,
  type: _ProcessDefinition,
  name: "ProcessDefinition",
  label: {
    en: "Process Definition",
    de: "Processdefinition"
  }
});
_ProcessDefinition.fields = [new Field({
  name: "id",
  type: String,
  key: false,
  label: {
    en: "ID",
    de: "ID"
  }
}), new Field({
  name: "origin",
  type: String,
  key: false,
  label: {
    en: "Origin",
    de: "Ursprung"
  }
}), new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "type",
  type: String,
  key: false,
  label: {
    en: "Type",
    de: "Type"
  }
}), new Field({
  name: "data",
  type: JSON,
  key: false,
  label: {
    en: "Data",
    de: "Daten"
  }
}), new Field({
  name: "role",
  type: String,
  key: false,
  label: {
    en: "Role",
    de: "Rolle"
  }
})];
var ProcessDefinition = _ProcessDefinition;
var _Checklist = class _Checklist extends Entity {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.description = props.description;
    this.role = props.role;
    this.roleCheck = props.roleCheck;
    this.roleStart = props.roleStart;
    this.fields = props.fields || [];
    this.data = props.data || [];
    this.signatureRequired = props.signatureRequired;
    this.allowsAdditionalDocuments = props.allowsAdditionalDocuments;
    this.recurrence = props.recurrence;
  }
};
_Checklist.type = new EntityType({
  public: false,
  type: _Checklist,
  name: "Checklist",
  label: {
    en: "Checklist",
    de: "Checkliste"
  }
});
_Checklist.fields = [new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "description",
  type: String,
  key: false,
  label: {
    en: "Description",
    de: "Beschreibung"
  }
}), new Field({
  name: "role",
  type: String,
  key: false,
  label: {
    en: "Role",
    de: "Rolle"
  }
}), new Field({
  name: "roleCheck",
  type: Date,
  key: false,
  label: {
    en: "Role (Check)",
    de: "Rolle (Pr\xFCfung)"
  }
}), new Field({
  name: "roleStart",
  type: Date,
  key: false,
  label: {
    en: "Role (Start)",
    de: "Rolle (Start)"
  }
}), new Field({
  name: "fields",
  type: JSON,
  key: false,
  label: {
    en: "Fields",
    de: "Felder"
  }
}), new Field({
  name: "data",
  type: JSON,
  key: false,
  label: {
    en: "Data",
    de: "Daten"
  }
}), new Field({
  name: "signatureRequired",
  type: Boolean,
  key: false,
  label: {
    en: "Signature required",
    de: "Unterschrift erforderlich"
  }
}), new Field({
  name: "allowsAdditionalDocuments",
  type: Boolean,
  key: false,
  label: {
    en: "Allows for additional documents",
    de: "Zus\xE4tzliche Dokumente erlaubt"
  }
}), new Field({
  name: "recurrence",
  type: Number,
  key: false,
  label: {
    en: "Recurrence (d)",
    de: "Wiederkehr (d)"
  }
})];
_Checklist.relationships = [];
var Checklist = _Checklist;
var TaskState = /* @__PURE__ */ ((TaskState2) => {
  TaskState2[TaskState2["open"] = 0] = "open";
  TaskState2[TaskState2["active"] = 1] = "active";
  TaskState2[TaskState2["completed"] = 2] = "completed";
  TaskState2[TaskState2["aborted"] = 3] = "aborted";
  return TaskState2;
})(TaskState || {});
var _Task = class _Task extends Entity {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.description = props.description;
    this.created = new Date(props.created);
    this.createdBy = props.createdBy;
    this.lastModified = new Date(props.lastModified);
    this.lastModifiedBy = props.lastModifiedBy;
    this.due = props.due ? new Date(props.due) : void 0;
    this.state = props.state || 0 /* open */;
    this.definition = props.definition;
    this.asset = props.asset;
    this.comments = props.comments || [];
    this.photos = props.photos || [];
  }
};
_Task.type = new EntityType({
  public: false,
  type: _Task,
  name: "Task",
  label: {
    en: "Task",
    de: "Task"
  }
});
_Task.fields = [new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "description",
  type: String,
  key: false,
  label: {
    en: "Description",
    de: "Beschreibung"
  }
}), new Field({
  name: "created",
  type: Date,
  key: false,
  label: {
    en: "Created",
    de: "Angelegt"
  }
}), new Field({
  name: "createdBy",
  type: String,
  key: false,
  label: {
    en: "Created by",
    de: "Angelegt von"
  }
}), new Field({
  name: "lastModified",
  type: Date,
  key: false,
  label: {
    en: "Last modified",
    de: "Zuletzt bearbeitet"
  }
}), new Field({
  name: "lastModifiedBy",
  type: Date,
  key: false,
  label: {
    en: "Last modified by",
    de: "Zuletzt bearbeitet by"
  }
}), new Field({
  name: "state",
  type: TaskState,
  key: false,
  label: {
    en: "State",
    de: "Status"
  }
}), new Field({
  name: "definition",
  type: JSON,
  key: false,
  label: {
    en: "Definition",
    de: "Definition"
  }
}), new Field({
  name: "comments",
  type: JSON,
  key: false,
  label: {
    en: "Comments",
    de: "Kommentare"
  }
}), new Field({
  name: "photos",
  type: JSON,
  key: false,
  label: {
    en: "Photos",
    de: "fotos"
  }
})];
_Task.relationships = [
  new Relationship({
    name: "asset",
    type: Asset,
    cardinality: "ManyToOne" /* ManyToOne */,
    directionality: "Unidirectional" /* Unidirectional */,
    label: {
      en: "Asset",
      de: "Ger\xE4t"
    }
  })
  /*new Relationship({
      name: 'definition',
      type: ProcessDefinition,
      cardinality: Cardinality.ManyToOne,
      directionality: Directionality.Unidirectional,
      label: {
          en: 'Definition',
          de: 'Definition'
      }
  })*/
];
var Task = _Task;

// src/model/role.ts
var RoleType = /* @__PURE__ */ ((RoleType2) => {
  RoleType2["role"] = "role";
  RoleType2["parameterizableRole"] = "parameterizableRole";
  RoleType2["parameterizedRole"] = "parameterizedRole";
  RoleType2["partnerDelegation"] = "partnerDelegation";
  return RoleType2;
})(RoleType || {});
var Entitlement = /* @__PURE__ */ ((Entitlement2) => {
  Entitlement2["projectBilling"] = "projectBilling";
  Entitlement2["projectManagement"] = "projectManagement";
  return Entitlement2;
})(Entitlement || {});
var _Role = class _Role extends Entity {
  static fromTemplate(template, parameterID, parameterObject, parameterNameValue) {
    const parameterizedBy = {};
    if (parameterID === "Site") {
      if (!parameterObject.street || !parameterObject.streetNumber || !parameterObject.streetNumber || !parameterObject.postalCode || !parameterObject.city || !parameterObject.country) {
        throw "Site object incomplete";
      }
      parameterizedBy[parameterID] = {
        _id: parameterObject._id,
        street: parameterObject.street,
        streetNumber: parameterObject.streetNumber,
        postalCode: parameterObject.postalCode,
        city: parameterObject.city,
        country: parameterObject.country
      };
    } else if (parameterID === "Project") {
      if (!parameterObject.name) {
        throw "Project object incomplete";
      }
      parameterizedBy[parameterID] = {
        _id: parameterObject._id,
        name: parameterObject.name
      };
    } else {
      throw `Unsupported role parameter type ${parameterID}`;
    }
    return new _Role({
      type: "parameterizedRole" /* parameterizedRole */,
      id: `${template.id}:${parameterObject._id}`,
      name: `${template.name} (${parameterNameValue})`,
      description: template.description,
      parameterizedBy,
      template: template._id
    });
  }
  static partnerDelegation(role, issuer, delegate) {
    if (role.type === "parameterizableRole" /* parameterizableRole */) {
      throw "Cannot create a partner delegation from a parameterizable role.";
    }
    if (role.type === "partnerDelegation" /* partnerDelegation */) {
      throw "Cannot create a partner delegation from a partner delegation.";
    }
    let id = `${issuer.id}:${role.id}`;
    let name = `${issuer.name}:${role.name}`;
    return new _Role({
      type: "partnerDelegation" /* partnerDelegation */,
      id,
      name,
      description: role.description,
      issuer: issuer._id,
      delegate: delegate._id,
      principal: role._id,
      parameterizedBy: role.parameterizedBy
    });
  }
  constructor(props) {
    super(props);
    this.id = props.id;
    this.name = props.name;
    this.description = props.description;
    this.type = props.type || "role" /* role */;
    this.template = props.template;
    this.issuer = props.issuer;
    this.delegate = props.delegate;
    this.principal = props.principal;
    this.instances = props.instances || [];
    this.delegates = props.delegates || [];
    this.parameterizableBy = props.parameterizableBy || [];
    this.parameterizedBy = props.parameterizedBy || {};
  }
  getRoleID() {
    if (this.type === "role" /* role */) {
      return this.id;
    } else if (this.type === "parameterizableRole" /* parameterizableRole */) {
      return this.id;
    } else if (this.type === "parameterizedRole" /* parameterizedRole */) {
      return this.id.split(":")[0].trim();
    } else {
      return this.id.split(":")[1].split("(")[0].trim();
    }
  }
  getParameterID() {
    if (this.type === "role" /* role */) {
      return null;
    } else if (this.type === "parameterizableRole" /* parameterizableRole */) {
      return null;
    } else if (this.type === "parameterizedRole" /* parameterizedRole */) {
      return this.id.split(":")[1].trim();
    } else {
      return this.id.split(":")[2].trim();
    }
  }
  getRoleName() {
    if (this.type === "role" /* role */) {
      return this.name;
    } else if (this.type === "parameterizableRole" /* parameterizableRole */) {
      return this.name;
    } else if (this.type === "parameterizedRole" /* parameterizedRole */) {
      return this.name.split("(")[0].trim();
    } else {
      return this.name.split(":")[1].split("(")[0];
    }
  }
  getParameterName() {
    if (this.type === "role" /* role */) {
      return null;
    } else if (this.type === "parameterizableRole" /* parameterizableRole */) {
      return null;
    } else if (this.type === "parameterizedRole" /* parameterizedRole */) {
      return this.name.split("(")[1].split(")")[0].trim();
    } else {
      return this.name.split("(")[1].split(")")[0].trim();
    }
  }
};
_Role.type = new EntityType({
  public: false,
  type: _Role,
  name: "Role",
  label: {
    en: "Role",
    de: "Rolle"
  }
});
_Role.fields = [new Field({
  name: "id",
  type: String,
  key: false,
  label: {
    en: "ID",
    de: "ID"
  }
}), new Field({
  name: "name",
  type: String,
  key: false,
  label: {
    en: "Name",
    de: "Name"
  }
}), new Field({
  name: "description",
  type: String,
  key: false,
  label: {
    en: "Description",
    de: "Beschreibung"
  }
}), new Field({
  name: "type",
  type: RoleType,
  key: false,
  label: {
    en: "Type",
    de: "Typ"
  }
}), new Field({
  name: "parameterizableBy",
  type: JSON,
  key: false,
  label: {
    en: "Parameterizable by",
    de: "Parametrierbar durch"
  }
}), new Field({
  name: "parameterizedBy",
  type: JSON,
  key: false,
  label: {
    en: "Parameterized by",
    de: "Parametriert durch"
  }
}), new Field({
  name: "issuer",
  type: String,
  key: false,
  label: {
    en: "Issuer",
    de: "Herausgeber"
  }
}), new Field({
  name: "template",
  type: String,
  key: false,
  label: {
    en: "Template",
    de: "Vorlage"
  }
}), new Field({
  name: "principal",
  type: String,
  key: false,
  label: {
    en: "Principal",
    de: "Prinzipal"
  }
}), new Field({
  name: "delegate",
  type: String,
  key: false,
  label: {
    en: "Delegate",
    de: "Delegierter"
  }
}), new Field({
  name: "instances",
  type: JSON,
  key: false,
  label: {
    en: "Instances",
    de: "Instanzen"
  }
}), new Field({
  name: "delegates",
  type: JSON,
  key: false,
  label: {
    en: "Delegates",
    de: "Delegierterte"
  }
})];
_Role.relationships = [new Relationship({
  name: "roleAssignments",
  type: Entity,
  // RoleAssignment
  typeName: "RoleAssignment",
  cardinality: "OneToMany" /* OneToMany */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "role",
  label: {
    en: "Role Assignments",
    de: "Rollenzuordnung"
  }
})];
var Role = _Role;
var _RoleAssignment = class _RoleAssignment extends Entity {
  constructor(props) {
    super(props);
    this.user = props.user;
    this.role = props.role;
  }
};
_RoleAssignment.type = new EntityType({
  public: false,
  type: _RoleAssignment,
  name: "RoleAssignment",
  label: {
    en: "Role Assignment",
    de: "Rollenzuweisung"
  }
});
_RoleAssignment.fields = [];
_RoleAssignment.relationships = [new Relationship({
  name: "user",
  type: User,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "roleAssignments",
  label: {
    en: "User",
    de: "Nutzer"
  }
}), new Relationship({
  name: "role",
  type: Role,
  cardinality: "ManyToOne" /* ManyToOne */,
  directionality: "Bidirectional" /* Bidirectional */,
  inverseName: "roleAssignments",
  label: {
    en: "Role",
    de: "Rolle"
  }
})];
var RoleAssignment = _RoleAssignment;

// src/model/energy.ts
var EnergyFacility = class extends Entity {
  constructor(props) {
    super(props);
    this.id = props.id;
    this.operatorID = props.operatorID;
    this.operatorPersonType = props.operatorPersonType;
    this.operatorMaskedName = props.operatorMaskedName;
    this.operatorMaStRNumber = props.operatorMaStRNumber;
    this.operatorName = props.operatorName;
    this.operationalStatusID = props.operationalStatusID;
    this.operationalStatusName = props.operationalStatusName;
    this.latitude = props.latitude;
    this.federalStateID = props.federalStateID;
    this.federalState = props.federalState;
    this.dateofLastUpdate = new Date(props.dateofLastUpdate);
    this.unitRegistrationDate = new Date(props.unitRegistrationDate);
    this.unitName = props.unitName;
    this.finalShutdownDate = props.finalShutdownDate;
    this.parcel = props.parcel;
    this.district = props.district;
    this.municipality = props.municipality;
    this.municipalityCode = props.municipalityCode;
    this.plannedCommissioningDate = props.plannedCommissioningDate ? new Date(props.plannedCommissioningDate) : void 0;
    this.houseNumber = props.houseNumber;
    this.commissioningDate = props.commissioningDate ? new Date(props.commissioningDate) : void 0;
    this.isGridOperatorReviewComplete = props.isGridOperatorReviewComplete;
    this.longitude = props.longitude;
    this.countryID = props.countryID;
    this.county = props.county;
    this.locationID = props.locationID;
    this.locationMaStRNumber = props.locationMaStRNumber;
    this.maStRNumber = props.maStRNumber;
    this.gridOperatorID = props.gridOperatorID;
    this.gridOperatorMaskedName = props.gridOperatorMaskedName;
    this.gridOperatorMaStRNumber = props.gridOperatorMaStRNumber;
    this.gridOperatorName = props.gridOperatorName;
    this.gridOperatorPersonType = props.gridOperatorPersonType;
    this.city = props.city;
    this.postalCode = props.postalCode;
    this.street = props.street;
    this.systemStatusID = props.systemStatusID;
    this.systemStatusName = props.systemStatusName;
    this.type = props.type;
    this.approvalReferenceNumber = props.approvalReferenceNumber;
    this.grossCapacity = props.grossCapacity;
    this.eegCommissioningDate = props.eegCommissioningDate ? new Date(props.eegCommissioningDate) : void 0;
    this.eegInstalledCapacity = props.eegInstalledCapacity;
    this.eegUnitMaStRNumber = props.eegUnitMaStRNumber;
    this.eegUnitRegistrationDate = props.eegUnitRegistrationDate ? new Date(props.eegUnitRegistrationDate) : void 0;
    this.eegUnitKey = props.eegUnitKey;
    this.eegSubsidy = props.eegSubsidy;
    this.subsidyNumbers = props.subsidyNumbers;
    this.energyCarrierID = props.energyCarrierID;
    this.energyCarrierName = props.energyCarrierName;
    this.approvalAuthority = props.approvalauthority;
    this.approvalRegistrationDate = props.approvalRegistrationDate ? new Date(props.approvalRegistrationDate) : void 0;
    this.approvalMaStRNumber = props.approvalMaStRNumber;
    this.groupingObjects = props.groupingObjects;
    this.groupingObjectsIDs = props.groupingObjectsIDs;
    this.hasFlexibilityPremium = props.hasFlexibilityPremium;
    this.isAnonymized = props.isAnonymized;
    this.isCommunityEnergy = props.isCommunityEnergy;
    this.isUnitEmergencyPowerGenerator = props.isUnitEmergencyPowerGenerator;
    this.powerPlantName = props.powerPlantName;
    this.powerPlantBlockName = props.powerPlantBlockName;
    this.unitLocation = props.unitLocation;
    this.unitLocationDescription = props.unitLocationDescription;
    this.powerLimitation = props.powerLimitation;
    this.tenantElectricityRegistered = props.tenantElectricityRegistered;
    this.migrationUnitMaStRNumber = props.migrationUnitMaStRNumber;
    this.netNominalCapacity = props.netNominalCapacity;
    this.usageAreaBuilding = props.usageAreaBuilding;
    this.protoTypeFacility = props.protoTypeFacility;
    this.controlArea = props.controlArea;
    this.anonymizedLocation = props.anonymizedLocation;
    this.electricityStorageTechnology = props.electricityStorageTechnology;
    this.electricityStorageTechnologyDescription = props.electricityStorageTechnologyDescription;
    this.voltageLevelID = props.voltageLevelID;
    this.voltageLevelName = props.voltageLevelName;
    this.typeOfAreaDescription = props.typeOfAreaDescription;
    this.electricityGenerationTechnologyID = props.electricityGenerationTechnologyID;
    this.electricityGenerationTechnology = props.electricityGenerationTechnology;
    this.typeDesignation = props.typeDesignation;
    this.fullPartialFeedIn = props.fullPartialFeedIn;
    this.fullPartialFeedInDescription = props.fullPartialFeedInDescription;
    this.hydroPowerUpgrade = props.hydroPowerUpgrade;
  }
};
EnergyFacility.fields = [
  new Field({
    name: "id",
    type: Number,
    key: true
  }),
  new Field({
    name: "operatorID",
    type: Number,
    key: false
  }),
  new Field({
    name: "operatorPersonType",
    type: Number,
    key: false
  }),
  new Field({
    name: "operatorMaskedName",
    type: String,
    key: false
  }),
  new Field({
    name: "operatorMaStRNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "operatorName",
    type: String,
    key: false
  }),
  new Field({
    name: "operationalStatusID",
    type: Number,
    key: false
  }),
  new Field({
    name: "operationalStatusName",
    type: String,
    key: false
  }),
  new Field({
    name: "latitude",
    type: Number,
    key: false
  }),
  new Field({
    name: "federalStateID",
    type: Number,
    key: false
  }),
  new Field({
    name: "federalState",
    type: String,
    key: false
  }),
  new Field({
    name: "dateofLastUpdate",
    type: Date,
    key: false
  }),
  new Field({
    name: "unitRegistrationDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "unitName",
    type: String,
    key: false
  }),
  new Field({
    name: "finalShutdownDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "parcel",
    type: String,
    key: false
  }),
  new Field({
    name: "district",
    type: String,
    key: false
  }),
  new Field({
    name: "municipality",
    type: String,
    key: false
  }),
  new Field({
    name: "municipalityCode",
    type: String,
    key: false
  }),
  new Field({
    name: "plannedCommissioningDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "houseNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "commissioningDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "isGridOperatorReviewComplete",
    type: Boolean,
    key: false
  }),
  new Field({
    name: "longitude",
    type: Number,
    key: false
  }),
  new Field({
    name: "countryID",
    type: Number,
    key: false
  }),
  new Field({
    name: "county",
    type: String,
    key: false
  }),
  new Field({
    name: "locationID",
    type: Number,
    key: false
  }),
  new Field({
    name: "locationMaStRNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "maStRNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "gridOperatorID",
    type: Number,
    key: false
  }),
  new Field({
    name: "gridOperatorMaskedName",
    type: Number,
    key: false
  }),
  new Field({
    name: "gridOperatorMaStRNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "gridOperatorName",
    type: String,
    key: false
  }),
  new Field({
    name: "gridOperatorPersonType",
    type: String,
    key: false
  }),
  new Field({
    name: "city",
    type: String,
    key: false
  }),
  new Field({
    name: "postalCode",
    type: String,
    key: false
  }),
  new Field({
    name: "street",
    type: String,
    key: false
  }),
  new Field({
    name: "systemStatusID",
    type: Number,
    key: false
  }),
  new Field({
    name: "systemStatusName",
    type: String,
    key: false
  }),
  new Field({
    name: "type",
    type: Number,
    key: false
  }),
  new Field({
    name: "approvalReferenceNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "numberofSolarModules",
    type: Number,
    key: false
  }),
  new Field({
    name: "batteryTechnology",
    type: String,
    key: false
  }),
  new Field({
    name: "biomassType",
    type: Number,
    key: false
  }),
  new Field({
    name: "biomassTypeDescription",
    type: String,
    key: false
  }),
  new Field({
    name: "grossCapacity",
    type: Number,
    key: false
  }),
  new Field({
    name: "eegCommissioningDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "eegInstalledCapacity",
    type: Number,
    key: false
  }),
  new Field({
    name: "eegUnitMaStRNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "eegUnitRegistrationDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "eegUnitKey",
    type: String,
    key: false
  }),
  new Field({
    name: "eegSubsidy",
    type: String,
    key: false
  }),
  new Field({
    name: "subsidyNumbers",
    type: String,
    key: false
  }),
  new Field({
    name: "energyCarrierID",
    type: Number,
    key: false
  }),
  new Field({
    name: "energyCarrierName",
    type: String,
    key: false
  }),
  new Field({
    name: "approvalAuthority",
    type: String,
    key: false
  }),
  new Field({
    name: "approvalRegistrationDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "approvalMaStRNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "groupingObjects",
    type: String,
    key: false
  }),
  new Field({
    name: "groupingObjectsIDs",
    type: String,
    key: false
  }),
  new Field({
    name: "hasFlexibilityPremium",
    type: Boolean,
    key: false
  }),
  new Field({
    name: "mainOrientationofSolarModules",
    type: String,
    key: false
  }),
  new Field({
    name: "mainOrientationofSolarModulesDescription",
    type: String,
    key: false
  }),
  new Field({
    name: "mainFuelID",
    type: Number,
    key: false
  }),
  new Field({
    name: "mainFuelName",
    type: String,
    key: false
  }),
  new Field({
    name: "mainTiltAngleofSolarModules",
    type: String,
    key: false
  }),
  new Field({
    name: "windTurbineManufacturer",
    type: String,
    key: false
  }),
  new Field({
    name: "windTurbineManufacturerDescription",
    type: String,
    key: false
  }),
  new Field({
    name: "isAnonymized",
    type: Boolean,
    key: false
  }),
  new Field({
    name: "isCommunityEnergy",
    type: Boolean,
    key: false
  }),
  new Field({
    name: "isUnitEmergencyPowerGenerator",
    type: Boolean,
    key: false
  }),
  new Field({
    name: "powerPlantName",
    type: String,
    key: false
  }),
  new Field({
    name: "powerPlantBlockName",
    type: String,
    key: false
  }),
  new Field({
    name: "chpUnitElectricalCapacity",
    type: Number,
    key: false
  }),
  new Field({
    name: "chpUnitCommissioningDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "chpUnitMaStRNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "chpUnitRegistrationDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "chpSubsidy",
    type: String,
    key: false
  }),
  new Field({
    name: "unitLocation",
    type: String,
    key: false
  }),
  new Field({
    name: "unitLocationDescription",
    type: String,
    key: false
  }),
  new Field({
    name: "powerLimitation",
    type: String,
    key: false
  }),
  new Field({
    name: "tenantElectricityRegistered",
    type: String,
    key: false
  }),
  new Field({
    name: "migrationUnitMaStRNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "hubHeightofWindTurbine",
    type: Number,
    key: false
  }),
  new Field({
    name: "netNominalCapacity",
    type: Number,
    key: false
  }),
  new Field({
    name: "usableStorageCapacity",
    type: Number,
    key: false
  }),
  new Field({
    name: "usageAreaBuilding",
    type: String,
    key: false
  }),
  new Field({
    name: "pilotWindTurbine",
    type: Boolean,
    key: false
  }),
  new Field({
    name: "prototypeFacility",
    type: Boolean,
    key: false
  }),
  new Field({
    name: "controlArea",
    type: String,
    key: false
  }),
  new Field({
    name: "anonymizedLocation",
    type: String,
    key: false
  }),
  new Field({
    name: "electricityStorageTechnology",
    type: String,
    key: false
  }),
  new Field({
    name: "electricityStorageTechnologyDescription",
    type: String,
    key: false
  }),
  new Field({
    name: "voltageLevelID",
    type: Number,
    key: false
  }),
  new Field({
    name: "voltageLevelName",
    type: String,
    key: false
  }),
  new Field({
    name: "typeOfAreaDescription",
    type: String,
    key: false
  }),
  new Field({
    name: "electricityGenerationTechnologyID",
    type: Number,
    key: false
  }),
  new Field({
    name: "electricityGenerationTechnology",
    type: String,
    key: false
  }),
  new Field({
    name: "typeDesignation",
    type: String,
    key: false
  }),
  new Field({
    name: "fullPartialFeedIn",
    type: Number,
    key: false
  }),
  new Field({
    name: "fullPartialFeedInDescription",
    type: String,
    key: false
  }),
  new Field({
    name: "hydroPowerUpgrade",
    type: String,
    key: false
  })
];
var _PVPlant = class _PVPlant extends EnergyFacility {
  constructor(props) {
    super(props);
    this.numberOfSolarModules = props.numberOfSolarModules;
    this.mainOrientationOfSolarModules = props.mainOrientationOfSolarModules;
    this.mainOrientationOfSolarModulesDescription = props.mainOrientationOfSolarModulesDescription;
    this.mainTiltAngleOfSolarModules = props.mainTiltAngleOfSolarModules;
  }
};
_PVPlant.type = new EntityType({
  public: true,
  type: _PVPlant,
  name: "PVPlant",
  label: {
    en: "PV-plant",
    de: "PV-Anlage"
  }
});
_PVPlant.fields = [
  ...EnergyFacility.fields,
  new Field({
    name: "numberOfSolarModules",
    type: Number,
    key: false
  }),
  new Field({
    name: "mainOrientationOfSolarModules",
    type: String,
    key: false
  }),
  new Field({
    name: "mainOrientationOfSolarModulesDescription",
    type: String,
    key: false
  }),
  new Field({
    name: "mainTiltAngleOfSolarModules",
    type: String,
    key: false
  })
];
_PVPlant.relationships = [];
var PVPlant = _PVPlant;
var _CHP = class _CHP extends EnergyFacility {
  constructor(props) {
    super(props);
    this.chpUnitElectricalCapacity = props.chpUnitElectricalCapacity;
    this.chpUnitCommissioningDate = props.chpUnitCommissioningDate ? new Date(props.chpUnitCommissioningDate) : void 0;
    this.chpUnitMaStRNumber = props.chpUnitMaStRNumber;
    this.chpUnitRegistrationDate = props.chpUnitRegistrationDate ? new Date(props.chpUnitRegistrationDate) : void 0;
    this.chpSubsidy = props.chpSubsidy;
    this.mainFuelID = props.mainFuelID;
    this.mainFuelName = props.mainFuelName;
    this.thermalUsableCapacity = props.thermalUsableCapacity;
  }
};
_CHP.type = new EntityType({
  public: true,
  type: _CHP,
  name: "CHP",
  label: {
    en: "CHP",
    de: "BHKW"
  }
});
_CHP.fields = [
  ...EnergyFacility.fields,
  new Field({
    name: "chpUnitElectricalCapacity",
    type: Number,
    key: false
  }),
  new Field({
    name: "chpUnitCommissioningDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "chpUnitMaStRNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "chpUnitRegistrationDate",
    type: Date,
    key: false
  }),
  new Field({
    name: "chpSubsidy",
    type: String,
    key: false
  }),
  new Field({
    name: "mainFuelID",
    type: Number,
    key: false
  }),
  new Field({
    name: "mainFuelName",
    type: String,
    key: false
  }),
  new Field({
    name: "thermalUsableCapacity",
    type: Number,
    key: false
  })
];
_CHP.relationships = [];
var CHP = _CHP;
var _Battery = class _Battery extends EnergyFacility {
  constructor(props) {
    super(props);
    this.batteryTechnology = props.batteryTechnology;
    this.storageUnitMaStrNumber = props.storageUnitMaStrNumber;
    this.usableStorageCapacity = props.usableStorageCapacity;
  }
};
_Battery.type = new EntityType({
  public: true,
  type: _Battery,
  name: "Battery",
  label: {
    en: "Battery",
    de: "Batterie"
  }
});
_Battery.fields = [
  ...EnergyFacility.fields,
  new Field({
    name: "batteryTechnology",
    type: String,
    key: false
  }),
  new Field({
    name: "storageUnitMaStrNumber",
    type: String,
    key: false
  }),
  new Field({
    name: "usableStorageCapacity",
    type: Number,
    key: false
  })
];
_Battery.relationships = [];
var Battery = _Battery;
var _BioMassPlant = class _BioMassPlant extends EnergyFacility {
  constructor(props) {
    super(props);
    this.bioMassType = props.bioMassType;
    this.bioMassTypeDescription = props.bioMassTypeDescription;
  }
};
_BioMassPlant.type = new EntityType({
  public: true,
  type: _BioMassPlant,
  name: "BioMassPlant",
  label: {
    en: "Biomass Plant",
    de: "Biomasseanlage"
  }
});
_BioMassPlant.fields = [
  ...EnergyFacility.fields,
  new Field({
    name: "bioMassType",
    type: String,
    key: false
  }),
  new Field({
    name: "bioMassTypeDescription",
    type: String,
    key: false
  })
];
_BioMassPlant.relationships = [];
var BioMassPlant = _BioMassPlant;
var _WindTurbine = class _WindTurbine extends EnergyFacility {
  constructor(props) {
    super(props);
    this.rotorDiameterOfWindTurbine = props.rotorDiameterOfWindTurbine;
    this.windTurbineManufacturer = props.windTurbineManufacturer;
    this.windTurbineManufacturerDescription = props.windTurbineManufacturerDescription;
    this.pilotWindTurbine = props.pilotWindTurbine;
    this.hubHeightOfWindTurbine = props.hubHeightOfWindTurbine;
    this.windClusterBalticSeaID = props.windClusterBalticSeaID;
    this.windClusterNorthSeaID = props.windClusterNorthSeaID;
    this.windFarmName = props.windFarmName;
  }
};
_WindTurbine.type = new EntityType({
  public: true,
  type: _WindTurbine,
  name: "WindTurbine",
  label: {
    en: "Wind Turbine",
    de: "Windturbine"
  }
});
_WindTurbine.fields = [
  ...EnergyFacility.fields,
  new Field({
    name: "rotorDiameterOfWindTurbine",
    type: Number,
    key: false
  }),
  new Field({
    name: "windTurbineManufacturer",
    type: String,
    key: false
  }),
  new Field({
    name: "windTurbineManufacturerDescription",
    type: String,
    key: false
  }),
  new Field({
    name: "pilotWindTurbine",
    type: String,
    key: false
  }),
  new Field({
    name: "hubHeightOfWindTurbine",
    type: Number,
    key: false
  }),
  new Field({
    name: "windClusterBalticSeaID",
    type: String,
    key: false
  }),
  new Field({
    name: "windClusterNorthSeaID",
    type: String,
    key: false
  }),
  new Field({
    name: "windFarmName",
    type: String,
    key: false
  })
];
_WindTurbine.relationships = [];
var WindTurbine = _WindTurbine;
var _HydroelectricPowerPlant = class _HydroelectricPowerPlant extends EnergyFacility {
  constructor(props) {
    super(props);
  }
};
_HydroelectricPowerPlant.type = new EntityType({
  public: true,
  type: _HydroelectricPowerPlant,
  name: "HydroelectricPowerPlant",
  label: {
    en: "Hydroelectric Power Plant",
    de: "Wasserkraftwerk"
  }
});
_HydroelectricPowerPlant.fields = [...EnergyFacility.fields];
_HydroelectricPowerPlant.relationships = [];
var HydroelectricPowerPlant = _HydroelectricPowerPlant;
var _GasAndSteamPowerPlant = class _GasAndSteamPowerPlant extends EnergyFacility {
  constructor(props) {
    super(props);
  }
};
_GasAndSteamPowerPlant.type = new EntityType({
  public: true,
  type: _GasAndSteamPowerPlant,
  name: "GasAndSteamPowerPlant",
  label: {
    en: "Gas and Steam Power Plant",
    de: "Gas- und Dampfdruckkraftwerk"
  }
});
_GasAndSteamPowerPlant.fields = [...EnergyFacility.fields];
_GasAndSteamPowerPlant.relationships = [];
var GasAndSteamPowerPlant = _GasAndSteamPowerPlant;

// src/model/sociodemographics.ts
var _CrimeStatistics = class _CrimeStatistics extends Entity {
  constructor(props) {
    super(props);
    this.year = props.year;
    this.offense = props.offense;
    this.municipalityCode = props.municipalityCode;
    this.district = props.district;
    this.districtType = props.districtType;
    this.totalRecordedCases = props.totalRecordedCases;
    this.mainIndicator = props.mainIndicator;
    this.attemptedCasesNumber = props.attemptedCasesNumber;
    this.attemptedCasesPercent = props.attemptedCasesPercent;
    this.threatWithFirearm = props.threatWithFirearm;
    this.shotWithFirearm = props.shotWithFirearm;
    this.solvedCases = props.solvedCases;
    this.clearanceRate = props.clearanceRate;
    this.totalSuspects = props.totalSuspects;
    this.maleSuspects = props.maleSuspects;
    this.femaleSuspects = props.femaleSuspects;
    this.nonGermanSuspectsCount = props.nonGermanSuspectsCount;
    this.nonGermanSuspectsPercent = props.nonGermanSuspectsPercent;
  }
};
_CrimeStatistics.type = new EntityType({
  type: _CrimeStatistics,
  name: "CrimeStatistics",
  label: {
    en: "Crime Statistics",
    de: "Kriminalit\xE4tsstatistik"
  }
});
_CrimeStatistics.fields = [new Field({
  name: "year",
  type: Number,
  key: false,
  label: {
    en: "Year",
    de: "Jahr"
  }
}), new Field({
  name: "offense",
  type: String,
  key: false,
  label: {
    en: "Offense",
    de: "Straftat"
  }
}), new Field({
  name: "municipalityCode",
  type: String,
  key: false,
  label: {
    en: "Municipality Code",
    de: "Gemeindeschl\xFCssel"
  }
}), new Field({
  name: "district",
  type: String,
  key: false,
  label: {
    en: "District",
    de: "Bezirk"
  }
}), new Field({
  name: "districtType",
  type: String,
  key: false,
  label: {
    en: "District Type",
    de: "Bezirkstyp"
  }
}), new Field({
  name: "totalRecordedCases",
  type: Number,
  key: false,
  label: {
    en: "Total Recorded Cases",
    de: "Gesamtzahl der registrierten F\xE4lle"
  }
}), new Field({
  name: "mainIndicator",
  type: String,
  key: false,
  label: {
    en: "Main Indicator",
    de: "Hauptindikator"
  }
}), new Field({
  name: "attemptedCasesNumber",
  type: Number,
  key: false,
  label: {
    en: "Attempted Cases Number",
    de: "Anzahl der versuchten F\xE4lle"
  }
}), new Field({
  name: "attemptedCasesPercent",
  type: Number,
  key: false,
  label: {
    en: "Attempted Cases Percent",
    de: "Prozent der versuchten F\xE4lle"
  }
}), new Field({
  name: "threatWithFirearm",
  type: Number,
  key: false,
  label: {
    en: "Threat with Firearm",
    de: "Bedrohung mit Schusswaffe"
  }
}), new Field({
  name: "shotWithFirearm",
  type: Number,
  key: false,
  label: {
    en: "Shot with Firearm",
    de: "Schuss mit Schusswaffe"
  }
}), new Field({
  name: "solvedCases",
  type: Number,
  key: false,
  label: {
    en: "Solved Cases",
    de: "Gel\xF6ste F\xE4lle"
  }
}), new Field({
  name: "clearanceRate",
  type: Number,
  key: false,
  label: {
    en: "Clearance Rate",
    de: "Aufkl\xE4rungsquote"
  }
}), new Field({
  name: "totalSuspects",
  type: Number,
  key: false,
  label: {
    en: "Total Suspects",
    de: "Gesamtzahl der Verd\xE4chtigen"
  }
}), new Field({
  name: "maleSuspects",
  type: Number,
  key: false,
  label: {
    en: "Male Suspects",
    de: "M\xE4nnliche Verd\xE4chtige"
  }
}), new Field({
  name: "femaleSuspects",
  type: Number,
  key: false,
  label: {
    en: "Female Suspects",
    de: "Weibliche Verd\xE4chtige"
  }
}), new Field({
  name: "nonGermanSuspectsCount",
  type: Number,
  key: false,
  label: {
    en: "Non-German Suspects Count",
    de: "Anzahl nicht-deutscher Verd\xE4chtiger"
  }
}), new Field({
  name: "nonGermanSuspectsPercent",
  type: Number,
  key: false,
  label: {
    en: "Non-German Suspects Percent",
    de: "Prozent nicht-deutscher Verd\xE4chtiger"
  }
})];
_CrimeStatistics.relationships = [];
var CrimeStatistics = _CrimeStatistics;
var StudyType = /* @__PURE__ */ ((StudyType2) => {
  StudyType2["humanities"] = "humanities";
  StudyType2["sports"] = "sports";
  StudyType2["lawEconomicsSocialSciences"] = "lawEconomicsSocialSciences";
  StudyType2["mathematicsNaturalSciences"] = "mathematicsNaturalSciences";
  StudyType2["medicineMedicalSciences"] = "medicineMedicalSciences";
  StudyType2["agricultureForestryNutritionVeterinary"] = "agricultureForestryNutritionVeterinary";
  StudyType2["engineering"] = "engineering";
  StudyType2["artFineArts"] = "artFineArts";
  StudyType2["outsideStudyClassification"] = "outsideStudyClassification";
  return StudyType2;
})(StudyType || {});
var StudyTypeI18N = {
  en: {
    humanities: "Humanities",
    sports: "Sports",
    lawEconomicsSocialSciences: "Law, Economics, Social Sciences",
    mathematicsNaturalSciences: "Mathematics and Natural Sciences",
    medicineMedicalSciences: "Medicine and Medical Sciences",
    agricultureForestryNutritionVeterinary: "Agriculture, Forestry, Nutrition, Veterinary",
    engineering: "Engineering",
    artFineArts: "Art and Fine Arts",
    outsideStudyClassification: "Outside Study Classification"
  },
  de: {
    humanities: "Geisteswissenschaften",
    sports: "Sport",
    lawEconomicsSocialSciences: "Rechts-, Wirtschafts- und Sozialwissenschaften",
    mathematicsNaturalSciences: "Mathematik und Naturwissenschaften",
    medicineMedicalSciences: "Medizin",
    agricultureForestryNutritionVeterinary: "Agrar-, Forst-, Ern\xE4hrungs- und Veterin\xE4rwissenschaften",
    engineering: "Ingenieurwissenschaften",
    artFineArts: "Kunst",
    outsideStudyClassification: "Au\xDFerhalb der Studienfachklassifikation"
  }
};
var _SubjectOfStudy = class _SubjectOfStudy extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.district = props.district;
    this.humanities = props.humanities;
    this.sports = props.sports;
    this.lawEconomicsSocialSciences = props.lawEconomicsSocialSciences;
    this.mathematicsNaturalSciences = props.mathematicsNaturalSciences;
    this.medicineMedicalSciences = props.medicineMedicalSciences;
    this.agricultureForestryNutritionVeterinary = props.agricultureForestryNutritionVeterinary;
    this.engineering = props.engineering;
    this.artFineArts = props.artFineArts;
    this.outsideStudyClassification = props.outsideStudyClassification;
    this.total = props.total;
    this.lat = props.lat;
    this.lon = props.lon;
    this.basis = props.basis;
  }
};
_SubjectOfStudy.type = new EntityType({
  type: _SubjectOfStudy,
  name: "SubjectOfStudy",
  label: {
    en: "Subject of Study",
    de: "Fachbereich"
  }
});
_SubjectOfStudy.fields = [new Field({
  name: "municipalityKey",
  type: String,
  key: false,
  label: {
    en: "Municipality Key",
    de: "Gemeindeschl\xFCssel"
  }
}), new Field({
  name: "district",
  type: String,
  key: false,
  label: {
    en: "District",
    de: "Bezirk"
  }
}), new Field({
  name: "humanities",
  type: Number,
  key: false,
  label: {
    en: "Humanities",
    de: "Geisteswissenschaften"
  }
}), new Field({
  name: "sports",
  type: Number,
  key: false,
  label: {
    en: "Sports",
    de: "Sport"
  }
}), new Field({
  name: "lawEconomicsSocialSciences",
  type: Number,
  key: false,
  label: {
    en: "Law, Economics, Social Sciences",
    de: "Rechts-, Wirtschafts- und Sozialwissenschaften"
  }
}), new Field({
  name: "mathematicsNaturalSciences",
  type: Number,
  key: false,
  label: {
    en: "Mathematics and Natural Sciences",
    de: "Mathematik und Naturwissenschaften"
  }
}), new Field({
  name: "medicineMedicalSciences",
  type: Number,
  key: false,
  label: {
    en: "Medicine and Medical Sciences",
    de: "Medizin und Gesundheitswissenschaften"
  }
}), new Field({
  name: "agricultureForestryNutritionVeterinary",
  type: Number,
  key: false,
  label: {
    en: "Agriculture, Forestry, Nutrition, Veterinary",
    de: "Agrar-, Forst-, Ern\xE4hrungs- und Veterin\xE4rwissenschaften"
  }
}), new Field({
  name: "engineering",
  type: Number,
  key: false,
  label: {
    en: "Engineering",
    de: "Ingenieurwissenschaften"
  }
}), new Field({
  name: "artFineArts",
  type: Number,
  key: false,
  label: {
    en: "Art and Fine Arts",
    de: "Kunst und Kunstwissenschaften"
  }
}), new Field({
  name: "outsideStudyClassification",
  type: Number,
  key: false,
  label: {
    en: "Outside Study Classification",
    de: "Au\xDFerhalb der Studienfachklassifikation"
  }
}), new Field({
  name: "total",
  type: Number,
  key: false,
  label: {
    en: "Total",
    de: "Gesamt"
  }
}), new Field({
  name: "lat",
  type: Number,
  key: false,
  label: {
    en: "Latitude",
    de: "Breitengrad"
  }
}), new Field({
  name: "lon",
  type: Number,
  key: false,
  label: {
    en: "Longitude",
    de: "L\xE4ngengrad"
  }
}), new Field({
  name: "basis",
  type: String,
  key: false,
  label: {
    en: "Basis",
    de: "Basis"
  }
})];
_SubjectOfStudy.relationships = [];
var SubjectOfStudy = _SubjectOfStudy;
var _StudentsNationalityGender = class _StudentsNationalityGender extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.district = props.district;
    this.total = props.total;
    this.foreignersTotal = props.foreignersTotal;
    this.germansTotal = props.germansTotal;
    this.maleTotal = props.maleTotal;
    this.foreignersMale = props.foreignersMale;
    this.germansMale = props.germansMale;
    this.femaleTotal = props.femaleTotal;
    this.foreignersFemale = props.foreignersFemale;
    this.germansFemale = props.germansFemale;
    this.lat = props.lat;
    this.lon = props.lon;
    this.basis = props.basis;
  }
};
_StudentsNationalityGender.type = new EntityType({
  type: _StudentsNationalityGender,
  name: "StudentsNationalityGender",
  label: {
    en: "Students by Nationality and Gender",
    de: "Studenten nach Nationalit\xE4t und Geschlecht"
  }
});
_StudentsNationalityGender.fields = [new Field({
  name: "municipalityKey",
  type: String,
  key: false,
  label: {
    en: "Municipality Key",
    de: "Gemeindeschl\xFCssel"
  }
}), new Field({
  name: "district",
  type: String,
  key: false,
  label: {
    en: "District",
    de: "Bezirk"
  }
}), new Field({
  name: "total",
  type: Number,
  key: false,
  label: {
    en: "Total",
    de: "Gesamt"
  }
}), new Field({
  name: "foreignersTotal",
  type: Number,
  key: false,
  label: {
    en: "Foreigners Total",
    de: "Ausl\xE4nder Gesamt"
  }
}), new Field({
  name: "germansTotal",
  type: Number,
  key: false,
  label: {
    en: "Germans Total",
    de: "Deutsche Gesamt"
  }
}), new Field({
  name: "maleTotal",
  type: Number,
  key: false,
  label: {
    en: "Male Total",
    de: "M\xE4nnlich Gesamt"
  }
}), new Field({
  name: "foreignersMale",
  type: Number,
  key: false,
  label: {
    en: "Foreigners Male",
    de: "Ausl\xE4nder M\xE4nnlich"
  }
}), new Field({
  name: "germansMale",
  type: Number,
  key: false,
  label: {
    en: "Germans Male",
    de: "Deutsche M\xE4nnlich"
  }
}), new Field({
  name: "femaleTotal",
  type: Number,
  key: false,
  label: {
    en: "Female Total",
    de: "Weiblich Gesamt"
  }
}), new Field({
  name: "foreignersFemale",
  type: Number,
  key: false,
  label: {
    en: "Foreigners Female",
    de: "Ausl\xE4nder Weiblich"
  }
}), new Field({
  name: "germansFemale",
  type: Number,
  key: false,
  label: {
    en: "Germans Female",
    de: "Deutsche Weiblich"
  }
}), new Field({
  name: "lat",
  type: Number,
  key: false,
  label: {
    en: "Latitude",
    de: "Breitengrad"
  }
}), new Field({
  name: "lon",
  type: Number,
  key: false,
  label: {
    en: "Longitude",
    de: "L\xE4ngengrad"
  }
}), new Field({
  name: "basis",
  type: String,
  key: false,
  label: {
    en: "Basis",
    de: "Basis"
  }
})];
_StudentsNationalityGender.relationships = [];
var StudentsNationalityGender = _StudentsNationalityGender;
var _EmploymentData = class _EmploymentData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.unemploymentRate = props.unemploymentRate;
    this.unemploymentRateWomen = props.unemploymentRateWomen;
    this.unemploymentRateMen = props.unemploymentRateMen;
    this.unemployedWomen = props.unemployedWomen;
    this.unemployedMen = props.unemployedMen;
    this.unemploymentStructure = props.unemploymentStructure;
    this.longTermUnemployed = props.longTermUnemployed;
    this.longTermUnemployedWomen = props.longTermUnemployedWomen;
    this.longTermUnemployedMen = props.longTermUnemployedMen;
    this.unemployedForeigners = props.unemployedForeigners;
    this.unemployedForeignWomen = props.unemployedForeignWomen;
    this.unemployedForeignMen = props.unemployedForeignMen;
    this.unemployedWithoutEducation = props.unemployedWithoutEducation;
    this.unemployedExpertLevel = props.unemployedExpertLevel;
    this.unemployedSpecialistLevel = props.unemployedSpecialistLevel;
    this.unemployedSkilledLevel = props.unemployedSkilledLevel;
    this.unemployedHelperLevel = props.unemployedHelperLevel;
    this.openPositionsExpertLevel = props.openPositionsExpertLevel;
    this.openPositionsSpecialistLevel = props.openPositionsSpecialistLevel;
    this.openPositionsSkilledLevel = props.openPositionsSkilledLevel;
    this.openPositionsHelperLevel = props.openPositionsHelperLevel;
    this.unemploymentRateOlder = props.unemploymentRateOlder;
    this.unemploymentRateYounger = props.unemploymentRateYounger;
    this.shareOlderUnemployed = props.shareOlderUnemployed;
    this.shareOlderUnemployedWomen = props.shareOlderUnemployedWomen;
    this.shareOlderUnemployedMen = props.shareOlderUnemployedMen;
    this.shareYoungerUnemployed = props.shareYoungerUnemployed;
    this.shareYoungerUnemployedWomen = props.shareYoungerUnemployedWomen;
    this.shareYoungerUnemployedMen = props.shareYoungerUnemployedMen;
    this.olderUnemployed = props.olderUnemployed;
    this.olderUnemployedWomen = props.olderUnemployedWomen;
    this.olderUnemployedMen = props.olderUnemployedMen;
    this.youngerUnemployed = props.youngerUnemployed;
    this.youngerUnemployedWomen = props.youngerUnemployedWomen;
    this.youngerUnemployedMen = props.youngerUnemployedMen;
  }
};
_EmploymentData.type = new EntityType({
  type: _EmploymentData,
  name: "EmploymentData",
  label: {
    en: "Employment Data",
    de: "Erwerbst\xE4tigenstatistik"
  }
});
_EmploymentData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "unemploymentRate",
    type: Number,
    key: false,
    label: {
      en: "Unemployment Rate",
      de: "Arbeitslosenquote"
    }
  }),
  new Field({
    name: "unemploymentRateWomen",
    type: Number,
    key: false,
    label: {
      en: "Unemployment Rate Women",
      de: "Arbeitslosenquote Frauen"
    }
  }),
  new Field({
    name: "unemploymentRateMen",
    type: Number,
    key: false,
    label: {
      en: "Unemployment Rate Men",
      de: "Arbeitslosenquote M\xE4nner"
    }
  }),
  new Field({
    name: "unemployedWomen",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Women",
      de: "Arbeitslose Frauen"
    }
  }),
  new Field({
    name: "unemployedMen",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Men",
      de: "Arbeitslose M\xE4nner"
    }
  }),
  new Field({
    name: "unemploymentStructure",
    type: String,
    key: false,
    label: {
      en: "Unemployment Structure",
      de: "Arbeitslosenstruktur"
    }
  }),
  new Field({
    name: "longTermUnemployed",
    type: Number,
    key: false,
    label: {
      en: "Long-term Unemployed",
      de: "Langzeitarbeitslose"
    }
  }),
  new Field({
    name: "longTermUnemployedWomen",
    type: Number,
    key: false,
    label: {
      en: "Long-term Unemployed Women",
      de: "Langzeitarbeitslose Frauen"
    }
  }),
  new Field({
    name: "longTermUnemployedMen",
    type: Number,
    key: false,
    label: {
      en: "Long-term Unemployed Men",
      de: "Langzeitarbeitslose M\xE4nner"
    }
  }),
  new Field({
    name: "unemployedForeigners",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Foreigners",
      de: "Arbeitslose Ausl\xE4nder"
    }
  }),
  new Field({
    name: "unemployedForeignWomen",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Foreign Women",
      de: "Arbeitslose Ausl\xE4nderinnen"
    }
  }),
  new Field({
    name: "unemployedForeignMen",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Foreign Men",
      de: "Arbeitslose Ausl\xE4nder"
    }
  }),
  new Field({
    name: "unemployedWithoutEducation",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Without Education",
      de: "Arbeitslose ohne Ausbildung"
    }
  }),
  new Field({
    name: "unemployedExpertLevel",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Expert Level",
      de: "Arbeitslose Expertenniveau"
    }
  }),
  new Field({
    name: "unemployedSpecialistLevel",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Specialist Level",
      de: "Arbeitslose Spezialistenniveau"
    }
  }),
  new Field({
    name: "unemployedSkilledLevel",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Skilled Level",
      de: "Arbeitslose Fachkr\xE4fteniveau"
    }
  }),
  new Field({
    name: "unemployedHelperLevel",
    type: Number,
    key: false,
    label: {
      en: "Unemployed Helper Level",
      de: "Arbeitslose Helferniveau"
    }
  }),
  new Field({
    name: "openPositionsExpertLevel",
    type: Number,
    key: false,
    label: {
      en: "Open Positions Expert Level",
      de: "Offene Stellen Expertenniveau"
    }
  }),
  new Field({
    name: "openPositionsSpecialistLevel",
    type: Number,
    key: false,
    label: {
      en: "Open Positions Specialist Level",
      de: "Offene Stellen Spezialistenniveau"
    }
  }),
  new Field({
    name: "openPositionsSkilledLevel",
    type: Number,
    key: false,
    label: {
      en: "Open Positions Skilled Level",
      de: "Offene Stellen Fachkr\xE4fteniveau"
    }
  }),
  new Field({
    name: "openPositionsHelperLevel",
    type: Number,
    key: false,
    label: {
      en: "Open Positions Helper Level",
      de: "Offene Stellen Helferniveau"
    }
  }),
  new Field({
    name: "unemploymentRateOlder",
    type: Number,
    key: false,
    label: {
      en: "Unemployment Rate Older",
      de: "Arbeitslosenquote \xC4ltere"
    }
  }),
  new Field({
    name: "unemploymentRateYounger",
    type: Number,
    key: false,
    label: {
      en: "Unemployment Rate Younger",
      de: "Arbeitslosenquote J\xFCngere"
    }
  }),
  new Field({
    name: "shareOlderUnemployed",
    type: Number,
    key: false,
    label: {
      en: "Share Older Unemployed",
      de: "Anteil \xE4ltere Arbeitslose"
    }
  }),
  new Field({
    name: "shareOlderUnemployedWomen",
    type: Number,
    key: false,
    label: {
      en: "Share Older Unemployed Women",
      de: "Anteil \xE4ltere arbeitslose Frauen"
    }
  }),
  new Field({
    name: "shareOlderUnemployedMen",
    type: Number,
    key: false,
    label: {
      en: "Share Older Unemployed Men",
      de: "Anteil \xE4ltere arbeitslose M\xE4nner"
    }
  }),
  new Field({
    name: "shareYoungerUnemployed",
    type: Number,
    key: false,
    label: {
      en: "Share Younger Unemployed",
      de: "Anteil j\xFCngere Arbeitslose"
    }
  }),
  new Field({
    name: "shareYoungerUnemployedWomen",
    type: Number,
    key: false,
    label: {
      en: "Share Younger Unemployed Women",
      de: "Anteil j\xFCngere arbeitslose Frauen"
    }
  }),
  new Field({
    name: "shareYoungerUnemployedMen",
    type: Number,
    key: false,
    label: {
      en: "Share Younger Unemployed Men",
      de: "Anteil j\xFCngere arbeitslose M\xE4nner"
    }
  }),
  new Field({
    name: "olderUnemployed",
    type: Number,
    key: false,
    label: {
      en: "Older Unemployed",
      de: "\xC4ltere Arbeitslose"
    }
  }),
  new Field({
    name: "olderUnemployedWomen",
    type: Number,
    key: false,
    label: {
      en: "Older Unemployed Women",
      de: "\xC4ltere arbeitslose Frauen"
    }
  }),
  new Field({
    name: "olderUnemployedMen",
    type: Number,
    key: false,
    label: {
      en: "Older Unemployed Men",
      de: "\xC4ltere arbeitslose M\xE4nner"
    }
  }),
  new Field({
    name: "youngerUnemployed",
    type: Number,
    key: false,
    label: {
      en: "Younger Unemployed",
      de: "J\xFCngere Arbeitslose"
    }
  }),
  new Field({
    name: "youngerUnemployedWomen",
    type: Number,
    key: false,
    label: {
      en: "Younger Unemployed Women",
      de: "J\xFCngere arbeitslose Frauen"
    }
  }),
  new Field({
    name: "youngerUnemployedMen",
    type: Number,
    key: false,
    label: {
      en: "Younger Unemployed Men",
      de: "J\xFCngere arbeitslose M\xE4nner"
    }
  })
];
_EmploymentData.relationships = [];
var EmploymentData = _EmploymentData;
var _BuildingAndHousingData = class _BuildingAndHousingData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.landPrice = props.landPrice;
    this.offerRentPrice = props.offerRentPrice;
    this.constructionBacklog = props.constructionBacklog;
    this.buildingPermitsForDwellings = props.buildingPermitsForDwellings;
    this.buildingPermitsOneTwoFamilyHouses = props.buildingPermitsOneTwoFamilyHouses;
    this.buildingPermitsMultiFamilyHouses = props.buildingPermitsMultiFamilyHouses;
    this.completedDwellingsPerExistingDwelling = props.completedDwellingsPerExistingDwelling;
    this.newOneTwoFamilyHouses = props.newOneTwoFamilyHouses;
    this.newDwellingsOneTwoFamilyHouses = props.newDwellingsOneTwoFamilyHouses;
    this.newDwellingsPerCapita = props.newDwellingsPerCapita;
    this.newDwellingsOneTwoFamilyHousesPerCapita = props.newDwellingsOneTwoFamilyHousesPerCapita;
    this.newDwellingsMultiFamilyHouses = props.newDwellingsMultiFamilyHouses;
    this.completedResidentialBuildingsWithRenewableHeating = props.completedResidentialBuildingsWithRenewableHeating;
    this.completedDwellingsWithRenewableHeating = props.completedDwellingsWithRenewableHeating;
    this.oneTwoFamilyHouses = props.oneTwoFamilyHouses;
    this.multiFamilyHouses = props.multiFamilyHouses;
    this.oneTwoRoomDwellings = props.oneTwoRoomDwellings;
    this.fivePlusRoomDwellings = props.fivePlusRoomDwellings;
    this.livingSpace = props.livingSpace;
    this.dwellingsInOneTwoFamilyHouses = props.dwellingsInOneTwoFamilyHouses;
    this.dwellingsInMultiFamilyHouses = props.dwellingsInMultiFamilyHouses;
  }
};
_BuildingAndHousingData.type = new EntityType({
  type: _BuildingAndHousingData,
  name: "BuildingAndHousingData",
  label: {
    en: "Building and Housing Data",
    de: "Geb\xE4ude- und Wohnungsdaten"
  }
});
_BuildingAndHousingData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "landPrice",
    type: Number,
    key: false,
    label: {
      en: "Land Price",
      de: "Bodenpreis"
    }
  }),
  new Field({
    name: "offerRentPrice",
    type: Number,
    key: false,
    label: {
      en: "Offer Rent Price",
      de: "Angebotsmiete"
    }
  }),
  new Field({
    name: "constructionBacklog",
    type: Number,
    key: false,
    label: {
      en: "Construction Backlog",
      de: "Bau\xFCberhang"
    }
  }),
  new Field({
    name: "buildingPermitsForDwellings",
    type: Number,
    key: false,
    label: {
      en: "Building Permits for Dwellings",
      de: "Baugenehmigungen f\xFCr Wohnungen"
    }
  }),
  new Field({
    name: "buildingPermitsOneTwoFamilyHouses",
    type: Number,
    key: false,
    label: {
      en: "Building Permits One-Two Family Houses",
      de: "Baugenehmigungen Ein- und Zweifamilienh\xE4user"
    }
  }),
  new Field({
    name: "buildingPermitsMultiFamilyHouses",
    type: Number,
    key: false,
    label: {
      en: "Building Permits Multi-Family Houses",
      de: "Baugenehmigungen Mehrfamilienh\xE4user"
    }
  }),
  new Field({
    name: "completedDwellingsPerExistingDwelling",
    type: Number,
    key: false,
    label: {
      en: "Completed Dwellings per Existing Dwelling",
      de: "Fertiggestellte Wohnungen je bestehende Wohnung"
    }
  }),
  new Field({
    name: "newOneTwoFamilyHouses",
    type: Number,
    key: false,
    label: {
      en: "New One-Two Family Houses",
      de: "Neue Ein- und Zweifamilienh\xE4user"
    }
  }),
  new Field({
    name: "newDwellingsOneTwoFamilyHouses",
    type: Number,
    key: false,
    label: {
      en: "New Dwellings in One-Two Family Houses",
      de: "Neue Wohnungen in Ein- und Zweifamilienh\xE4usern"
    }
  }),
  new Field({
    name: "newDwellingsPerCapita",
    type: Number,
    key: false,
    label: {
      en: "New Dwellings per Capita",
      de: "Neue Wohnungen je Einwohner"
    }
  }),
  new Field({
    name: "newDwellingsOneTwoFamilyHousesPerCapita",
    type: Number,
    key: false,
    label: {
      en: "New Dwellings in One-Two Family Houses per Capita",
      de: "Neue Wohnungen in Ein- und Zweifamilienh\xE4usern je Einwohner"
    }
  }),
  new Field({
    name: "newDwellingsMultiFamilyHouses",
    type: Number,
    key: false,
    label: {
      en: "New Dwellings in Multi-Family Houses",
      de: "Neue Wohnungen in Mehrfamilienh\xE4usern"
    }
  }),
  new Field({
    name: "completedResidentialBuildingsWithRenewableHeating",
    type: Number,
    key: false,
    label: {
      en: "Completed Residential Buildings with Renewable Heating",
      de: "Fertiggestellte Wohngeb\xE4ude mit erneuerbarer Heizung"
    }
  }),
  new Field({
    name: "completedDwellingsWithRenewableHeating",
    type: Number,
    key: false,
    label: {
      en: "Completed Dwellings with Renewable Heating",
      de: "Fertiggestellte Wohnungen mit erneuerbarer Heizung"
    }
  }),
  new Field({
    name: "oneTwoFamilyHouses",
    type: Number,
    key: false,
    label: {
      en: "One-Two Family Houses",
      de: "Ein- und Zweifamilienh\xE4user"
    }
  }),
  new Field({
    name: "multiFamilyHouses",
    type: Number,
    key: false,
    label: {
      en: "Multi-Family Houses",
      de: "Mehrfamilienh\xE4user"
    }
  }),
  new Field({
    name: "oneTwoRoomDwellings",
    type: Number,
    key: false,
    label: {
      en: "One-Two Room Dwellings",
      de: "Ein- und Zweizimmerwohnungen"
    }
  }),
  new Field({
    name: "fivePlusRoomDwellings",
    type: Number,
    key: false,
    label: {
      en: "Five Plus Room Dwellings",
      de: "F\xFCnf und mehr Zimmerwohnungen"
    }
  }),
  new Field({
    name: "livingSpace",
    type: Number,
    key: false,
    label: {
      en: "Living Space",
      de: "Wohnfl\xE4che"
    }
  }),
  new Field({
    name: "dwellingsInOneTwoFamilyHouses",
    type: Number,
    key: false,
    label: {
      en: "Dwellings in One-Two Family Houses",
      de: "Wohnungen in Ein- und Zweifamilienh\xE4usern"
    }
  }),
  new Field({
    name: "dwellingsInMultiFamilyHouses",
    type: Number,
    key: false,
    label: {
      en: "Dwellings in Multi-Family Houses",
      de: "Wohnungen in Mehrfamilienh\xE4usern"
    }
  })
];
_BuildingAndHousingData.relationships = [];
var BuildingAndHousingData = _BuildingAndHousingData;
var _LandUseData = class _LandUseData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.settlementAndTransportArea = props.settlementAndTransportArea;
    this.settlementDensityPerSqKm = props.settlementDensityPerSqKm;
    this.recreationalArea = props.recreationalArea;
    this.recreationalAreaPerCapita = props.recreationalAreaPerCapita;
    this.openSpace = props.openSpace;
    this.openSpacePerCapita = props.openSpacePerCapita;
    this.agriculturalArea = props.agriculturalArea;
    this.nearNaturalArea = props.nearNaturalArea;
    this.nearNaturalAreaPerCapita = props.nearNaturalAreaPerCapita;
    this.forestArea = props.forestArea;
    this.waterArea = props.waterArea;
    this.newlyClaimedLandUse = props.newlyClaimedLandUse;
  }
};
_LandUseData.type = new EntityType({
  type: _LandUseData,
  name: "LandUseData",
  label: {
    en: "Land Use Data",
    de: "Fl\xE4chennutzungsdaten"
  }
});
_LandUseData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "settlementAndTransportArea",
    type: Number,
    key: false,
    label: {
      en: "Settlement and Transport Area",
      de: "Siedlungs- und Verkehrsfl\xE4che"
    }
  }),
  new Field({
    name: "settlementDensityPerSqKm",
    type: Number,
    key: false,
    label: {
      en: "Settlement Density per Square Kilometer",
      de: "Siedlungsdichte je Quadratkilometer"
    }
  }),
  new Field({
    name: "recreationalArea",
    type: Number,
    key: false,
    label: {
      en: "Recreational Area",
      de: "Erholungsfl\xE4che"
    }
  }),
  new Field({
    name: "recreationalAreaPerCapita",
    type: Number,
    key: false,
    label: {
      en: "Recreational Area per Capita",
      de: "Erholungsfl\xE4che je Einwohner"
    }
  }),
  new Field({
    name: "openSpace",
    type: Number,
    key: false,
    label: {
      en: "Open Space",
      de: "Freifl\xE4che"
    }
  }),
  new Field({
    name: "openSpacePerCapita",
    type: Number,
    key: false,
    label: {
      en: "Open Space per Capita",
      de: "Freifl\xE4che je Einwohner"
    }
  }),
  new Field({
    name: "agriculturalArea",
    type: Number,
    key: false,
    label: {
      en: "Agricultural Area",
      de: "Landwirtschaftsfl\xE4che"
    }
  }),
  new Field({
    name: "nearNaturalArea",
    type: Number,
    key: false,
    label: {
      en: "Near Natural Area",
      de: "Naturnahe Fl\xE4che"
    }
  }),
  new Field({
    name: "nearNaturalAreaPerCapita",
    type: Number,
    key: false,
    label: {
      en: "Near Natural Area per Capita",
      de: "Naturnahe Fl\xE4che je Einwohner"
    }
  }),
  new Field({
    name: "forestArea",
    type: Number,
    key: false,
    label: {
      en: "Forest Area",
      de: "Waldfl\xE4che"
    }
  }),
  new Field({
    name: "waterArea",
    type: Number,
    key: false,
    label: {
      en: "Water Area",
      de: "Wasserfl\xE4che"
    }
  }),
  new Field({
    name: "newlyClaimedLandUse",
    type: Number,
    key: false,
    label: {
      en: "Newly Claimed Land Use",
      de: "Neu beanspruchte Fl\xE4chennutzung"
    }
  })
];
_LandUseData.relationships = [];
var LandUseData = _LandUseData;
var _EnvironmentData = class _EnvironmentData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.wasteVolumePerCapita = props.wasteVolumePerCapita;
    this.householdWastePerCapita = props.householdWastePerCapita;
    this.householdAndBulkyWaste = props.householdAndBulkyWaste;
    this.organicWaste = props.organicWaste;
    this.recyclableMaterials = props.recyclableMaterials;
    this.drinkingWaterConsumption = props.drinkingWaterConsumption;
    this.nitrogenSurplus = props.nitrogenSurplus;
  }
};
_EnvironmentData.type = new EntityType({
  type: _EnvironmentData,
  name: "EnvironmentData",
  label: {
    en: "Environment Data",
    de: "Umweltdaten"
  }
});
_EnvironmentData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "wasteVolumePerCapita",
    type: Number,
    key: false,
    label: {
      en: "Waste Volume per Capita",
      de: "Abfallmenge je Einwohner"
    }
  }),
  new Field({
    name: "householdWastePerCapita",
    type: Number,
    key: false,
    label: {
      en: "Household Waste per Capita",
      de: "Hausm\xFCll je Einwohner"
    }
  }),
  new Field({
    name: "householdAndBulkyWaste",
    type: Number,
    key: false,
    label: {
      en: "Household and Bulky Waste",
      de: "Haus- und Sperrm\xFCll"
    }
  }),
  new Field({
    name: "organicWaste",
    type: Number,
    key: false,
    label: {
      en: "Organic Waste",
      de: "Bioabfall"
    }
  }),
  new Field({
    name: "recyclableMaterials",
    type: Number,
    key: false,
    label: {
      en: "Recyclable Materials",
      de: "Wertstoffe"
    }
  }),
  new Field({
    name: "drinkingWaterConsumption",
    type: Number,
    key: false,
    label: {
      en: "Drinking Water Consumption",
      de: "Trinkwasserverbrauch"
    }
  }),
  new Field({
    name: "nitrogenSurplus",
    type: Number,
    key: false,
    label: {
      en: "Nitrogen Surplus",
      de: "Stickstoff\xFCberschuss"
    }
  })
];
_EnvironmentData.relationships = [];
var EnvironmentData = _EnvironmentData;
var _TrafficData = class _TrafficData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.accessibilityMotorways = props.accessibilityMotorways;
    this.accessibilityAirports = props.accessibilityAirports;
    this.accessibilityLongDistanceTrainStations = props.accessibilityLongDistanceTrainStations;
    this.accessibilityMajorCenters = props.accessibilityMajorCenters;
    this.accessibilitySecondaryCenters = props.accessibilitySecondaryCenters;
    this.proximitySupermarketsAvgDistance = props.proximitySupermarketsAvgDistance;
    this.proximitySupermarketsShareWithin1km = props.proximitySupermarketsShareWithin1km;
    this.proximityPharmaciesAvgDistance = props.proximityPharmaciesAvgDistance;
    this.proximityPharmaciesShareWithin1km = props.proximityPharmaciesShareWithin1km;
    this.proximityPrimarySchoolsAvgDistance = props.proximityPrimarySchoolsAvgDistance;
    this.proximityPrimarySchoolsShareWithin1km = props.proximityPrimarySchoolsShareWithin1km;
    this.proximityPublicTransportAvgDistance = props.proximityPublicTransportAvgDistance;
    this.proximityPublicTransportShareWithin1km = props.proximityPublicTransportShareWithin1km;
    this.broadbandAvailabilityMin50Mbps = props.broadbandAvailabilityMin50Mbps;
    this.broadbandAvailabilityMin100Mbps = props.broadbandAvailabilityMin100Mbps;
    this.broadbandAvailabilityMin1000Mbps = props.broadbandAvailabilityMin1000Mbps;
    this.carDensity = props.carDensity;
    this.electricCars = props.electricCars;
    this.hybridCarsTotal = props.hybridCarsTotal;
    this.plugInHybridCars = props.plugInHybridCars;
    this.petrolCars = props.petrolCars;
    this.dieselCars = props.dieselCars;
    this.gasCars = props.gasCars;
    this.chargingStationsPer100kInhabitants = props.chargingStationsPer100kInhabitants;
    this.chargingStationsPer100ElectricCars = props.chargingStationsPer100ElectricCars;
    this.roadTrafficAccidents = props.roadTrafficAccidents;
    this.trafficAccidentInjuries = props.trafficAccidentInjuries;
    this.trafficAccidentFatalities = props.trafficAccidentFatalities;
    this.inboundCommuters = props.inboundCommuters;
    this.outboundCommuters = props.outboundCommuters;
    this.commuterBalance = props.commuterBalance;
    this.commutersDistance50kmOrMore = props.commutersDistance50kmOrMore;
    this.commutersDistance150kmOrMore = props.commutersDistance150kmOrMore;
    this.commutersDistance300kmOrMore = props.commutersDistance300kmOrMore;
  }
};
_TrafficData.type = new EntityType({
  type: _TrafficData,
  name: "TrafficData",
  label: {
    en: "Traffic Data",
    de: "Verkehrsdaten"
  }
});
_TrafficData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "accessibilityMotorways",
    type: Number,
    key: false,
    label: {
      en: "Accessibility Motorways",
      de: "Erreichbarkeit Autobahnen"
    }
  }),
  new Field({
    name: "accessibilityAirports",
    type: Number,
    key: false,
    label: {
      en: "Accessibility Airports",
      de: "Erreichbarkeit Flugh\xE4fen"
    }
  }),
  new Field({
    name: "accessibilityLongDistanceTrainStations",
    type: Number,
    key: false,
    label: {
      en: "Accessibility Long Distance Train Stations",
      de: "Erreichbarkeit Fernbahnh\xF6fe"
    }
  }),
  new Field({
    name: "accessibilityMajorCenters",
    type: Number,
    key: false,
    label: {
      en: "Accessibility Major Centers",
      de: "Erreichbarkeit Oberzentren"
    }
  }),
  new Field({
    name: "accessibilitySecondaryCenters",
    type: Number,
    key: false,
    label: {
      en: "Accessibility Secondary Centers",
      de: "Erreichbarkeit Mittelzentren"
    }
  }),
  new Field({
    name: "proximitySupermarketsAvgDistance",
    type: Number,
    key: false,
    label: {
      en: "Proximity Supermarkets Average Distance",
      de: "N\xE4he Superm\xE4rkte Durchschnittsentfernung"
    }
  }),
  new Field({
    name: "proximitySupermarketsShareWithin1km",
    type: Number,
    key: false,
    label: {
      en: "Proximity Supermarkets Share Within 1km",
      de: "N\xE4he Superm\xE4rkte Anteil innerhalb 1km"
    }
  }),
  new Field({
    name: "proximityPharmaciesAvgDistance",
    type: Number,
    key: false,
    label: {
      en: "Proximity Pharmacies Average Distance",
      de: "N\xE4he Apotheken Durchschnittsentfernung"
    }
  }),
  new Field({
    name: "proximityPharmaciesShareWithin1km",
    type: Number,
    key: false,
    label: {
      en: "Proximity Pharmacies Share Within 1km",
      de: "N\xE4he Apotheken Anteil innerhalb 1km"
    }
  }),
  new Field({
    name: "proximityPrimarySchoolsAvgDistance",
    type: Number,
    key: false,
    label: {
      en: "Proximity Primary Schools Average Distance",
      de: "N\xE4he Grundschulen Durchschnittsentfernung"
    }
  }),
  new Field({
    name: "proximityPrimarySchoolsShareWithin1km",
    type: Number,
    key: false,
    label: {
      en: "Proximity Primary Schools Share Within 1km",
      de: "N\xE4he Grundschulen Anteil innerhalb 1km"
    }
  }),
  new Field({
    name: "proximityPublicTransportAvgDistance",
    type: Number,
    key: false,
    label: {
      en: "Proximity Public Transport Average Distance",
      de: "N\xE4he \xD6PNV Durchschnittsentfernung"
    }
  }),
  new Field({
    name: "proximityPublicTransportShareWithin1km",
    type: Number,
    key: false,
    label: {
      en: "Proximity Public Transport Share Within 1km",
      de: "N\xE4he \xD6PNV Anteil innerhalb 1km"
    }
  }),
  new Field({
    name: "broadbandAvailabilityMin50Mbps",
    type: Number,
    key: false,
    label: {
      en: "Broadband Availability Minimum 50 Mbps",
      de: "Breitbandverf\xFCgbarkeit mindestens 50 Mbps"
    }
  }),
  new Field({
    name: "broadbandAvailabilityMin100Mbps",
    type: Number,
    key: false,
    label: {
      en: "Broadband Availability Minimum 100 Mbps",
      de: "Breitbandverf\xFCgbarkeit mindestens 100 Mbps"
    }
  }),
  new Field({
    name: "broadbandAvailabilityMin1000Mbps",
    type: Number,
    key: false,
    label: {
      en: "Broadband Availability Minimum 1000 Mbps",
      de: "Breitbandverf\xFCgbarkeit mindestens 1000 Mbps"
    }
  }),
  new Field({
    name: "carDensity",
    type: Number,
    key: false,
    label: {
      en: "Car Density",
      de: "Pkw-Dichte"
    }
  }),
  new Field({
    name: "electricCars",
    type: Number,
    key: false,
    label: {
      en: "Electric Cars",
      de: "Elektroautos"
    }
  }),
  new Field({
    name: "hybridCarsTotal",
    type: Number,
    key: false,
    label: {
      en: "Hybrid Cars Total",
      de: "Hybridfahrzeuge gesamt"
    }
  }),
  new Field({
    name: "plugInHybridCars",
    type: Number,
    key: false,
    label: {
      en: "Plug-in Hybrid Cars",
      de: "Plug-in-Hybridfahrzeuge"
    }
  }),
  new Field({
    name: "petrolCars",
    type: Number,
    key: false,
    label: {
      en: "Petrol Cars",
      de: "Benzinfahrzeuge"
    }
  }),
  new Field({
    name: "dieselCars",
    type: Number,
    key: false,
    label: {
      en: "Diesel Cars",
      de: "Dieselfahrzeuge"
    }
  }),
  new Field({
    name: "gasCars",
    type: Number,
    key: false,
    label: {
      en: "Gas Cars",
      de: "Gastankfahrzeuge"
    }
  }),
  new Field({
    name: "chargingStationsPer100kInhabitants",
    type: Number,
    key: false,
    label: {
      en: "Charging Stations per 100k Inhabitants",
      de: "Ladestationen je 100.000 Einwohner"
    }
  }),
  new Field({
    name: "chargingStationsPer100ElectricCars",
    type: Number,
    key: false,
    label: {
      en: "Charging Stations per 100 Electric Cars",
      de: "Ladestationen je 100 Elektroautos"
    }
  }),
  new Field({
    name: "roadTrafficAccidents",
    type: Number,
    key: false,
    label: {
      en: "Road Traffic Accidents",
      de: "Stra\xDFenverkehrsunf\xE4lle"
    }
  }),
  new Field({
    name: "trafficAccidentInjuries",
    type: Number,
    key: false,
    label: {
      en: "Traffic Accident Injuries",
      de: "Verletzte bei Verkehrsunf\xE4llen"
    }
  }),
  new Field({
    name: "trafficAccidentFatalities",
    type: Number,
    key: false,
    label: {
      en: "Traffic Accident Fatalities",
      de: "Tote bei Verkehrsunf\xE4llen"
    }
  }),
  new Field({
    name: "inboundCommuters",
    type: Number,
    key: false,
    label: {
      en: "Inbound Commuters",
      de: "Einpendler"
    }
  }),
  new Field({
    name: "outboundCommuters",
    type: Number,
    key: false,
    label: {
      en: "Outbound Commuters",
      de: "Auspendler"
    }
  }),
  new Field({
    name: "commuterBalance",
    type: Number,
    key: false,
    label: {
      en: "Commuter Balance",
      de: "Pendlersaldo"
    }
  }),
  new Field({
    name: "commutersDistance50kmOrMore",
    type: Number,
    key: false,
    label: {
      en: "Commuters Distance 50km or More",
      de: "Pendler mit Entfernung 50km oder mehr"
    }
  }),
  new Field({
    name: "commutersDistance150kmOrMore",
    type: Number,
    key: false,
    label: {
      en: "Commuters Distance 150km or More",
      de: "Pendler mit Entfernung 150km oder mehr"
    }
  }),
  new Field({
    name: "commutersDistance300kmOrMore",
    type: Number,
    key: false,
    label: {
      en: "Commuters Distance 300km or More",
      de: "Pendler mit Entfernung 300km oder mehr"
    }
  })
];
_TrafficData.relationships = [];
var TrafficData = _TrafficData;
var _EconomicsData = class _EconomicsData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.microEnterprises = props.microEnterprises;
    this.smallEnterprises = props.smallEnterprises;
    this.mediumEnterprises = props.mediumEnterprises;
    this.largeEnterprises = props.largeEnterprises;
    this.gdpPerCapita = props.gdpPerCapita;
    this.gdpPerEmployedPerson = props.gdpPerEmployedPerson;
    this.grossValueAddedPerEmployedPerson = props.grossValueAddedPerEmployedPerson;
    this.grossValueAddedPerEmployedPrimarySector = props.grossValueAddedPerEmployedPrimarySector;
    this.grossValueAddedPerEmployedSecondarySector = props.grossValueAddedPerEmployedSecondarySector;
    this.grossValueAddedPerEmployedTertiarySector = props.grossValueAddedPerEmployedTertiarySector;
    this.shareGrossValueAddedPrimarySector = props.shareGrossValueAddedPrimarySector;
    this.shareGrossValueAddedSecondarySector = props.shareGrossValueAddedSecondarySector;
    this.shareGrossValueAddedTertiarySector = props.shareGrossValueAddedTertiarySector;
    this.companyInsolvencies = props.companyInsolvencies;
    this.companyInsolvencyCreditorClaims = props.companyInsolvencyCreditorClaims;
    this.investmentsMiningManufacturing = props.investmentsMiningManufacturing;
    this.foreignSalesMiningManufacturing = props.foreignSalesMiningManufacturing;
    this.salesMiningManufacturing = props.salesMiningManufacturing;
    this.salesConstructionMainTrades = props.salesConstructionMainTrades;
    this.salesCrafts = props.salesCrafts;
  }
};
_EconomicsData.type = new EntityType({
  type: _EconomicsData,
  name: "EconomicsData",
  label: {
    en: "Economics Data",
    de: "Wirtschaftsdaten"
  }
});
_EconomicsData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "microEnterprises",
    type: Number,
    key: false,
    label: {
      en: "Micro Enterprises",
      de: "Mikrounternehmen"
    }
  }),
  new Field({
    name: "smallEnterprises",
    type: Number,
    key: false,
    label: {
      en: "Small Enterprises",
      de: "Kleine Unternehmen"
    }
  }),
  new Field({
    name: "mediumEnterprises",
    type: Number,
    key: false,
    label: {
      en: "Medium Enterprises",
      de: "Mittlere Unternehmen"
    }
  }),
  new Field({
    name: "largeEnterprises",
    type: Number,
    key: false,
    label: {
      en: "Large Enterprises",
      de: "Gro\xDFe Unternehmen"
    }
  }),
  new Field({
    name: "gdpPerCapita",
    type: Number,
    key: false,
    label: {
      en: "GDP per Capita",
      de: "BIP pro Kopf"
    }
  }),
  new Field({
    name: "gdpPerEmployedPerson",
    type: Number,
    key: false,
    label: {
      en: "GDP per Employed Person",
      de: "BIP je Erwerbst\xE4tigen"
    }
  }),
  new Field({
    name: "grossValueAddedPerEmployedPerson",
    type: Number,
    key: false,
    label: {
      en: "Gross Value Added per Employed Person",
      de: "Bruttowertsch\xF6pfung je Erwerbst\xE4tigen"
    }
  }),
  new Field({
    name: "grossValueAddedPerEmployedPrimarySector",
    type: Number,
    key: false,
    label: {
      en: "Gross Value Added per Employed Primary Sector",
      de: "Bruttowertsch\xF6pfung je Erwerbst\xE4tigen Prim\xE4rsektor"
    }
  }),
  new Field({
    name: "grossValueAddedPerEmployedSecondarySector",
    type: Number,
    key: false,
    label: {
      en: "Gross Value Added per Employed Secondary Sector",
      de: "Bruttowertsch\xF6pfung je Erwerbst\xE4tigen Sekund\xE4rsektor"
    }
  }),
  new Field({
    name: "grossValueAddedPerEmployedTertiarySector",
    type: Number,
    key: false,
    label: {
      en: "Gross Value Added per Employed Tertiary Sector",
      de: "Bruttowertsch\xF6pfung je Erwerbst\xE4tigen Terti\xE4rsektor"
    }
  }),
  new Field({
    name: "shareGrossValueAddedPrimarySector",
    type: Number,
    key: false,
    label: {
      en: "Share Gross Value Added Primary Sector",
      de: "Anteil Bruttowertsch\xF6pfung Prim\xE4rsektor"
    }
  }),
  new Field({
    name: "shareGrossValueAddedSecondarySector",
    type: Number,
    key: false,
    label: {
      en: "Share Gross Value Added Secondary Sector",
      de: "Anteil Bruttowertsch\xF6pfung Sekund\xE4rsektor"
    }
  }),
  new Field({
    name: "shareGrossValueAddedTertiarySector",
    type: Number,
    key: false,
    label: {
      en: "Share Gross Value Added Tertiary Sector",
      de: "Anteil Bruttowertsch\xF6pfung Terti\xE4rsektor"
    }
  }),
  new Field({
    name: "companyInsolvencies",
    type: Number,
    key: false,
    label: {
      en: "Company Insolvencies",
      de: "Unternehmensinsolvenzen"
    }
  }),
  new Field({
    name: "companyInsolvencyCreditorClaims",
    type: Number,
    key: false,
    label: {
      en: "Company Insolvency Creditor Claims",
      de: "Forderungen bei Unternehmensinsolvenzen"
    }
  }),
  new Field({
    name: "investmentsMiningManufacturing",
    type: Number,
    key: false,
    label: {
      en: "Investments Mining and Manufacturing",
      de: "Investitionen Bergbau und verarbeitendes Gewerbe"
    }
  }),
  new Field({
    name: "foreignSalesMiningManufacturing",
    type: Number,
    key: false,
    label: {
      en: "Foreign Sales Mining and Manufacturing",
      de: "Auslandsumsatz Bergbau und verarbeitendes Gewerbe"
    }
  }),
  new Field({
    name: "salesMiningManufacturing",
    type: Number,
    key: false,
    label: {
      en: "Sales Mining and Manufacturing",
      de: "Umsatz Bergbau und verarbeitendes Gewerbe"
    }
  }),
  new Field({
    name: "salesConstructionMainTrades",
    type: Number,
    key: false,
    label: {
      en: "Sales Construction Main Trades",
      de: "Umsatz Bauhauptgewerbe"
    }
  }),
  new Field({
    name: "salesCrafts",
    type: Number,
    key: false,
    label: {
      en: "Sales Crafts",
      de: "Umsatz Handwerk"
    }
  })
];
_EconomicsData.relationships = [];
var EconomicsData = _EconomicsData;
var _PopulationData = class _PopulationData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.inhabitantsUnder3 = props.inhabitantsUnder3;
    this.inhabitants3ToUnder6 = props.inhabitants3ToUnder6;
    this.inhabitantsUnder6 = props.inhabitantsUnder6;
    this.inhabitants6ToUnder18 = props.inhabitants6ToUnder18;
    this.inhabitants18ToUnder25 = props.inhabitants18ToUnder25;
    this.inhabitants25ToUnder30 = props.inhabitants25ToUnder30;
    this.inhabitants30ToUnder50 = props.inhabitants30ToUnder50;
    this.inhabitants50ToUnder65 = props.inhabitants50ToUnder65;
    this.inhabitants65ToUnder75 = props.inhabitants65ToUnder75;
    this.inhabitants75ToUnder85 = props.inhabitants75ToUnder85;
    this.inhabitants65AndOlder = props.inhabitants65AndOlder;
    this.inhabitants75AndOlder = props.inhabitants75AndOlder;
    this.inhabitants85AndOlder = props.inhabitants85AndOlder;
    this.female18ToUnder25 = props.female18ToUnder25;
    this.female25ToUnder30 = props.female25ToUnder30;
    this.female65ToUnder75 = props.female65ToUnder75;
    this.female75ToUnder85 = props.female75ToUnder85;
    this.female65AndOlder = props.female65AndOlder;
    this.female75AndOlder = props.female75AndOlder;
    this.female85AndOlder = props.female85AndOlder;
    this.averageAgePopulation = props.averageAgePopulation;
    this.marriages = props.marriages;
    this.divorces = props.divorces;
    this.foreignerShare = props.foreignerShare;
    this.femaleForeigners = props.femaleForeigners;
    this.householdSize = props.householdSize;
    this.singlePersonHouseholds = props.singlePersonHouseholds;
    this.householdsWithChildren = props.householdsWithChildren;
    this.youthDependencyRatio = props.youthDependencyRatio;
    this.elderlyDependencyRatio = props.elderlyDependencyRatio;
    this.femaleShare = props.femaleShare;
    this.femaleShare20ToUnder40 = props.femaleShare20ToUnder40;
    this.naturalizationsPerForeigner = props.naturalizationsPerForeigner;
    this.naturalizationsPerInhabitant = props.naturalizationsPerInhabitant;
    this.refugeesPerPopulation = props.refugeesPerPopulation;
    this.refugeesPerForeignPopulation = props.refugeesPerForeignPopulation;
    this.populationGrowth10Y = props.populationGrowth10Y;
    this.populationGrowth5Y = props.populationGrowth5Y;
    this.migrationBalanceTotal = props.migrationBalanceTotal;
    this.migrationBalanceExternal = props.migrationBalanceExternal;
    this.migrationBalanceExternalFemale = props.migrationBalanceExternalFemale;
    this.migrationBalanceExternalMale = props.migrationBalanceExternalMale;
    this.migrationBalanceInternal = props.migrationBalanceInternal;
    this.migrationBalanceInternalFemale = props.migrationBalanceInternalFemale;
    this.migrationBalanceInternalMale = props.migrationBalanceInternalMale;
    this.educationMigrants = props.educationMigrants;
    this.femaleEducationMigrants = props.femaleEducationMigrants;
    this.maleEducationMigrants = props.maleEducationMigrants;
    this.earlyCareerMigrants = props.earlyCareerMigrants;
    this.femaleEarlyCareerMigrants = props.femaleEarlyCareerMigrants;
    this.maleEarlyCareerMigrants = props.maleEarlyCareerMigrants;
    this.retirementMigrants = props.retirementMigrants;
    this.familyMigrants = props.familyMigrants;
    this.employmentMigrants = props.employmentMigrants;
    this.internalMigrationVolume = props.internalMigrationVolume;
    this.internalMigrationVolumeFemale = props.internalMigrationVolumeFemale;
    this.internalMigrationVolumeMale = props.internalMigrationVolumeMale;
    this.immigrationRate = props.immigrationRate;
    this.emigrationRate = props.emigrationRate;
    this.femaleImmigrationRate = props.femaleImmigrationRate;
    this.femaleEmigrationRate = props.femaleEmigrationRate;
    this.maleImmigrationRate = props.maleImmigrationRate;
    this.maleEmigrationRate = props.maleEmigrationRate;
    this.births = props.births;
    this.deaths = props.deaths;
    this.naturalPopulationBalance = props.naturalPopulationBalance;
    this.totalFertilityRate = props.totalFertilityRate;
    this.lifeExpectancyFemale = props.lifeExpectancyFemale;
    this.lifeExpectancyMale = props.lifeExpectancyMale;
    this.birthsYoungMothers = props.birthsYoungMothers;
    this.birthsOlderMothers = props.birthsOlderMothers;
    this.lifeExpectancyAt60Female = props.lifeExpectancyAt60Female;
    this.infantMortalityUnder1 = props.infantMortalityUnder1;
    this.lifeExpectancyAt60Male = props.lifeExpectancyAt60Male;
    this.lifeExpectancy = props.lifeExpectancy;
    this.lifeExpectancyAt60 = props.lifeExpectancyAt60;
  }
};
_PopulationData.type = new EntityType({
  type: _PopulationData,
  name: "PopulationData",
  label: {
    en: "Population Data",
    de: "Bev\xF6lkerungsdaten"
  }
});
_PopulationData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "inhabitantsUnder3",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants Under 3",
      de: "Einwohner unter 3"
    }
  }),
  new Field({
    name: "inhabitants3ToUnder6",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 3 to Under 6",
      de: "Einwohner 3 bis unter 6"
    }
  }),
  new Field({
    name: "inhabitantsUnder6",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants Under 6",
      de: "Einwohner unter 6"
    }
  }),
  new Field({
    name: "inhabitants6ToUnder18",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 6 to Under 18",
      de: "Einwohner 6 bis unter 18"
    }
  }),
  new Field({
    name: "inhabitants18ToUnder25",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 18 to Under 25",
      de: "Einwohner 18 bis unter 25"
    }
  }),
  new Field({
    name: "inhabitants25ToUnder30",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 25 to Under 30",
      de: "Einwohner 25 bis unter 30"
    }
  }),
  new Field({
    name: "inhabitants30ToUnder50",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 30 to Under 50",
      de: "Einwohner 30 bis unter 50"
    }
  }),
  new Field({
    name: "inhabitants50ToUnder65",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 50 to Under 65",
      de: "Einwohner 50 bis unter 65"
    }
  }),
  new Field({
    name: "inhabitants65ToUnder75",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 65 to Under 75",
      de: "Einwohner 65 bis unter 75"
    }
  }),
  new Field({
    name: "inhabitants75ToUnder85",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 75 to Under 85",
      de: "Einwohner 75 bis unter 85"
    }
  }),
  new Field({
    name: "inhabitants65AndOlder",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 65 and Older",
      de: "Einwohner 65 und \xE4lter"
    }
  }),
  new Field({
    name: "inhabitants75AndOlder",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 75 and Older",
      de: "Einwohner 75 und \xE4lter"
    }
  }),
  new Field({
    name: "inhabitants85AndOlder",
    type: Number,
    key: false,
    label: {
      en: "Inhabitants 85 and Older",
      de: "Einwohner 85 und \xE4lter"
    }
  }),
  new Field({
    name: "female18ToUnder25",
    type: Number,
    key: false,
    label: {
      en: "Female 18 to Under 25",
      de: "Weiblich 18 bis unter 25"
    }
  }),
  new Field({
    name: "female25ToUnder30",
    type: Number,
    key: false,
    label: {
      en: "Female 25 to Under 30",
      de: "Weiblich 25 bis unter 30"
    }
  }),
  new Field({
    name: "female65ToUnder75",
    type: Number,
    key: false,
    label: {
      en: "Female 65 to Under 75",
      de: "Weiblich 65 bis unter 75"
    }
  }),
  new Field({
    name: "female75ToUnder85",
    type: Number,
    key: false,
    label: {
      en: "Female 75 to Under 85",
      de: "Weiblich 75 bis unter 85"
    }
  }),
  new Field({
    name: "female65AndOlder",
    type: Number,
    key: false,
    label: {
      en: "Female 65 and Older",
      de: "Weiblich 65 und \xE4lter"
    }
  }),
  new Field({
    name: "female75AndOlder",
    type: Number,
    key: false,
    label: {
      en: "Female 75 and Older",
      de: "Weiblich 75 und \xE4lter"
    }
  }),
  new Field({
    name: "female85AndOlder",
    type: Number,
    key: false,
    label: {
      en: "Female 85 and Older",
      de: "Weiblich 85 und \xE4lter"
    }
  }),
  new Field({
    name: "averageAgePopulation",
    type: Number,
    key: false,
    label: {
      en: "Average Age Population",
      de: "Durchschnittsalter Bev\xF6lkerung"
    }
  }),
  new Field({
    name: "marriages",
    type: Number,
    key: false,
    label: {
      en: "Marriages",
      de: "Eheschlie\xDFungen"
    }
  }),
  new Field({
    name: "divorces",
    type: Number,
    key: false,
    label: {
      en: "Divorces",
      de: "Scheidungen"
    }
  }),
  new Field({
    name: "foreignerShare",
    type: Number,
    key: false,
    label: {
      en: "Foreigner Share",
      de: "Ausl\xE4nderanteil"
    }
  }),
  new Field({
    name: "femaleForeigners",
    type: Number,
    key: false,
    label: {
      en: "Female Foreigners",
      de: "Weibliche Ausl\xE4nder"
    }
  }),
  new Field({
    name: "householdSize",
    type: Number,
    key: false,
    label: {
      en: "Household Size",
      de: "Haushaltsgr\xF6\xDFe"
    }
  }),
  new Field({
    name: "singlePersonHouseholds",
    type: Number,
    key: false,
    label: {
      en: "Single Person Households",
      de: "Einpersonenhaushalte"
    }
  }),
  new Field({
    name: "householdsWithChildren",
    type: Number,
    key: false,
    label: {
      en: "Households with Children",
      de: "Haushalte mit Kindern"
    }
  }),
  new Field({
    name: "youthDependencyRatio",
    type: Number,
    key: false,
    label: {
      en: "Youth Dependency Ratio",
      de: "Jugendquotient"
    }
  }),
  new Field({
    name: "elderlyDependencyRatio",
    type: Number,
    key: false,
    label: {
      en: "Elderly Dependency Ratio",
      de: "Altenquotient"
    }
  }),
  new Field({
    name: "femaleShare",
    type: Number,
    key: false,
    label: {
      en: "Female Share",
      de: "Frauenanteil"
    }
  }),
  new Field({
    name: "femaleShare20ToUnder40",
    type: Number,
    key: false,
    label: {
      en: "Female Share 20 to Under 40",
      de: "Frauenanteil 20 bis unter 40"
    }
  }),
  new Field({
    name: "naturalizationsPerForeigner",
    type: Number,
    key: false,
    label: {
      en: "Naturalizations per Foreigner",
      de: "Einb\xFCrgerungen je Ausl\xE4nder"
    }
  }),
  new Field({
    name: "naturalizationsPerInhabitant",
    type: Number,
    key: false,
    label: {
      en: "Naturalizations per Inhabitant",
      de: "Einb\xFCrgerungen je Einwohner"
    }
  }),
  new Field({
    name: "refugeesPerPopulation",
    type: Number,
    key: false,
    label: {
      en: "Refugees per Population",
      de: "Fl\xFCchtlinge je Bev\xF6lkerung"
    }
  }),
  new Field({
    name: "refugeesPerForeignPopulation",
    type: Number,
    key: false,
    label: {
      en: "Refugees per Foreign Population",
      de: "Fl\xFCchtlinge je ausl\xE4ndische Bev\xF6lkerung"
    }
  }),
  new Field({
    name: "populationGrowth10Y",
    type: Number,
    key: false,
    label: {
      en: "Population Growth 10 Years",
      de: "Bev\xF6lkerungswachstum 10 Jahre"
    }
  }),
  new Field({
    name: "populationGrowth5Y",
    type: Number,
    key: false,
    label: {
      en: "Population Growth 5 Years",
      de: "Bev\xF6lkerungswachstum 5 Jahre"
    }
  }),
  new Field({
    name: "migrationBalanceTotal",
    type: Number,
    key: false,
    label: {
      en: "Migration Balance Total",
      de: "Wanderungssaldo gesamt"
    }
  }),
  new Field({
    name: "migrationBalanceExternal",
    type: Number,
    key: false,
    label: {
      en: "Migration Balance External",
      de: "Wanderungssaldo Au\xDFenwanderung"
    }
  }),
  new Field({
    name: "migrationBalanceExternalFemale",
    type: Number,
    key: false,
    label: {
      en: "Migration Balance External Female",
      de: "Wanderungssaldo Au\xDFenwanderung weiblich"
    }
  }),
  new Field({
    name: "migrationBalanceExternalMale",
    type: Number,
    key: false,
    label: {
      en: "Migration Balance External Male",
      de: "Wanderungssaldo Au\xDFenwanderung m\xE4nnlich"
    }
  }),
  new Field({
    name: "migrationBalanceInternal",
    type: Number,
    key: false,
    label: {
      en: "Migration Balance Internal",
      de: "Wanderungssaldo Binnenwanderung"
    }
  }),
  new Field({
    name: "migrationBalanceInternalFemale",
    type: Number,
    key: false,
    label: {
      en: "Migration Balance Internal Female",
      de: "Wanderungssaldo Binnenwanderung weiblich"
    }
  }),
  new Field({
    name: "migrationBalanceInternalMale",
    type: Number,
    key: false,
    label: {
      en: "Migration Balance Internal Male",
      de: "Wanderungssaldo Binnenwanderung m\xE4nnlich"
    }
  }),
  new Field({
    name: "educationMigrants",
    type: Number,
    key: false,
    label: {
      en: "Education Migrants",
      de: "Bildungswanderer"
    }
  }),
  new Field({
    name: "femaleEducationMigrants",
    type: Number,
    key: false,
    label: {
      en: "Female Education Migrants",
      de: "Bildungswanderer weiblich"
    }
  }),
  new Field({
    name: "maleEducationMigrants",
    type: Number,
    key: false,
    label: {
      en: "Male Education Migrants",
      de: "Bildungswanderer m\xE4nnlich"
    }
  }),
  new Field({
    name: "earlyCareerMigrants",
    type: Number,
    key: false,
    label: {
      en: "Early Career Migrants",
      de: "Berufseinstiegswanderer"
    }
  }),
  new Field({
    name: "femaleEarlyCareerMigrants",
    type: Number,
    key: false,
    label: {
      en: "Female Early Career Migrants",
      de: "Berufseinstiegswanderer weiblich"
    }
  }),
  new Field({
    name: "maleEarlyCareerMigrants",
    type: Number,
    key: false,
    label: {
      en: "Male Early Career Migrants",
      de: "Berufseinstiegswanderer m\xE4nnlich"
    }
  }),
  new Field({
    name: "retirementMigrants",
    type: Number,
    key: false,
    label: {
      en: "Retirement Migrants",
      de: "Rentnerwanderer"
    }
  }),
  new Field({
    name: "familyMigrants",
    type: Number,
    key: false,
    label: {
      en: "Family Migrants",
      de: "Familienwanderer"
    }
  }),
  new Field({
    name: "employmentMigrants",
    type: Number,
    key: false,
    label: {
      en: "Employment Migrants",
      de: "Erwerbswanderer"
    }
  }),
  new Field({
    name: "internalMigrationVolume",
    type: Number,
    key: false,
    label: {
      en: "Internal Migration Volume",
      de: "Binnenwanderungsvolumen"
    }
  }),
  new Field({
    name: "internalMigrationVolumeFemale",
    type: Number,
    key: false,
    label: {
      en: "Internal Migration Volume Female",
      de: "Binnenwanderungsvolumen weiblich"
    }
  }),
  new Field({
    name: "internalMigrationVolumeMale",
    type: Number,
    key: false,
    label: {
      en: "Internal Migration Volume Male",
      de: "Binnenwanderungsvolumen m\xE4nnlich"
    }
  }),
  new Field({
    name: "immigrationRate",
    type: Number,
    key: false,
    label: {
      en: "Immigration Rate",
      de: "Zuzugsrate"
    }
  }),
  new Field({
    name: "emigrationRate",
    type: Number,
    key: false,
    label: {
      en: "Emigration Rate",
      de: "Fortzugsrate"
    }
  }),
  new Field({
    name: "femaleImmigrationRate",
    type: Number,
    key: false,
    label: {
      en: "Female Immigration Rate",
      de: "Zuzugsrate weiblich"
    }
  }),
  new Field({
    name: "femaleEmigrationRate",
    type: Number,
    key: false,
    label: {
      en: "Female Emigration Rate",
      de: "Fortzugsrate weiblich"
    }
  }),
  new Field({
    name: "maleImmigrationRate",
    type: Number,
    key: false,
    label: {
      en: "Male Immigration Rate",
      de: "Zuzugsrate m\xE4nnlich"
    }
  }),
  new Field({
    name: "maleEmigrationRate",
    type: Number,
    key: false,
    label: {
      en: "Male Emigration Rate",
      de: "Fortzugsrate m\xE4nnlich"
    }
  }),
  new Field({
    name: "births",
    type: Number,
    key: false,
    label: {
      en: "Births",
      de: "Geburten"
    }
  }),
  new Field({
    name: "deaths",
    type: Number,
    key: false,
    label: {
      en: "Deaths",
      de: "Sterbef\xE4lle"
    }
  }),
  new Field({
    name: "naturalPopulationBalance",
    type: Number,
    key: false,
    label: {
      en: "Natural Population Balance",
      de: "Nat\xFCrlicher Bev\xF6lkerungssaldo"
    }
  }),
  new Field({
    name: "totalFertilityRate",
    type: Number,
    key: false,
    label: {
      en: "Total Fertility Rate",
      de: "Gesamtfruchtbarkeitsrate"
    }
  }),
  new Field({
    name: "lifeExpectancyFemale",
    type: Number,
    key: false,
    label: {
      en: "Life Expectancy Female",
      de: "Lebenserwartung weiblich"
    }
  }),
  new Field({
    name: "lifeExpectancyMale",
    type: Number,
    key: false,
    label: {
      en: "Life Expectancy Male",
      de: "Lebenserwartung m\xE4nnlich"
    }
  }),
  new Field({
    name: "birthsYoungMothers",
    type: Number,
    key: false,
    label: {
      en: "Births Young Mothers",
      de: "Geburten junge M\xFCtter"
    }
  }),
  new Field({
    name: "birthsOlderMothers",
    type: Number,
    key: false,
    label: {
      en: "Births Older Mothers",
      de: "Geburten \xE4ltere M\xFCtter"
    }
  }),
  new Field({
    name: "lifeExpectancyAt60Female",
    type: Number,
    key: false,
    label: {
      en: "Life Expectancy at 60 Female",
      de: "Lebenserwartung mit 60 weiblich"
    }
  }),
  new Field({
    name: "infantMortalityUnder1",
    type: Number,
    key: false,
    label: {
      en: "Infant Mortality Under 1",
      de: "S\xE4uglingssterblichkeit unter 1"
    }
  }),
  new Field({
    name: "lifeExpectancyAt60Male",
    type: Number,
    key: false,
    label: {
      en: "Life Expectancy at 60 Male",
      de: "Lebenserwartung mit 60 m\xE4nnlich"
    }
  }),
  new Field({
    name: "lifeExpectancy",
    type: Number,
    key: false,
    label: {
      en: "Life Expectancy",
      de: "Lebenserwartung"
    }
  }),
  new Field({
    name: "lifeExpectancyAt60",
    type: Number,
    key: false,
    label: {
      en: "Life Expectancy at 60",
      de: "Lebenserwartung mit 60"
    }
  })
];
_PopulationData.relationships = [];
var PopulationData = _PopulationData;
var _PoliticsData = class _PoliticsData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.voterTurnout = props.voterTurnout;
    this.voteShareCduCsu = props.voteShareCduCsu;
    this.voteShareSpd = props.voteShareSpd;
    this.voteShareGreens = props.voteShareGreens;
    this.voteShareFdp = props.voteShareFdp;
    this.voteShareOtherParties = props.voteShareOtherParties;
    this.voteShareLeftParty = props.voteShareLeftParty;
    this.voteShareAfd = props.voteShareAfd;
  }
};
_PoliticsData.type = new EntityType({
  type: _PoliticsData,
  name: "PoliticsData",
  label: {
    en: "Politics Data",
    de: "Politikdaten"
  }
});
_PoliticsData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "voterTurnout",
    type: Number,
    key: false,
    label: {
      en: "Voter Turnout",
      de: "W\xE4hlerbeteiligung"
    }
  }),
  new Field({
    name: "voteShareCduCsu",
    type: Number,
    key: false,
    label: {
      en: "Vote Share CDU/CSU",
      de: "Stimmenanteil CDU/CSU"
    }
  }),
  new Field({
    name: "voteShareSpd",
    type: Number,
    key: false,
    label: {
      en: "Vote Share SPD",
      de: "Stimmenanteil SPD"
    }
  }),
  new Field({
    name: "voteShareGreens",
    type: Number,
    key: false,
    label: {
      en: "Vote Share Greens",
      de: "Stimmenanteil Gr\xFCne"
    }
  }),
  new Field({
    name: "voteShareFdp",
    type: Number,
    key: false,
    label: {
      en: "Vote Share FDP",
      de: "Stimmenanteil FDP"
    }
  }),
  new Field({
    name: "voteShareOtherParties",
    type: Number,
    key: false,
    label: {
      en: "Vote Share Other Parties",
      de: "Stimmenanteil Sonstige"
    }
  }),
  new Field({
    name: "voteShareLeftParty",
    type: Number,
    key: false,
    label: {
      en: "Vote Share Left Party",
      de: "Stimmenanteil Linke"
    }
  }),
  new Field({
    name: "voteShareAfd",
    type: Number,
    key: false,
    label: {
      en: "Vote Share AfD",
      de: "Stimmenanteil AfD"
    }
  })
];
_PoliticsData.relationships = [];
var PoliticsData = _PoliticsData;
var _SocialSupplyData = class _SocialSupplyData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.peopleInNeedOfCare = props.peopleInNeedOfCare;
    this.outpatientCare = props.outpatientCare;
    this.inpatientCare = props.inpatientCare;
    this.recipientsOfCareAllowance = props.recipientsOfCareAllowance;
    this.staffInNursingHomes = props.staffInNursingHomes;
    this.staffInHomeCareServices = props.staffInHomeCareServices;
    this.nursingHomePlacesPerCapita = props.nursingHomePlacesPerCapita;
    this.childcareRateUnder3 = props.childcareRateUnder3;
    this.fullDayChildcareRateUnder3 = props.fullDayChildcareRateUnder3;
    this.childcareRatePreschool = props.childcareRatePreschool;
    this.fullDayChildcareRatePreschool = props.fullDayChildcareRatePreschool;
    this.childrenWithForeignOriginInDaycare = props.childrenWithForeignOriginInDaycare;
    this.pedagogicalStaffInDaycare = props.pedagogicalStaffInDaycare;
    this.inclusiveDaycareCenters = props.inclusiveDaycareCenters;
  }
};
_SocialSupplyData.type = new EntityType({
  type: _SocialSupplyData,
  name: "SocialSupplyData",
  label: {
    en: "Social Supply Data",
    de: "Sozialeversorgungsdaten"
  }
});
_SocialSupplyData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "peopleInNeedOfCare",
    type: Number,
    key: false,
    label: {
      en: "People in Need of Care",
      de: "Pflegebed\xFCrftige"
    }
  }),
  new Field({
    name: "outpatientCare",
    type: Number,
    key: false,
    label: {
      en: "Outpatient Care",
      de: "Ambulante Pflege"
    }
  }),
  new Field({
    name: "inpatientCare",
    type: Number,
    key: false,
    label: {
      en: "Inpatient Care",
      de: "Station\xE4re Pflege"
    }
  }),
  new Field({
    name: "recipientsOfCareAllowance",
    type: Number,
    key: false,
    label: {
      en: "Recipients of Care Allowance",
      de: "Pflegegeldempf\xE4nger"
    }
  }),
  new Field({
    name: "staffInNursingHomes",
    type: Number,
    key: false,
    label: {
      en: "Staff in Nursing Homes",
      de: "Personal in Pflegeheimen"
    }
  }),
  new Field({
    name: "staffInHomeCareServices",
    type: Number,
    key: false,
    label: {
      en: "Staff in Nursing Services",
      de: "Personal in Pflegediensten"
    }
  }),
  new Field({
    name: "nursingHomePlacesPerCapita",
    type: Number,
    key: false,
    label: {
      en: "Nursing Home Places per Capita",
      de: "Pflegeheimpl\xE4tze je Einwohner"
    }
  }),
  new Field({
    name: "childcareRateUnder3",
    type: Number,
    key: false,
    label: {
      en: "Childcare Rate Under 3",
      de: "Betreuungsquote unter 3"
    }
  }),
  new Field({
    name: "fullDayChildcareRateUnder3",
    type: Number,
    key: false,
    label: {
      en: "Full Day Childcare Rate Under 3",
      de: "Ganztagsbetreuungsquote unter 3"
    }
  }),
  new Field({
    name: "childcareRatePreschool",
    type: Number,
    key: false,
    label: {
      en: "Childcare Rate Preschool",
      de: "Betreuungsquote Kindergarten"
    }
  }),
  new Field({
    name: "fullDayChildcareRatePreschool",
    type: Number,
    key: false,
    label: {
      en: "Full Day Childcare Rate Preschool",
      de: "Ganztagsbetreuungsquote Kindergarten"
    }
  }),
  new Field({
    name: "childrenWithForeignOriginInDaycare",
    type: Number,
    key: false,
    label: {
      en: "Children with Foreign Origin in Daycare",
      de: "Kinder mit Migrationshintergrund in Tagesbetreuung"
    }
  }),
  new Field({
    name: "pedagogicalStaffInDaycare",
    type: Number,
    key: false,
    label: {
      en: "Pedagogical Staff in Daycare",
      de: "P\xE4dagogisches Personal in Tagesbetreuung"
    }
  }),
  new Field({
    name: "inclusiveDaycareCenters",
    type: Number,
    key: false,
    label: {
      en: "Inclusive Daycare Centers",
      de: "Inklusive Kindertageseinrichtungen"
    }
  })
];
_SocialSupplyData.relationships = [];
var SocialSupplyData = _SocialSupplyData;
var _PublicFinancesData = class _PublicFinancesData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.fiscalCapacity = props.fiscalCapacity;
    this.taxRevenue = props.taxRevenue;
    this.incomeTax = props.incomeTax;
    this.businessTax = props.businessTax;
    this.valueAddedTax = props.valueAddedTax;
    this.keyAllocations = props.keyAllocations;
    this.municipalDebt = props.municipalDebt;
    this.cashAdvances = props.cashAdvances;
    this.municipalStaff = props.municipalStaff;
    this.expenditureOnCapitalInvestments = props.expenditureOnCapitalInvestments;
    this.grantsForInvestmentPromotion = props.grantsForInvestmentPromotion;
  }
};
_PublicFinancesData.type = new EntityType({
  type: _PublicFinancesData,
  name: "PublicFinancesData",
  label: {
    en: "Public Finances Data",
    de: "Daten zu \xD6ffentliche Finanzen"
  }
});
_PublicFinancesData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "fiscalCapacity",
    type: Number,
    key: false,
    label: {
      en: "Fiscal Capacity",
      de: "Steuerkraft"
    }
  }),
  new Field({
    name: "taxRevenue",
    type: Number,
    key: false,
    label: {
      en: "Tax Revenue",
      de: "Steuereinnahmen"
    }
  }),
  new Field({
    name: "incomeTax",
    type: Number,
    key: false,
    label: {
      en: "Income Tax",
      de: "Einkommensteuer"
    }
  }),
  new Field({
    name: "businessTax",
    type: Number,
    key: false,
    label: {
      en: "Business Tax",
      de: "Gewerbesteuer"
    }
  }),
  new Field({
    name: "valueAddedTax",
    type: Number,
    key: false,
    label: {
      en: "Value Added Tax",
      de: "Umsatzsteuer"
    }
  }),
  new Field({
    name: "keyAllocations",
    type: Number,
    key: false,
    label: {
      en: "Key Allocations",
      de: "Schl\xFCsselzuweisungen"
    }
  }),
  new Field({
    name: "municipalDebt",
    type: Number,
    key: false,
    label: {
      en: "Municipal Debt",
      de: "Gemeindeschulden"
    }
  }),
  new Field({
    name: "cashAdvances",
    type: Number,
    key: false,
    label: {
      en: "Cash Advances",
      de: "Kassenkredite"
    }
  }),
  new Field({
    name: "municipalStaff",
    type: Number,
    key: false,
    label: {
      en: "Municipal Staff",
      de: "Gemeindebedienstete"
    }
  }),
  new Field({
    name: "expenditureOnCapitalInvestments",
    type: Number,
    key: false,
    label: {
      en: "Expenditure on Capital Investments",
      de: "Ausgaben f\xFCr Investitionen"
    }
  }),
  new Field({
    name: "grantsForInvestmentPromotion",
    type: Number,
    key: false,
    label: {
      en: "Grants for Investment Promotion",
      de: "Zusch\xFCsse f\xFCr Investitionsf\xF6rderung"
    }
  })
];
_PublicFinancesData.relationships = [];
var PublicFinancesData = _PublicFinancesData;
var _SubsidiesData = class _SubsidiesData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.urbanDevelopmentFundingLongTerm = props.urbanDevelopmentFundingLongTerm;
    this.urbanDevelopmentFundingShortTerm = props.urbanDevelopmentFundingShortTerm;
    this.grwBusinessSupportLongTerm = props.grwBusinessSupportLongTerm;
    this.grwBusinessSupportShortTerm = props.grwBusinessSupportShortTerm;
    this.grwInfrastructureSupportLongTerm = props.grwInfrastructureSupportLongTerm;
    this.grwInfrastructureSupportShortTerm = props.grwInfrastructureSupportShortTerm;
    this.universityFundingLongTerm = props.universityFundingLongTerm;
    this.universityFundingShortTerm = props.universityFundingShortTerm;
    this.laborMarketSupportBALongTerm = props.laborMarketSupportBALongTerm;
    this.laborMarketSupportBAShortTerm = props.laborMarketSupportBAShortTerm;
    this.directProjectFundingLongTerm = props.directProjectFundingLongTerm;
    this.directProjectFundingShortTerm = props.directProjectFundingShortTerm;
  }
};
_SubsidiesData.type = new EntityType({
  type: _SubsidiesData,
  name: "SubsidiesData",
  label: {
    en: "Subsidies Data",
    de: "Daten zu Subventionen/F\xF6rderungen"
  }
});
_SubsidiesData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "urbanDevelopmentFundingLongTerm",
    type: Number,
    key: false,
    label: {
      en: "Urban Development Funding Long Term",
      de: "St\xE4dtebauf\xF6rderung langfristig"
    }
  }),
  new Field({
    name: "urbanDevelopmentFundingShortTerm",
    type: Number,
    key: false,
    label: {
      en: "Urban Development Funding Short Term",
      de: "St\xE4dtebauf\xF6rderung kurzfristig"
    }
  }),
  new Field({
    name: "grwBusinessSupportLongTerm",
    type: Number,
    key: false,
    label: {
      en: "GRW Business Support Long Term",
      de: "GRW Wirtschaftsf\xF6rderung langfristig"
    }
  }),
  new Field({
    name: "grwBusinessSupportShortTerm",
    type: Number,
    key: false,
    label: {
      en: "GRW Business Support Short Term",
      de: "GRW Wirtschaftsf\xF6rderung kurzfristig"
    }
  }),
  new Field({
    name: "grwInfrastructureSupportLongTerm",
    type: Number,
    key: false,
    label: {
      en: "GRW Infrastructure Support Long Term",
      de: "GRW Infrastrukturf\xF6rderung langfristig"
    }
  }),
  new Field({
    name: "grwInfrastructureSupportShortTerm",
    type: Number,
    key: false,
    label: {
      en: "GRW Infrastructure Support Short Term",
      de: "GRW Infrastrukturf\xF6rderung kurzfristig"
    }
  }),
  new Field({
    name: "universityFundingLongTerm",
    type: Number,
    key: false,
    label: {
      en: "University Funding Long Term",
      de: "Hochschulf\xF6rderung langfristig"
    }
  }),
  new Field({
    name: "universityFundingShortTerm",
    type: Number,
    key: false,
    label: {
      en: "University Funding Short Term",
      de: "Hochschulf\xF6rderung kurzfristig"
    }
  }),
  new Field({
    name: "laborMarketSupportBALongTerm",
    type: Number,
    key: false,
    label: {
      en: "Labor Market Support BA Long Term",
      de: "Arbeitsmarktf\xF6rderung BA langfristig"
    }
  }),
  new Field({
    name: "laborMarketSupportBAShortTerm",
    type: Number,
    key: false,
    label: {
      en: "Labor Market Support BA Short Term",
      de: "Arbeitsmarktf\xF6rderung BA kurzfristig"
    }
  }),
  new Field({
    name: "directProjectFundingLongTerm",
    type: Number,
    key: false,
    label: {
      en: "Direct Project Funding Long Term",
      de: "Direkte Projektf\xF6rderung langfristig"
    }
  }),
  new Field({
    name: "directProjectFundingShortTerm",
    type: Number,
    key: false,
    label: {
      en: "Direct Project Funding Short Term",
      de: "Direkte Projektf\xF6rderung kurzfristig"
    }
  })
];
_SubsidiesData.relationships = [];
var SubsidiesData = _SubsidiesData;
var _SocialBenefitsData = class _SocialBenefitsData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.sgbiiRate = props.sgbiiRate;
    this.femaleSgbiiRecipients = props.femaleSgbiiRecipients;
    this.housingAllowanceHouseholds = props.housingAllowanceHouseholds;
    this.rentSubsidyHouseholds = props.rentSubsidyHouseholds;
    this.burdenSubsidyHouseholds = props.burdenSubsidyHouseholds;
    this.elderlyBasicIncomeRecipients = props.elderlyBasicIncomeRecipients;
    this.femaleElderlyBasicIncomeRecipients = props.femaleElderlyBasicIncomeRecipients;
    this.maleElderlyBasicIncomeRecipients = props.maleElderlyBasicIncomeRecipients;
    this.asylumApplicants = props.asylumApplicants;
    this.minimumSecurityRecipients = props.minimumSecurityRecipients;
    this.parentalBenefitFathersFirstYear = props.parentalBenefitFathersFirstYear;
    this.parentalBenefitFathers = props.parentalBenefitFathers;
    this.parentalBenefitMothers = props.parentalBenefitMothers;
    this.singlePersonNeedsCommunity = props.singlePersonNeedsCommunity;
    this.largeNeedsCommunity = props.largeNeedsCommunity;
    this.needsCommunityWithChildren = props.needsCommunityWithChildren;
    this.personsInNeedsCommunity = props.personsInNeedsCommunity;
    this.employableBenefitRecipients = props.employableBenefitRecipients;
    this.femaleEmployableBenefitRecipients = props.femaleEmployableBenefitRecipients;
    this.youngEmployableBenefitRecipients = props.youngEmployableBenefitRecipients;
    this.olderEmployableBenefitRecipients = props.olderEmployableBenefitRecipients;
    this.singleParentEmployableRecipients = props.singleParentEmployableRecipients;
    this.childPoverty = props.childPoverty;
    this.alg1Benefits = props.alg1Benefits;
    this.alg1BenefitsMen = props.alg1BenefitsMen;
    this.alg1BenefitsWomen = props.alg1BenefitsWomen;
    this.sgbiiBenefits = props.sgbiiBenefits;
    this.alg2BenefitsAmount = props.alg2BenefitsAmount;
    this.alg2BenefitsForSgbii = props.alg2BenefitsForSgbii;
    this.housingBenefitAmount = props.housingBenefitAmount;
    this.housingBenefitForSgbii = props.housingBenefitForSgbii;
    this.housingSubsidyBenefits = props.housingSubsidyBenefits;
  }
};
_SocialBenefitsData.type = new EntityType({
  type: _SocialBenefitsData,
  name: "SocialBenefitsData",
  label: {
    en: "Social Benefits Data",
    de: "Daten zu Sozialleistungen"
  }
});
_SocialBenefitsData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "sgbiiRate",
    type: Number,
    key: false,
    label: {
      en: "SGB II Rate",
      de: "SGB II Quote"
    }
  }),
  new Field({
    name: "femaleSgbiiRecipients",
    type: Number,
    key: false,
    label: {
      en: "Female SGB II Recipients",
      de: "Weibliche SGB II-Empf\xE4nger"
    }
  }),
  new Field({
    name: "housingAllowanceHouseholds",
    type: Number,
    key: false,
    label: {
      en: "Housing Allowance Households",
      de: "Wohngeldhaushalte"
    }
  }),
  new Field({
    name: "rentSubsidyHouseholds",
    type: Number,
    key: false,
    label: {
      en: "Rent Subsidy Households",
      de: "Mietzuschusshaushalte"
    }
  }),
  new Field({
    name: "burdenSubsidyHouseholds",
    type: Number,
    key: false,
    label: {
      en: "Burden Subsidy Households",
      de: "Lastenzuschusshaushalte"
    }
  }),
  new Field({
    name: "elderlyBasicIncomeRecipients",
    type: Number,
    key: false,
    label: {
      en: "Elderly Basic Income Recipients",
      de: "Grundsicherung im Alter Empf\xE4nger"
    }
  }),
  new Field({
    name: "femaleElderlyBasicIncomeRecipients",
    type: Number,
    key: false,
    label: {
      en: "Female Elderly Basic Income Recipients",
      de: "Grundsicherung im Alter weibliche Empf\xE4nger"
    }
  }),
  new Field({
    name: "maleElderlyBasicIncomeRecipients",
    type: Number,
    key: false,
    label: {
      en: "Male Elderly Basic Income Recipients",
      de: "Grundsicherung im Alter m\xE4nnliche Empf\xE4nger"
    }
  }),
  new Field({
    name: "asylumApplicants",
    type: Number,
    key: false,
    label: {
      en: "Asylum Applicants",
      de: "Asylbewerber"
    }
  }),
  new Field({
    name: "minimumSecurityRecipients",
    type: Number,
    key: false,
    label: {
      en: "Minimum Security Recipients",
      de: "Mindestsicherungsempf\xE4nger"
    }
  }),
  new Field({
    name: "parentalBenefitFathersFirstYear",
    type: Number,
    key: false,
    label: {
      en: "Parental Benefit Fathers First Year",
      de: "Elterngeld V\xE4ter erstes Jahr"
    }
  }),
  new Field({
    name: "parentalBenefitFathers",
    type: Number,
    key: false,
    label: {
      en: "Parental Benefit Fathers",
      de: "Elterngeld V\xE4ter"
    }
  }),
  new Field({
    name: "parentalBenefitMothers",
    type: Number,
    key: false,
    label: {
      en: "Parental Benefit Mothers",
      de: "Elterngeld M\xFCtter"
    }
  }),
  new Field({
    name: "singlePersonNeedsCommunity",
    type: Number,
    key: false,
    label: {
      en: "Single Person Needs Community",
      de: "Einpersonen-Bedarfsgemeinschaft"
    }
  }),
  new Field({
    name: "largeNeedsCommunity",
    type: Number,
    key: false,
    label: {
      en: "Large Needs Community",
      de: "Gro\xDFe Bedarfsgemeinschaft"
    }
  }),
  new Field({
    name: "needsCommunityWithChildren",
    type: Number,
    key: false,
    label: {
      en: "Needs Community with Children",
      de: "Bedarfsgemeinschaft mit Kindern"
    }
  }),
  new Field({
    name: "personsInNeedsCommunity",
    type: Number,
    key: false,
    label: {
      en: "Persons in Needs Community",
      de: "Personen in Bedarfsgemeinschaft"
    }
  }),
  new Field({
    name: "employableBenefitRecipients",
    type: Number,
    key: false,
    label: {
      en: "Employable Benefit Recipients",
      de: "Erwerbsf\xE4hige Leistungsberechtigte"
    }
  }),
  new Field({
    name: "femaleEmployableBenefitRecipients",
    type: Number,
    key: false,
    label: {
      en: "Female Employable Benefit Recipients",
      de: "Erwerbsf\xE4hige Leistungsberechtigte weiblich"
    }
  }),
  new Field({
    name: "youngEmployableBenefitRecipients",
    type: Number,
    key: false,
    label: {
      en: "Young Employable Benefit Recipients",
      de: "Erwerbsf\xE4hige Leistungsberechtigte jung"
    }
  }),
  new Field({
    name: "olderEmployableBenefitRecipients",
    type: Number,
    key: false,
    label: {
      en: "Older Employable Benefit Recipients",
      de: "Erwerbsf\xE4hige Leistungsberechtigte \xE4lter"
    }
  }),
  new Field({
    name: "singleParentEmployableRecipients",
    type: Number,
    key: false,
    label: {
      en: "Single Parent Employable Recipients",
      de: "Alleinerziehende erwerbsf\xE4hige Leistungsberechtigte"
    }
  }),
  new Field({
    name: "childPoverty",
    type: Number,
    key: false,
    label: {
      en: "Child Poverty",
      de: "Kinderarmut"
    }
  }),
  new Field({
    name: "alg1Benefits",
    type: Number,
    key: false,
    label: {
      en: "ALG 1 Benefits",
      de: "Arbeitslosengeld 1"
    }
  }),
  new Field({
    name: "alg1BenefitsMen",
    type: Number,
    key: false,
    label: {
      en: "ALG 1 Benefits Men",
      de: "Arbeitslosengeld 1 M\xE4nner"
    }
  }),
  new Field({
    name: "alg1BenefitsWomen",
    type: Number,
    key: false,
    label: {
      en: "ALG 1 Benefits Women",
      de: "Arbeitslosengeld 1 Frauen"
    }
  }),
  new Field({
    name: "sgbiiBenefits",
    type: Number,
    key: false,
    label: {
      en: "SGB II Benefits",
      de: "SGB II Leistungen"
    }
  }),
  new Field({
    name: "alg2BenefitsAmount",
    type: Number,
    key: false,
    label: {
      en: "ALG 2 Benefits Amount",
      de: "Arbeitslosengeld 2 Betrag"
    }
  }),
  new Field({
    name: "alg2BenefitsForSgbii",
    type: Number,
    key: false,
    label: {
      en: "ALG 2 Benefits for SGB II",
      de: "Arbeitslosengeld 2 f\xFCr SGB II"
    }
  }),
  new Field({
    name: "housingBenefitAmount",
    type: Number,
    key: false,
    label: {
      en: "Housing Benefit Amount",
      de: "Wohnhilfe Betrag"
    }
  }),
  new Field({
    name: "housingBenefitForSgbii",
    type: Number,
    key: false,
    label: {
      en: "Housing Benefit for SGB II",
      de: "Wohnhilfe f\xFCr SGB II"
    }
  }),
  new Field({
    name: "housingSubsidyBenefits",
    type: Number,
    key: false,
    label: {
      en: "Housing Subsidy Benefits",
      de: "Wohngeld Leistungen"
    }
  })
];
_SocialBenefitsData.relationships = [];
var SocialBenefitsData = _SocialBenefitsData;
var _IncomeData = class _IncomeData extends Entity {
  constructor(props) {
    super(props);
    this.municipalityKey = props.municipalityKey;
    this.year = props.year;
    this.grossEarnings = props.grossEarnings;
    this.grossEarningsInManufacturing = props.grossEarningsInManufacturing;
    this.medianIncome = props.medianIncome;
    this.medianIncomeWomen = props.medianIncomeWomen;
    this.medianIncomeMen = props.medianIncomeMen;
    this.medianIncome25ToUnder55 = props.medianIncome25ToUnder55;
    this.medianIncome55ToUnder65 = props.medianIncome55ToUnder65;
    this.medianIncomeWithVocationalQualification = props.medianIncomeWithVocationalQualification;
    this.medianIncomeWithAcademicQualification = props.medianIncomeWithAcademicQualification;
    this.householdIncome = props.householdIncome;
    this.householdsWithLowIncome = props.householdsWithLowIncome;
    this.householdsWithMiddleIncome = props.householdsWithMiddleIncome;
    this.householdsWithHighIncome = props.householdsWithHighIncome;
    this.purchasingPower = props.purchasingPower;
    this.retailRelevantPurchasingPower = props.retailRelevantPurchasingPower;
    this.consumerInsolvencyProceedings = props.consumerInsolvencyProceedings;
    this.consumerInsolvencyClaims = props.consumerInsolvencyClaims;
    this.selfEmployedInInsolvenciesShare = props.selfEmployedInInsolvenciesShare;
    this.debtorRate = props.debtorRate;
    this.workVolume = props.workVolume;
  }
};
_IncomeData.type = new EntityType({
  type: _IncomeData,
  name: "IncomeData",
  label: {
    en: "Income Data",
    de: "Einkommensdaten"
  }
});
_IncomeData.fields = [
  new Field({
    name: "municipalityKey",
    type: String,
    key: false,
    label: {
      en: "Municipality Key",
      de: "Gemeindeschl\xFCssel"
    }
  }),
  new Field({
    name: "year",
    type: Number,
    key: false,
    label: {
      en: "Year",
      de: "Jahr"
    }
  }),
  new Field({
    name: "grossEarnings",
    type: Number,
    key: false,
    label: {
      en: "Gross Earnings",
      de: "Bruttoeinkommen"
    }
  }),
  new Field({
    name: "grossEarningsInManufacturing",
    type: Number,
    key: false,
    label: {
      en: "Gross Earnings in Manufacturing",
      de: "Bruttoeinkommen im verarbeitenden Gewerbe"
    }
  }),
  new Field({
    name: "medianIncome",
    type: Number,
    key: false,
    label: {
      en: "Median Income",
      de: "Medianeinkommen"
    }
  }),
  new Field({
    name: "medianIncomeWomen",
    type: Number,
    key: false,
    label: {
      en: "Median Income Women",
      de: "Medianeinkommen Frauen"
    }
  }),
  new Field({
    name: "medianIncomeMen",
    type: Number,
    key: false,
    label: {
      en: "Median Income Men",
      de: "Medianeinkommen M\xE4nner"
    }
  }),
  new Field({
    name: "medianIncome25ToUnder55",
    type: Number,
    key: false,
    label: {
      en: "Median Income 25 to under 55",
      de: "Medianeinkommen 25 bis unter 55"
    }
  }),
  new Field({
    name: "medianIncome55ToUnder65",
    type: Number,
    key: false,
    label: {
      en: "Median Income 55 to under 65",
      de: "Medianeinkommen 55 bis unter 65"
    }
  }),
  new Field({
    name: "medianIncomeWithVocationalQualification",
    type: Number,
    key: false,
    label: {
      en: "Median Income with Vocational Qualification",
      de: "Medianeinkommen mit Berufsausbildung"
    }
  }),
  new Field({
    name: "medianIncomeWithAcademicQualification",
    type: Number,
    key: false,
    label: {
      en: "Median Income with Academic Qualification",
      de: "Medianeinkommen mit akademischer Qualifikation"
    }
  }),
  new Field({
    name: "householdIncome",
    type: Number,
    key: false,
    label: {
      en: "Household Income",
      de: "Haushaltseinkommen"
    }
  }),
  new Field({
    name: "householdsWithLowIncome",
    type: Number,
    key: false,
    label: {
      en: "Households with Low Income",
      de: "Haushalte mit niedrigem Einkommen"
    }
  }),
  new Field({
    name: "householdsWithMiddleIncome",
    type: Number,
    key: false,
    label: {
      en: "Households with Middle Income",
      de: "Haushalte mit mittlerem Einkommen"
    }
  }),
  new Field({
    name: "householdsWithHighIncome",
    type: Number,
    key: false,
    label: {
      en: "Households with High Income",
      de: "Haushalte mit hohem Einkommen"
    }
  }),
  new Field({
    name: "purchasingPower",
    type: Number,
    key: false,
    label: {
      en: "Purchasing Power",
      de: "Kaufkraft"
    }
  }),
  new Field({
    name: "retailRelevantPurchasingPower",
    type: Number,
    key: false,
    label: {
      en: "Retail Relevant Purchasing Power",
      de: "Einzelhandelsrelevante Kaufkraft"
    }
  }),
  new Field({
    name: "consumerInsolvencyProceedings",
    type: Number,
    key: false,
    label: {
      en: "Consumer Insolvency Proceedings",
      de: "Verbraucherinsolvenzverfahren"
    }
  }),
  new Field({
    name: "consumerInsolvencyClaims",
    type: Number,
    key: false,
    label: {
      en: "Consumer Insolvency Claims",
      de: "Verbraucherinsolvenzforderungen"
    }
  }),
  new Field({
    name: "selfEmployedInInsolvenciesShare",
    type: Number,
    key: false,
    label: {
      en: "Share of Self-Employed in Insolvencies",
      de: "Anteil Selbstst\xE4ndige in Insolvenzen"
    }
  }),
  new Field({
    name: "debtorRate",
    type: Number,
    key: false,
    label: {
      en: "Debtor Rate",
      de: "Schuldnerquote"
    }
  }),
  new Field({
    name: "workVolume",
    type: Number,
    key: false,
    label: {
      en: "Work Volume",
      de: "Arbeitsvolumen"
    }
  })
];
_IncomeData.relationships = [];
var IncomeData = _IncomeData;

// src/model/conversation.ts
var MessageType = /* @__PURE__ */ ((MessageType2) => {
  MessageType2["botMessage"] = "botMessage";
  MessageType2["userMessage"] = "userMessage";
  return MessageType2;
})(MessageType || {});
var Message = class _Message {
  constructor(type, content, confirmation, resources, date = /* @__PURE__ */ new Date()) {
    this.type = type;
    this.date = date;
    this.content = content;
    this.confirmation = confirmation;
    this.resources = resources || [];
  }
  clone() {
    return new _Message(this.type, this.content, this.confirmation, this.resources, this.date);
  }
};
var _Conversation = class _Conversation extends Entity {
  constructor(props = {}) {
    super(props);
    this.user = props.user;
    this.messages = (props.messages || []).map((message) => new Message(message.type, message.content, message.confirmation, message.resources, message.date));
    this.topic = props.topic;
    this.created = props.created || /* @__PURE__ */ new Date();
    this.lastCity = props.lastCity;
    this.lastLocalGovernment = props.lastLocalGovernment;
    this.lastAddress = props.lastAddress;
  }
  clone() {
    const conversation = new _Conversation(this);
    return conversation;
  }
  memorySize() {
    const calculateSize = (value) => {
      if (value === null || value === void 0) return 0;
      if (typeof value === "string") return value.length * 2;
      if (typeof value === "number") return 8;
      if (typeof value === "boolean") return 4;
      if (value instanceof Date) return 8;
      if (Array.isArray(value)) {
        return value.reduce((acc, item) => acc + calculateSize(item), 0);
      }
      if (typeof value === "object") {
        return Object.values(value).reduce((acc, val) => acc + calculateSize(val), 0);
      }
      return 0;
    };
    let size = 0;
    if (this.user) size += calculateSize(this.user);
    if (this.topic) size += calculateSize(this.topic);
    if (this.created) size += calculateSize(this.created);
    if (this.lastCity) size += calculateSize(this.lastCity);
    if (this.lastLocalGovernment) size += calculateSize(this.lastLocalGovernment);
    if (this.lastAddress) size += calculateSize(this.lastAddress);
    if (this.messages) {
      size += this.messages.reduce((acc, message) => {
        return acc + calculateSize(message.content) + calculateSize(message.type) + calculateSize(message.date) + calculateSize(message.confirmation) + calculateSize(message.resources);
      }, 0);
    }
    return size;
  }
};
_Conversation.type = new EntityType({
  type: _Conversation,
  name: "Conversation",
  label: {
    en: "Conversation",
    de: "Konversation"
  }
});
_Conversation.fields = [new Field({
  name: "created",
  type: Date,
  key: false,
  label: {
    en: "Created",
    de: "Erstellt"
  }
}), new Field({
  name: "messages",
  type: JSON,
  key: false,
  label: {
    en: "Messages",
    de: "Nachrichten"
  }
}), new Field({
  name: "topic",
  type: String,
  key: false,
  label: {
    en: "Topic",
    de: "Thema"
  }
}), new Field({
  name: "lastCity",
  type: String,
  key: false,
  label: {
    en: "Last City",
    de: "Letzte Stadt"
  }
}), new Field({
  name: "lastLocalGovernment",
  type: String,
  key: false,
  label: {
    en: "Last Local Government",
    de: "Letzte Gemeinde"
  }
}), new Field({
  name: "lastAddress",
  type: JSON,
  key: false,
  label: {
    en: "Last Address",
    de: "Letzte Adresse"
  }
})];
_Conversation.relationships = [];
var Conversation = _Conversation;

// src/model/agentic.ts
var PublishingStatus = /* @__PURE__ */ ((PublishingStatus2) => {
  PublishingStatus2["DRAFT"] = "DRAFT";
  PublishingStatus2["PUBLISHED"] = "PUBLISHED";
  PublishingStatus2["ARCHIVED"] = "ARCHIVED";
  return PublishingStatus2;
})(PublishingStatus || {});
var _MarketplaceOffer = class _MarketplaceOffer extends Entity {
  constructor(props) {
    super(props);
    this.provider = props.provider || props._tenant;
    this.name = props.name;
    this.synopsis = props.synopsis;
    this.description = props.description;
    this.marketingContent = props.marketingContent;
    this.urlTermsAndConditions = props.urlTermsAndConditions;
    this.urlPrivacyPolicy = props.urlPrivacyPolicy;
    this.updated = new Date(props.updated) || /* @__PURE__ */ new Date();
    this.offered = props.offered || false;
    this.published = props.published || false;
    this.plans = props.plans || [];
    this.images = props.images || [];
  }
};
_MarketplaceOffer.type = new EntityType({
  type: _MarketplaceOffer,
  name: "MarketplaceOffer",
  label: {
    en: "Marketplace Offer",
    de: "Marktplatzangebot"
  }
});
_MarketplaceOffer.fields = [
  new Field({
    name: "provider",
    type: String,
    key: false,
    label: {
      en: "Provider",
      de: "Anbieter"
    }
  }),
  new Field({
    name: "name",
    type: String,
    key: false,
    label: {
      en: "Name",
      de: "Name"
    }
  }),
  new Field({
    name: "synopsis",
    type: String,
    key: false,
    label: {
      en: "Synopsis",
      de: "Synopsis"
    }
  }),
  new Field({
    name: "description",
    type: String,
    key: false,
    label: {
      en: "Description",
      de: "Beschreibung"
    }
  }),
  new Field({
    name: "marketingContent",
    type: String,
    key: false,
    label: {
      en: "Marketing Content",
      de: "Marketing-Inhalt"
    }
  }),
  new Field({
    name: "urlTermsAndConditions",
    type: String,
    key: false,
    label: {
      en: "Terms and Conditions URL",
      de: "URL der Allgemeinen Gesch\xE4ftsbedingungen"
    }
  }),
  new Field({
    name: "urlPrivacyPolicy",
    type: String,
    key: false,
    label: {
      en: "Privacy Policy URL",
      de: "URL der Datenschutzerkl\xE4rung"
    }
  }),
  new Field({
    name: "updated",
    type: Date,
    key: false,
    label: {
      en: "Updated",
      de: "Aktualisiert"
    }
  }),
  new Field({
    name: "offered",
    type: Boolean,
    key: false,
    label: {
      en: "Offered",
      de: "Angeboten"
    }
  }),
  new Field({
    name: "published",
    type: Boolean,
    key: false,
    label: {
      en: "Published",
      de: "Ver\xF6ffentlicht"
    }
  }),
  new Field({
    name: "plans",
    type: JSON,
    key: false,
    label: {
      en: "Plans",
      de: "Tarife"
    }
  }),
  new Field({
    name: "images",
    type: JSON,
    key: false,
    label: {
      en: "Images",
      de: "Bilder"
    }
  }),
  new Field({
    name: "updated",
    type: Date,
    key: false,
    label: {
      en: "Updated",
      de: "Aktualisiert"
    }
  }),
  new Field({
    name: "offered",
    type: Boolean,
    key: false,
    label: {
      en: "Offered",
      de: "Angeboten"
    }
  }),
  new Field({
    name: "published",
    type: Boolean,
    key: false,
    label: {
      en: "Published",
      de: "Ver\xF6ffentlicht"
    }
  }),
  new Field({
    name: "plans",
    type: JSON,
    key: false,
    label: {
      en: "Plans",
      de: "Tarife"
    }
  }),
  new Field({
    name: "images",
    type: JSON,
    key: false,
    label: {
      en: "Images",
      de: "Bilder"
    }
  })
];
_MarketplaceOffer.relationships = [];
var MarketplaceOffer = _MarketplaceOffer;
var _AgentToolset = class _AgentToolset extends MarketplaceOffer {
  constructor(props) {
    super(props);
    this.serverURL = props.serverURL;
  }
};
_AgentToolset.type = new EntityType({
  type: _AgentToolset,
  name: "AgentToolset",
  label: {
    en: "Agent Toolset",
    de: "Agent Toolset"
  }
});
_AgentToolset.fields = [
  ...MarketplaceOffer.fields,
  new Field({
    name: "serverURL",
    type: String,
    key: false,
    label: {
      en: "Server URL",
      de: "Dateien"
    }
  })
];
_AgentToolset.relationships = [];
var AgentToolset = _AgentToolset;
var _KnowledgeBase = class _KnowledgeBase extends MarketplaceOffer {
  constructor(props) {
    super(props);
    this.files = (props.files || []).map((f) => __spreadProps(__spreadValues({}, f), { updated: new Date(f.updated) }));
    this.links = props.links || [];
  }
  addFile(path) {
    if (this.files.find((f) => f.path === path)) {
      return;
    }
    this.updated = /* @__PURE__ */ new Date();
    this.files.push({ path, updated: /* @__PURE__ */ new Date(), processing: true });
  }
  removeFile(path) {
    this.updated = /* @__PURE__ */ new Date();
    this.files = this.files.filter((f) => f.path !== path);
  }
};
_KnowledgeBase.type = new EntityType({
  type: _KnowledgeBase,
  name: "KnowledgeBase",
  label: {
    en: "KnowledgeBase",
    de: "Wissensbasis"
  }
});
_KnowledgeBase.fields = [
  ...MarketplaceOffer.fields,
  new Field({
    name: "files",
    type: JSON,
    key: false,
    label: {
      en: "Files",
      de: "Dateien"
    }
  }),
  new Field({
    name: "links",
    type: JSON,
    key: false,
    label: {
      en: "Links",
      de: "Links"
    }
  })
];
_KnowledgeBase.relationships = [];
var KnowledgeBase = _KnowledgeBase;

// src/geometry.ts
var RADIUS = 6378137;
var rad = (coord) => coord * Math.PI / 180;
var ringArea = (points) => {
  let p1;
  let p2;
  let p3;
  let lowerIndex;
  let middleIndex;
  let upperIndex;
  let area = 0;
  if (points.length > 2) {
    for (let i = 0; i < points.length; i++) {
      if (i === points.length - 2) {
        lowerIndex = points.length - 2;
        middleIndex = points.length - 1;
        upperIndex = 0;
      } else if (i === points.length - 1) {
        lowerIndex = points.length - 1;
        middleIndex = 0;
        upperIndex = 1;
      } else {
        lowerIndex = i;
        middleIndex = i + 1;
        upperIndex = i + 2;
      }
      p1 = points[lowerIndex];
      p2 = points[middleIndex];
      p3 = points[upperIndex];
      area += (rad(p3.lat) - rad(p1.lat)) * Math.sin(rad(p2.lon));
    }
    area = area * RADIUS * RADIUS / 2;
  }
  return area;
};
var getGeoArea = (coords) => {
  let area = 0;
  if (coords && coords.length > 0) {
    area += Math.abs(ringArea(coords));
  }
  return area;
};
var getConvexPolygonArea = (vertices) => {
  var total = 0;
  for (var i = 0, l = vertices.length; i < l; i++) {
    var addX = vertices[i].x;
    var addY = vertices[i == vertices.length - 1 ? 0 : i + 1].y;
    var subX = vertices[i == vertices.length - 1 ? 0 : i + 1].x;
    var subY = vertices[i].y;
    total += addX * addY * 0.5;
    total -= subX * subY * 0.5;
  }
  return Math.abs(total);
};
var calculateBoundingBox = (shape) => {
  const boundingBox = {
    minLat: Number.MAX_SAFE_INTEGER,
    maxLat: Number.MIN_SAFE_INTEGER,
    minLon: Number.MAX_SAFE_INTEGER,
    maxLon: Number.MIN_SAFE_INTEGER
  };
  for (const position of shape) {
    boundingBox.minLat = Math.min(boundingBox.minLat, position.lat);
    boundingBox.maxLat = Math.max(boundingBox.maxLat, position.lat);
    boundingBox.minLon = Math.min(boundingBox.minLon, position.lon);
    boundingBox.maxLon = Math.max(boundingBox.maxLon, position.lon);
  }
  boundingBox.centerLat = 0.5 * (boundingBox.minLat + boundingBox.maxLat);
  boundingBox.centerLon = 0.5 * (boundingBox.minLon + boundingBox.maxLon);
  return boundingBox;
};
var outerBoundingBox = (boundedEntities) => {
  const boundingBox = {
    minLat: Number.MAX_SAFE_INTEGER,
    maxLat: Number.MIN_SAFE_INTEGER,
    minLon: Number.MAX_SAFE_INTEGER,
    maxLon: Number.MIN_SAFE_INTEGER
  };
  for (const boundedEntity of boundedEntities) {
    boundingBox.minLat = Math.min(boundingBox.minLat, boundedEntity.minLat);
    boundingBox.maxLat = Math.max(boundingBox.maxLat, boundedEntity.maxLat);
    boundingBox.minLon = Math.min(boundingBox.minLon, boundedEntity.minLon);
    boundingBox.maxLon = Math.max(boundingBox.maxLon, boundedEntity.maxLon);
  }
  boundingBox.centerLat = 0.5 * (boundingBox.minLat + boundingBox.maxLat);
  boundingBox.centerLon = 0.5 * (boundingBox.minLon + boundingBox.maxLon);
  return boundingBox;
};

// src/model/land.ts
var LandUse = /* @__PURE__ */ ((LandUse2) => {
  LandUse2["unknown"] = "unknown";
  LandUse2["greenfield"] = "greenfield";
  LandUse2["agriculture"] = "agriculture";
  LandUse2["brownfield"] = "brownfield";
  LandUse2["forest"] = "forest";
  LandUse2["water"] = "water";
  LandUse2["sportsAndEntertainment"] = "sportsAndEntertainment";
  LandUse2["residential"] = "residential";
  LandUse2["cemetary"] = "cemetary";
  LandUse2["industrialArea"] = "industrialArea";
  LandUse2["commercialArea"] = "commercialArea";
  LandUse2["natureReserve"] = "natureReserve";
  LandUse2["dump"] = "dump";
  LandUse2["way"] = "way";
  LandUse2["wood"] = "wood";
  LandUse2["watercourse"] = "watercourse";
  LandUse2["roadTraffic"] = "roadTraffic";
  LandUse2["mixedUse"] = "mixedUse";
  LandUse2["specialPurpose"] = "specialPurpose";
  LandUse2["square"] = "square";
  LandUse2["unvegetatedArea"] = "unvegetatedArea";
  LandUse2["moor"] = "moor";
  LandUse2["mining"] = "mining";
  LandUse2["trainTraffic"] = "trainTraffic";
  LandUse2["swamp"] = "swamp";
  LandUse2["shippingTraffic"] = "shippingTraffic";
  LandUse2["harborBasin"] = "harborBasin";
  LandUse2["airTraffic"] = "airTraffic";
  LandUse2["heath"] = "heath";
  LandUse2["sea"] = "sea";
  LandUse2["miningOperations"] = "miningOperations";
  return LandUse2;
})(LandUse || {});
var LandUseI18N = {
  en: {
    unknown: "Unknown",
    greenfield: "Greenfield",
    agriculture: "Agriculture",
    brownfield: "Brownfield",
    forest: "Forest",
    water: "Water",
    sportsAndEntertainment: "Sports and Entertainment",
    residential: "Residential",
    cemetary: "Cemetary",
    industrialArea: "Industrial Area",
    commercialArea: "Commercial Area",
    natureReserve: "Nature Reserve",
    dump: "Dump",
    way: "Way",
    wood: "Wood",
    watercourse: "Watercourse",
    roadTraffic: "Road Traffic",
    mixedUse: "Mixed Use",
    specialPurpose: "Special Purpose",
    square: "Square",
    unvegetatedArea: "Unvegetated Area",
    moor: "Moor",
    mining: "Mining",
    trainTraffic: "Train Traffic",
    swamp: "Swamp",
    shippingTraffic: "Shipping Traffic",
    harborBasin: "Harbor Basin",
    airTraffic: "Air Traffic",
    heath: "Heath",
    sea: "Sea",
    miningOperations: "Mining Operations"
  },
  de: {
    unknown: "Unbekannt",
    greenfield: "Gr\xFCnfl\xE4che",
    agriculture: "Landwirtschaft",
    brownfield: "Industriebrache",
    forest: "Wald",
    water: "Wasserfl\xE4che",
    sportsAndEntertainment: "Sport und Unterhaltung",
    residential: "Wohngebiet",
    cemetary: "Friedhof",
    industrialArea: "Industriegebiet",
    commercialArea: "Gewerbegebiet",
    natureReserve: "Naturschutzgebiet",
    dump: "M\xFCllhalde",
    way: "Weg",
    wood: "Geh\xF6lz",
    watercourse: "Flie\xDFgew\xE4sser",
    roadTraffic: "Stra\xDFenverkehr",
    mixedUse: "Mischnutzung",
    specialPurpose: "Sonderzweck",
    square: "Platz",
    unvegetatedArea: "Vegetationslose Fl\xE4che",
    moor: "Moor",
    mining: "Bergbau",
    trainTraffic: "Schienenverkehr",
    swamp: "Sumpf",
    shippingTraffic: "Schiffsverkehr",
    harborBasin: "Hafenbecken",
    airTraffic: "Flugverkehr",
    heath: "Heide",
    sea: "Meer",
    miningOperations: "Bergbaubetrieb"
  }
};
var SurfaceType = /* @__PURE__ */ ((SurfaceType2) => {
  SurfaceType2["unknown"] = "unknown";
  SurfaceType2["grass"] = "grass";
  return SurfaceType2;
})(SurfaceType || {});
var BarrierType = /* @__PURE__ */ ((BarrierType2) => {
  BarrierType2["unknown"] = "unknown";
  BarrierType2["fence"] = "fence";
  return BarrierType2;
})(BarrierType || {});
var ResidentialType = /* @__PURE__ */ ((ResidentialType2) => {
  ResidentialType2["unknown"] = "unknown";
  ResidentialType2["singleFamily"] = "singleFamily";
  return ResidentialType2;
})(ResidentialType || {});
var SportType = /* @__PURE__ */ ((SportType2) => {
  SportType2["unknown"] = "unknown";
  SportType2["soccer"] = "soccer";
  return SportType2;
})(SportType || {});
var _PlotOfLand = class _PlotOfLand extends Entity {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.description = props.description;
    this.shape = props.shape;
    this.area = props.area || getGeoArea(props.shape);
    this.minLat = 0;
    this.maxLat = 0;
    this.centerLat = 0;
    this.minLon = 0;
    this.maxLon = 0;
    this.centerLon = 0;
    this.calculateBoundingBox();
    this.landUse = props.landUse;
    this.website = props.website;
    this.barrierType = props.fenceType;
    this.surfaceType = props.surfaceType;
    this.sportType = props.sportType;
    this.residentialType = props.residentialType;
    this.address = props.address ? new Address(props.address) : void 0;
    this.operator = props.operator;
    this.contact = props.contact;
    this.plant = props.plant;
  }
  calculateBoundingBox() {
    this.minLat = Number.MAX_SAFE_INTEGER;
    this.maxLat = Number.MIN_SAFE_INTEGER;
    this.minLon = Number.MAX_SAFE_INTEGER;
    this.maxLon = Number.MIN_SAFE_INTEGER;
    for (const position of this.shape) {
      this.minLat = Math.min(this.minLat, position.lat);
      this.maxLat = Math.max(this.maxLat, position.lat);
      this.minLon = Math.min(this.minLon, position.lon);
      this.maxLon = Math.max(this.maxLon, position.lon);
    }
    this.centerLat = 0.5 * (this.minLat + this.maxLat);
    this.centerLon = 0.5 * (this.minLon + this.maxLon);
  }
};
_PlotOfLand.type = new EntityType({
  type: _PlotOfLand,
  name: "PlotOfLand",
  label: {
    en: "Plot of Land",
    de: "Grundst\xFCck"
  }
});
_PlotOfLand.fields = [new Field({
  name: "name",
  type: String,
  key: false
}), new Field({
  name: "description",
  type: String,
  key: false
}), new Field({
  name: "shape",
  type: JSON,
  key: true
}), new Field({
  name: "minLon",
  type: Number,
  key: true
}), new Field({
  name: "maxLon",
  type: Number,
  key: true
}), new Field({
  name: "minLat",
  type: Number,
  key: true
}), new Field({
  name: "maxLat",
  type: Number,
  key: true
}), new Field({
  name: "centerLat",
  type: Number,
  key: true
}), new Field({
  name: "centerLon",
  type: Number,
  key: true
}), new Field({
  name: "landUse",
  type: LandUse,
  key: false
}), new Field({
  name: "website",
  type: String,
  key: false
}), new Field({
  name: "fenceType",
  type: BarrierType,
  key: false
}), new Field({
  name: "surfaceType",
  type: SurfaceType,
  key: false
}), new Field({
  name: "sportType",
  type: SportType,
  key: false
}), new Field({
  name: "residentialType",
  type: ResidentialType,
  key: false
}), new Field({
  name: "operator",
  type: String,
  key: false
}), new Field({
  name: "plant",
  type: JSON,
  key: false
}), new Field({
  name: "contact",
  type: JSON,
  key: false
})];
_PlotOfLand.relationships = [new Relationship({
  name: "address",
  type: Address,
  cardinality: "OneToOne" /* OneToOne */,
  directionality: "Unidirectional" /* Unidirectional */,
  label: {
    en: "Address",
    de: "Adresse"
  }
})];
var PlotOfLand = _PlotOfLand;
var _Parcel = class _Parcel extends Entity {
  constructor(props) {
    super(props);
    this.oid = props.oid;
    this.updated = props.updated;
    this.parcelID = props.parcelID;
    this.name = props.name;
    this.landUse = props.landUse;
    this.landUseDetails = props.landUseDetails;
    this.geometry = props.geometry;
    this.minLat = props.minLat;
    this.maxLat = props.maxLat;
    this.minLon = props.minLon;
    this.maxLon = props.maxLon;
  }
  getLandUseName(locale = "de") {
    return LandUseI18N[locale][this.landUse];
  }
  getFullName(locale = "de") {
    return `${LandUseI18N[locale][this.landUse]} ${this.name || ""}`;
  }
  memorySize() {
    let size = 0;
    if (this.name) size += this.name.length;
    if (this.parcelID) size += this.parcelID.length;
    if (this.landUseDetails) size += this.landUseDetails.length;
    if (this.oid) size += this.oid.length;
    if (this.geometry) {
      size += JSON.stringify(this.geometry).length;
    }
    return size;
  }
};
_Parcel.type = new EntityType({
  type: _Parcel,
  name: "Parcel",
  label: {
    en: "Parcel",
    de: "Flurst\xFCck"
  }
});
_Parcel.fields = [new Field({
  name: "oid",
  type: String,
  key: true
}), new Field({
  name: "updated",
  type: Date,
  key: true
}), new Field({
  name: "name",
  type: String,
  key: false
}), new Field({
  name: "parcelID",
  type: String,
  key: false
}), new Field({
  name: "landUse",
  type: LandUse,
  key: false
}), new Field({
  name: "landUseDetails",
  type: String,
  key: false
}), new Field({
  name: "geometry",
  type: JSON,
  key: true
}), new Field({
  name: "minLon",
  type: Number,
  key: true
}), new Field({
  name: "maxLon",
  type: Number,
  key: true
}), new Field({
  name: "minLat",
  type: Number,
  key: true
}), new Field({
  name: "maxLat",
  type: Number,
  key: true
})];
_Parcel.relationships = [];
var Parcel = _Parcel;

// src/model/ontology.ts
var objectClasses = [
  Address,
  Site,
  Building,
  Floor,
  Space,
  Lease,
  Unit,
  Subsidiary,
  NaturalPerson,
  LegalPerson,
  Partnership,
  LocalGovernment,
  PostalCode,
  Area,
  CellularCoverage,
  Document,
  DocumentDetails,
  Asset,
  Measurement,
  Gateway,
  Product,
  ProductApproval,
  PoI,
  University,
  School,
  Hotel,
  Restaurant,
  Hospital,
  ChildCareFacility,
  ChargingStation,
  Billboard,
  FireStation,
  PoliceStation,
  Pharmacy,
  AdvertisementColumn,
  PollutionData,
  Airport,
  FreewayMaintenanceOffice,
  ParkingLot,
  BusStop,
  TrainStation,
  Church,
  Hairdresser,
  Doctor,
  ParcelStation,
  CareFacility,
  BusinessRule,
  Checklist,
  Task,
  Role,
  RoleAssignment,
  Project,
  ProjectEntitlement,
  User,
  Customer,
  CustomerTheme,
  PVPlant,
  Battery,
  CHP,
  BioMassPlant,
  WindTurbine,
  HydroelectricPowerPlant,
  GasAndSteamPowerPlant,
  CrimeStatistics,
  SubjectOfStudy,
  StudentsNationalityGender,
  EmploymentData,
  BuildingAndHousingData,
  LandUseData,
  EnvironmentData,
  TrafficData,
  EconomicsData,
  PopulationData,
  PublicFinancesData,
  SubsidiesData,
  Conversation,
  Way,
  Bridge,
  PoliticsData,
  SocialSupplyData,
  SocialBenefitsData,
  IncomeData,
  KnowledgeBase,
  AgentToolset,
  Parcel,
  PlotOfLand
];
var getEntityType = (typeName) => {
  const entityType = objectClasses.find((type) => type.type.name === typeName);
  if (!entityType) {
    throw `Entity type ${typeName} is not registered.`;
  }
  return entityType;
};
var getRelationship = (typeName, relationshipName) => {
  const entityType = objectClasses.find((type) => type.type.name === typeName);
  if (!entityType) {
    throw `Entity type ${entityType} is not registered.`;
  }
  const relationship = entityType.relationships.find((relationship2) => relationship2.name === relationshipName);
  if (!relationship) {
    throw `Relationship ${relationshipName} does not exist on type ${entityType}.`;
  }
  return relationship;
};

// src/query.ts
var FieldValue = class _FieldValue {
  static unmarshal(fieldValue) {
    return new _FieldValue(fieldValue.name, fieldValue.value, fieldValue.operator || "equal" /* equal */, fieldValue.modifiers || []);
  }
  constructor(name, value, operator = "equal" /* equal */, modifiers = []) {
    this.name = name;
    this.value = value;
    this.operator = operator;
    this.modifiers = modifiers;
  }
  marshal() {
    return {
      name: this.name,
      value: this.value,
      operator: this.operator,
      modifiers: this.modifiers
    };
  }
};
var Filter = class _Filter {
  static unmarshal(filter) {
    switch (filter.type) {
      case "andFilter" /* andFilter */: {
        const andFilter = filter;
        return new AndFilter(andFilter.filters.map((filter2) => _Filter.unmarshal(filter2)));
      }
      case "orFilter" /* orFilter */: {
        const orFilter = filter;
        return new OrFilter(orFilter.filters.map((filter2) => _Filter.unmarshal(filter2)));
      }
      case "notFilter" /* notFilter */: {
        const notFilter = filter;
        return new NotFilter(_Filter.unmarshal(notFilter.filter));
      }
      case "comparison" /* comparison */:
      default: {
        const comparison = filter;
        return new Comparison(comparison.field, comparison.value, comparison.operator);
      }
    }
  }
  static latLonContainedInBoundingBoxFilter(lat, lon) {
    return new AndFilter([
      new Comparison("minLat", lat, "lessEqual" /* lessEqual */),
      new Comparison("maxLat", lat, "greaterEqual" /* greaterEqual */),
      new Comparison("minLon", lon, "lessEqual" /* lessEqual */),
      new Comparison("maxLon", lon, "greaterEqual" /* greaterEqual */)
    ]);
  }
  static locationContainedInBoundingBoxFilter(minLat, maxLat, minLon, maxLon) {
    return new AndFilter([
      new Comparison("lat", minLat, "greaterEqual" /* greaterEqual */),
      new Comparison("lat", maxLat, "lessEqual" /* lessEqual */),
      new Comparison("lon", minLon, "greaterEqual" /* greaterEqual */),
      new Comparison("lon", maxLon, "lessEqual" /* lessEqual */)
    ]);
  }
  static geoContainedInBoundingBoxFilter(minLat, maxLat, minLon, maxLon) {
    return new AndFilter([
      new Comparison("minLat", minLat, "greaterEqual" /* greaterEqual */),
      new Comparison("maxLat", maxLat, "lessEqual" /* lessEqual */),
      new Comparison("minLon", minLon, "greaterEqual" /* greaterEqual */),
      new Comparison("maxLon", maxLon, "lessEqual" /* lessEqual */)
    ]);
  }
  static geoContainsBoundingBoxFilter(minLat, maxLat, minLon, maxLon) {
    return new AndFilter([
      new Comparison("minLat", minLat, "lessEqual" /* lessEqual */),
      new Comparison("maxLat", maxLat, "greaterEqual" /* greaterEqual */),
      new Comparison("minLon", minLon, "lessEqual" /* lessEqual */),
      new Comparison("maxLon", maxLon, "greaterEqual" /* greaterEqual */)
    ]);
  }
  static geoBoundingBoxOverlapFilter(minLat, maxLat, minLon, maxLon) {
    return new AndFilter([
      new OrFilter([
        new AndFilter([
          new Comparison("minLat", minLat, "lessEqual" /* lessEqual */),
          new Comparison("maxLat", minLat, "greaterEqual" /* greaterEqual */)
        ]),
        new AndFilter([
          new Comparison("minLat", maxLat, "lessEqual" /* lessEqual */),
          new Comparison("maxLat", maxLat, "greaterEqual" /* greaterEqual */)
        ])
      ]),
      new OrFilter([
        new AndFilter([
          new Comparison("minLon", minLon, "lessEqual" /* lessEqual */),
          new Comparison("maxLon", minLon, "greaterEqual" /* greaterEqual */)
        ]),
        new AndFilter([
          new Comparison("minLon", maxLon, "lessEqual" /* lessEqual */),
          new Comparison("maxLon", maxLon, "greaterEqual" /* greaterEqual */)
        ])
      ])
    ]);
  }
  static getContainsPointFilter(lat, lon, radius) {
    const ky = 4e4 / 360;
    const kx = Math.cos(Math.PI * lat / 180) * ky;
    return new AndFilter([
      new Comparison("lat", lat - radius / 1e3 / ky, "greaterEqual" /* greaterEqual */),
      new Comparison("lat", lat + radius / 1e3 / ky, "lessEqual" /* lessEqual */),
      new Comparison("lon", lon - radius / 1e3 / kx, "greaterEqual" /* greaterEqual */),
      new Comparison("lon", lon + radius / 1e3 / kx, "lessEqual" /* lessEqual */)
    ]);
  }
  constructor(type) {
    this.type = type;
  }
  marshal() {
    return this;
  }
};
var Comparison = class extends Filter {
  constructor(field, value, operator = "equal" /* equal */, modifiers = []) {
    super("comparison" /* comparison */);
    this.field = field;
    this.value = value;
    this.operator = operator;
    this.modifiers = modifiers;
  }
  toCypher(scope) {
    let cypher = `${scope}.${this.field}`;
    switch (this.operator) {
      case "less" /* less */:
        cypher += " < ";
        break;
      case "lessEqual" /* lessEqual */:
        cypher += " <= ";
        break;
      case "greater" /* greater */:
        cypher += " > ";
        break;
      case "greaterEqual" /* greaterEqual */:
        cypher += " >= ";
        break;
      case "notEqual" /* notEqual */:
        cypher += " != ";
        break;
      case "equalRegExp" /* equalRegExp */:
        cypher += " =~ ";
        break;
      case "startsWith" /* startsWith */:
        cypher += " STARTS WITH ";
        break;
      case "equal" /* equal */:
      default:
        cypher += " = ";
        break;
    }
    if (typeof this.value === "string" || this.value instanceof String) {
      cypher += `"${this.value}"`;
    } else {
      cypher += `${this.value}`;
    }
    return cypher;
  }
  toMongoDBFilter() {
    let filter = {};
    switch (this.operator) {
      case "less" /* less */: {
        filter[this.field] = { $lt: this.value };
        break;
      }
      case "lessEqual" /* lessEqual */: {
        filter[this.field] = { $lte: this.value };
        break;
      }
      case "greater" /* greater */: {
        filter[this.field] = { $gt: this.value };
        break;
      }
      case "greaterEqual" /* greaterEqual */: {
        filter[this.field] = { $gte: this.value };
        break;
      }
      case "notEqual" /* notEqual */: {
        filter[this.field] = { $ne: this.value };
        break;
      }
      case "equalRegExp" /* equalRegExp */: {
        filter[this.field] = { $regex: `${this.value}` };
        break;
      }
      case "startsWith" /* startsWith */: {
        filter[this.field] = { $regex: `^${this.value}` };
        break;
      }
      case "equal" /* equal */:
      default: {
        filter[this.field] = { $eq: this.value };
        break;
      }
    }
    return filter;
  }
};
var OrFilter = class extends Filter {
  constructor(filters) {
    super("orFilter" /* orFilter */);
    this.filters = filters;
  }
  toCypher(scope) {
    let cypher = "";
    this.filters.forEach((filter, index) => {
      if (index > 0) {
        cypher += " OR ";
      }
      cypher += `(${filter.toCypher(scope)})`;
    });
    return cypher;
  }
  toMongoDBFilter() {
    if (this.filters && this.filters.length > 0) {
      return { $or: this.filters.map((filter) => filter.toMongoDBFilter()) };
    } else {
      return {};
    }
  }
};
var AndFilter = class extends Filter {
  constructor(filters) {
    super("andFilter" /* andFilter */);
    this.filters = filters;
  }
  toCypher(scope) {
    let cypher = "";
    this.filters.forEach((filter, index) => {
      if (index > 0) {
        cypher += " AND ";
      }
      cypher += `(${filter.toCypher(scope)})`;
    });
    return cypher;
  }
  toMongoDBFilter() {
    if (this.filters && this.filters.length > 0) {
      return { $and: this.filters.map((filter) => filter.toMongoDBFilter()) };
    } else {
      return {};
    }
  }
};
var NotFilter = class extends Filter {
  constructor(filter) {
    super("notFilter" /* notFilter */);
    this.filter = filter;
  }
  toCypher(scope) {
    return `NOT(${this.filter.toCypher(scope)})`;
  }
  toMongoDBFilter() {
    return { $not: this.filter.toMongoDBFilter() };
  }
};
var ComparisonHelper = class {
  constructor(field) {
    this.field = field;
  }
  equal(value) {
    return new Comparison(this.field, value, "equal" /* equal */);
  }
  less(value) {
    return new Comparison(this.field, value, "less" /* less */);
  }
  lessEqual(value) {
    return new Comparison(this.field, value, "lessEqual" /* lessEqual */);
  }
  greater(value) {
    return new Comparison(this.field, value, "greater" /* greater */);
  }
  greaterEqual(value) {
    return new Comparison(this.field, value, "greaterEqual" /* greaterEqual */);
  }
  notEqual(value) {
    return new Comparison(this.field, value, "notEqual" /* notEqual */);
  }
  equalRegExp(value) {
    return new Comparison(this.field, value, "equalRegExp" /* equalRegExp */);
  }
  startsWith(value) {
    return new Comparison(this.field, value, "startsWith" /* startsWith */);
  }
};
var is = (field) => {
  return new ComparisonHelper(field);
};
var and = (...filters) => {
  return new AndFilter(filters);
};
var or = (...filters) => {
  return new OrFilter(filters);
};
var not = (filter) => {
  return new NotFilter(filter);
};
var EntityQuery = class _EntityQuery {
  static unmarshal(entityQuery) {
    return new _EntityQuery(
      getEntityType(entityQuery.type).type,
      entityQuery.fieldValues.map((fieldValue) => FieldValue.unmarshal(fieldValue)),
      entityQuery.name,
      entityQuery.filter ? Filter.unmarshal(entityQuery.filter) : void 0
    );
  }
  static from(type) {
    return new Query(new _EntityQuery(type, [], void 0));
  }
  constructor(type, fieldValues = [], name, filter) {
    this.type = type;
    this.fieldValues = fieldValues;
    this.name = name;
    this.filter = filter;
  }
  marshal() {
    return {
      type: this.type.name,
      fieldValues: this.fieldValues.map((fieldValue) => fieldValue.marshal()),
      name: this.name,
      filter: this.filter ? this.filter.marshal() : void 0
    };
  }
};
var from = (type) => {
  return EntityQuery.from(type);
};
var RelationshipDirection = /* @__PURE__ */ ((RelationshipDirection2) => {
  RelationshipDirection2["in"] = "in";
  RelationshipDirection2["out"] = "out";
  return RelationshipDirection2;
})(RelationshipDirection || {});
var LinkedEntityQuery = class _LinkedEntityQuery {
  static unmarshal(linkedEntityQuery) {
    return new _LinkedEntityQuery(
      linkedEntityQuery.relationship,
      linkedEntityQuery.direction,
      getEntityType(linkedEntityQuery.type).type,
      linkedEntityQuery.fieldValues || [],
      linkedEntityQuery.name,
      linkedEntityQuery.filter ? Filter.unmarshal(linkedEntityQuery.filter) : void 0
    );
  }
  constructor(relationship, direction = "in" /* in */, type, fieldValues = [], name, filter) {
    this.relationship = relationship;
    this.direction = direction;
    this.type = type;
    this.fieldValues = fieldValues;
    this.name = name;
    this.filter = filter;
  }
  marshal() {
    return {
      relationship: this.relationship,
      direction: this.direction,
      type: this.type ? this.type.name : null,
      fieldValues: this.fieldValues.map((fieldValue) => fieldValue.marshal()),
      name: this.name,
      filter: this.filter ? this.filter.marshal() : void 0
    };
  }
};
var FieldReference = class _FieldReference {
  static unmarshal(fieldReference) {
    return new _FieldReference(fieldReference.entity, fieldReference.field);
  }
  constructor(entity, field) {
    this.entity = entity;
    this.field = field;
  }
  marshal() {
    return {
      entity: this.entity,
      field: this.field
    };
  }
};
var Query = class _Query {
  static unmarshal(query) {
    if (!query.entityQuery) {
      throw "Entity query must be defined.";
    }
    return new _Query(
      EntityQuery.unmarshal(query.entityQuery),
      query.linkedEntityQueries.map((linkedEntityQuery) => LinkedEntityQuery.unmarshal(linkedEntityQuery)),
      query.fieldReferences.map((fieldReference) => FieldReference.unmarshal(fieldReference))
    );
  }
  static nextNeighborQuery(entity) {
    const entityClass = entity.constructor;
    const type = entityClass.type;
    const fields = entityClass.fields;
    const relationships = entityClass.relationships;
    const entityQuery = new EntityQuery(type, [new FieldValue("_id", entity._id)]);
    return new _Query(entityQuery, [new LinkedEntityQuery(null, "out" /* out */, null)], []);
  }
  where(filter) {
    this.entityQuery.filter = filter;
    return this;
  }
  constructor(entityQuery, linkedEntityQueries = [], fieldReferences = []) {
    this.entityQuery = entityQuery;
    this.linkedEntityQueries = linkedEntityQueries ? linkedEntityQueries.map((linkedEntityQuery) => new LinkedEntityQuery(linkedEntityQuery.relationship, linkedEntityQuery.direction || "in" /* in */, linkedEntityQuery.type, linkedEntityQuery.fieldValues, linkedEntityQuery.name)) : [];
    this.fieldReferences = fieldReferences ? fieldReferences.map((fieldReference) => new FieldReference(fieldReference.entity, fieldReference.field)) : [];
  }
  marshal() {
    return {
      entityQuery: this.entityQuery.marshal(),
      linkedEntityQueries: this.linkedEntityQueries.map((linkedEntityQuery) => linkedEntityQuery.marshal()),
      fieldReferences: this.fieldReferences.map((fieldReference) => fieldReference.marshal())
    };
  }
  link(role, direction, type) {
    this.linkedEntityQueries = this.linkedEntityQueries || [];
    this.linkedEntityQueries.push(new LinkedEntityQuery(role, direction, type));
    return this;
  }
};

// src/analytics.ts
var group = (data) => {
  return data.reduce((groups, sample) => {
    for (let i = 0; i < groups.length; ++i) {
      if (sample <= groups[i].limit) {
        ++groups[i].count;
      }
    }
    return groups;
  }, [
    { limit: 800, count: 0 },
    { limit: 5e3, count: 0 },
    { limit: 1e4, count: 0 },
    { limit: 2e4, count: 0 },
    { limit: 5e4, count: 0 },
    { limit: Number.MAX_VALUE, count: 0 }
  ]);
};
var sum = (data) => {
  return data.reduce((sum2, sample) => {
    sum2 += sample;
    return sum2;
  }, 0);
};

// src/mcp.ts
var import_client = require("@modelcontextprotocol/sdk/client/index.js");
var import_streamableHttp = require("@modelcontextprotocol/sdk/client/streamableHttp.js");
var import_types = require("@modelcontextprotocol/sdk/types.js");
var MCPClient = class {
  constructor(url) {
    this.transport = null;
    this.notificationsToolLastEventId = void 0;
    this.sessionId = void 0;
    this.notificationCount = 0;
    this.url = url || "http://localhost:3066";
    this.serverUrl = `${this.url}/mcp`;
    this.client = void 0;
  }
  connect() {
    return __async(this, null, function* () {
      if (this.client) {
        console.log("Already connected. Disconnect first.");
        return;
      }
      console.log(`Connecting to ${this.serverUrl}...`);
      try {
        this.client = new import_client.Client({
          name: "example-client",
          version: "1.0.0"
        });
        this.client.onerror = (error) => {
          console.error("\x1B[31mClient error:", error, "\x1B[0m");
        };
        this.transport = new import_streamableHttp.StreamableHTTPClientTransport(
          new URL(this.serverUrl),
          {
            sessionId: this.sessionId
          }
        );
        this.client.setNotificationHandler(import_types.LoggingMessageNotificationSchema, (notification) => {
          this.notificationCount++;
          console.log(`
Notification #${this.notificationCount}: ${notification.params.level} - ${notification.params.data}`);
          process.stdout.write("> ");
        });
        this.client.setNotificationHandler(import_types.ResourceListChangedNotificationSchema, (_) => __async(this, null, function* () {
          console.log(`
Resource list changed notification received!`);
          try {
            if (!this.client) {
              console.log("Client disconnected, cannot fetch resources");
              return;
            }
            const resourcesResult = yield this.client.request({
              method: "resources/list",
              params: {}
            }, import_types.ListResourcesResultSchema);
            console.log("Available resources count:", resourcesResult.resources.length);
          } catch (e) {
            console.log("Failed to list resources after change notification");
          }
          process.stdout.write("> ");
        }));
        yield this.client.connect(this.transport);
        this.sessionId = this.transport.sessionId;
        console.log("Transport created with session ID:", this.sessionId);
        console.log("Connected to MCP server");
      } catch (error) {
        console.error("Failed to connect:", error);
        this.client = void 0;
        this.transport = null;
      }
    });
  }
  disconnect() {
    return __async(this, null, function* () {
      if (!this.client || !this.transport) {
        console.log("Not connected.");
        return;
      }
      try {
        yield this.transport.close();
        console.log("Disconnected from MCP server");
        this.client = void 0;
        this.transport = null;
      } catch (error) {
        console.error("Error disconnecting:", error);
      }
    });
  }
  terminateSession() {
    return __async(this, null, function* () {
      if (!this.client || !this.transport) {
        console.log("Not connected.");
        return;
      }
      try {
        console.log("Terminating session with ID:", this.transport.sessionId);
        yield this.transport.terminateSession();
        console.log("Session terminated successfully");
        if (!this.transport.sessionId) {
          console.log("Session ID has been cleared");
          this.sessionId = void 0;
          yield this.transport.close();
          console.log("Transport closed after session termination");
          this.client = void 0;
          this.transport = null;
        } else {
          console.log("Server responded with 405 Method Not Allowed (session termination not supported)");
          console.log("Session ID is still active:", this.transport.sessionId);
        }
      } catch (error) {
        console.error("Error terminating session:", error);
      }
    });
  }
  reconnect() {
    return __async(this, null, function* () {
      if (this.client) {
        yield this.disconnect();
      }
      yield this.connect();
    });
  }
  listTools() {
    return __async(this, null, function* () {
      if (!this.client) {
        console.log("Not connected to server.");
        return [];
      }
      try {
        const toolsRequest = {
          method: "tools/list",
          params: {}
        };
        const toolsResult = yield this.client.request(toolsRequest, import_types.ListToolsResultSchema);
        if (toolsResult.tools.length === 0) {
          return [];
        } else {
          return toolsResult.tools;
        }
      } catch (error) {
        console.error(`Tools not supported by this server (${error})`);
        return [];
      }
    });
  }
  callTool(name, args) {
    return __async(this, null, function* () {
      if (!this.client) {
        console.log("Not connected to server.");
        return;
      }
      try {
        const request = {
          method: "tools/call",
          params: {
            name,
            arguments: args
          }
        };
        console.log(`Calling tool '${name}' with args:`, args);
        const onLastEventIdUpdate = (event) => {
          this.notificationsToolLastEventId = event;
        };
        const result = yield this.client.request(request, import_types.CallToolResultSchema, {
          resumptionToken: this.notificationsToolLastEventId,
          onresumptiontoken: onLastEventIdUpdate
        });
        const response = { output: "", resources: [] };
        result.content.forEach((item) => {
          if (item.type === "text") {
            response.output += item.text;
          } else if (item.type === "resource") {
            if (item.resource.blob) {
              response.resources.push(JSON.parse(Buffer.from(item.resource.blob, "base64").toString()));
            }
          } else {
            console.log(`  ${item.type} content:`, item);
          }
        });
        return response;
      } catch (error) {
        console.log(`Error calling tool ${name}: ${error}`);
        throw error;
      }
    });
  }
  listPlans() {
    return __async(this, null, function* () {
      const response = yield fetch(`${this.url}/real-gain/plans`);
      return response.json();
    });
  }
  getGeneralInfo() {
    return __async(this, null, function* () {
      const response = yield fetch(`${this.url}/real-gain/general-info`);
      return response.json();
    });
  }
};

// src/model/fileSystem.ts
var CloudVolume = class {
  constructor(entries) {
    this._folders = [];
    this._files = [];
    this.itemMap = {};
    entries.forEach((entry) => this.addEntry(entry));
  }
  addEntry(entry) {
    let parentPath;
    let path = "";
    const segments = entry.name.split("/");
    segments.forEach((segment, index) => {
      if (segment.trim().length === 0) {
        return;
      }
      path += `${index > 0 ? "/" : ""}${segment}`;
      if (!this.itemMap[path]) {
        if (index < segments.length - 1) {
          if (path.endsWith("/")) {
            path = path.slice(0, -1);
          }
          const folder = new CloudFolder(segment, path);
          this.itemMap[path] = folder;
          if (parentPath) {
            this.itemMap[parentPath]._folders.push(folder);
          } else {
            this._folders.push(folder);
          }
        } else {
          if (entry.name.endsWith("/")) {
            const folder = new CloudFolder(segment, entry.name.slice(0, -1));
            this.itemMap[path] = folder;
            if (parentPath) {
              this.itemMap[parentPath]._folders.push(folder);
            } else {
              this._folders.push(folder);
            }
          } else {
            const file = new CloudFile(segment, path, entry, entry.tags);
            this.itemMap[path] = file;
            if (parentPath) {
              this.itemMap[parentPath]._files.push(file);
            } else {
              this._files.push(file);
            }
          }
        }
      }
      parentPath = path;
    });
  }
  folders() {
    return this._folders;
  }
  folder(path) {
    const item = this.itemMap[path];
    if (!item) {
      throw new Error(`Folder ${path} does not exist.`);
    }
    if (!item.isFolder()) {
      throw new Error(`Item ${path} is not a folder.`);
    }
    return item;
  }
  file(path) {
    const item = this.itemMap[path];
    if (!item) {
      throw new Error(`Folder ${path} does not exist.`);
    }
    if (item.isFolder()) {
      throw new Error(`Item ${path} is not a file.`);
    }
    return item;
  }
  files() {
    return this._files;
  }
};
var CloudItem = class {
  constructor(name, path, tags = {}) {
    this._name = name;
    this._path = path;
    this.tags = tags;
  }
  name() {
    return this._name;
  }
  path() {
    return this._path;
  }
  getTag(key) {
    return this.tags[key];
  }
  setTag(key, value) {
    this.tags[key] = value;
  }
};
var CloudFolder = class extends CloudItem {
  constructor(name, path, tags = {}) {
    super(name, path, tags);
    this._files = [];
    this._folders = [];
  }
  files() {
    return this._files;
  }
  folders() {
    return this._folders;
  }
  isFolder() {
    return true;
  }
  folder(name) {
    const folder = this._folders.find((folder2) => folder2.name() === name);
    if (!folder) {
      throw new Error(`Folder ${name} does not exist.`);
    }
    return folder;
  }
};
var CloudFile = class extends CloudItem {
  constructor(name, path, entry, tags = {}) {
    super(name, path, tags);
    this.entry = entry;
  }
  isFolder() {
    return false;
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Action,
  ActionType,
  Address,
  AdvertisementColumn,
  AgentToolset,
  Airport,
  AndCondition,
  AndFilter,
  Area,
  AreaScale,
  Asset,
  AssetSchema,
  BarrierType,
  Battery,
  Billboard,
  Billing,
  BioMassPlant,
  Bridge,
  BridgeUsageType,
  Building,
  BuildingAndHousingData,
  BusStop,
  BusinessRule,
  BusinessRuleRuntimeStatus,
  CHP,
  Cardinality,
  CareFacility,
  CellularCoverage,
  ChargingStation,
  ChargingType,
  Checklist,
  ChildCareFacility,
  Church,
  CityObjectLoD2,
  CityObjectType,
  CloudFile,
  CloudFolder,
  CloudVolume,
  Comparison,
  ComparisonCondition,
  ComparisonOperator,
  ComparisonType,
  Condition,
  ConditionType,
  ConjunctionCondition,
  Conversation,
  CrimeStatistics,
  Customer,
  CustomerTheme,
  Device,
  Directionality,
  Doctor,
  Document,
  DocumentDetails,
  DocumentType,
  DocumentTypeI18N,
  EconomicsData,
  EmailNotification,
  EmploymentData,
  EnergyFacility,
  Entitlement,
  Entity,
  EntityQuery,
  EntityType,
  EnvironmentData,
  Field,
  FieldReference,
  FieldValue,
  Filter,
  FireStation,
  Floor,
  FloorCategory,
  FreewayMaintenanceOffice,
  GasAndSteamPowerPlant,
  Gateway,
  Hairdresser,
  Hospital,
  Hotel,
  HydroelectricPowerPlant,
  Image,
  ImageList,
  IncomeData,
  Invoice,
  InvoiceStatus,
  InvoiceType,
  InvoicingPeriod,
  KnowledgeBase,
  LandUse,
  LandUseData,
  LandUseI18N,
  Lease,
  LegalForm,
  LegalPerson,
  LinkedEntityQuery,
  LocalGovernment,
  LocalGovernmentType,
  LocalGovernmentTypeI18N,
  MCPClient,
  MIMEType,
  MarketplaceOffer,
  Measurement,
  MeasurementType,
  MeasurementTypeI18N,
  MeasurementUnit,
  Message,
  MessageType,
  MetadataLoD2,
  MeteringAlgorithm,
  NaturalPerson,
  OperatingState,
  OrCondition,
  OrFilter,
  Order,
  OrderItem,
  PVPlant,
  Parcel,
  ParcelStation,
  ParkingLot,
  Partnership,
  PasswordStatus,
  PaymentMode,
  Person,
  Pharmacy,
  Plan,
  PlotOfLand,
  PoI,
  PoIType,
  PoITypeI18N,
  PoliceStation,
  PoliticsData,
  PollutionData,
  PopulationData,
  PostalCode,
  ProcessDefinition,
  ProcessDefinitionType,
  Product,
  ProductApproval,
  Project,
  ProjectEntitlement,
  PublicFinancesData,
  PublishingStatus,
  Query,
  Relationship,
  RelationshipDirection,
  ResidentialType,
  Restaurant,
  Role,
  RoleAssignment,
  RoleType,
  RoofType,
  SMSNotification,
  School,
  ServiceType,
  Site,
  SocialBenefitsData,
  SocialSupplyData,
  Space,
  SpaceCategory,
  SportType,
  StudentsNationalityGender,
  StudyType,
  StudyTypeI18N,
  SubjectOfStudy,
  Subsidiary,
  SubsidiesData,
  SurfaceType,
  Task,
  TaskState,
  TrafficData,
  TrainStation,
  TransformLoD2,
  Unit,
  University,
  UniversityType,
  User,
  UserState,
  VerticesLoD2,
  Way,
  WayType,
  WayTypeI18N,
  WindTurbine,
  and,
  calculateBoundingBox,
  from,
  getConvexPolygonArea,
  getEntityType,
  getGeoArea,
  getRelationship,
  group,
  is,
  not,
  objectClasses,
  or,
  outerBoundingBox,
  sum
});
